export const hardcodeSeg = {
  0: [
    1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
    1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
    1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
    1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
    1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
    1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
    1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
    1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
    1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
    1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
    1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
    1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
  ],
  1: [
    1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
    1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1,
    1, 1, 1, 1, 1, 2, 1, 1, 3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 3,
    1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
    1, 1, 1, 1, 1, 1, 3, 1, 1, 1, 1, 3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 3, 1, 1,
    1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
    1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
    1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 2, 1, 1, 1,
    1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
    1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
    1, 1, 1, 1, 1, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 2, 3, 1,
  ],
  2: [
    1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 3, 1, 3, 1, 1, 1, 1, 1, 1, 1, 2, 1, 1,
    1, 1, 1, 1, 1, 1, 1, 1, 1, 3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 3,
    4, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 4, 1, 1, 1, 1, 1, 1, 1, 1, 1,
    1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 4, 1, 2, 4, 1, 1,
    1, 1, 1, 2, 1, 1, 4, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
    1, 1, 2, 1, 1, 2, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
    1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 5, 1,
    1, 1, 1, 1, 3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
    1, 1, 1, 1, 1, 1, 1, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
    1, 3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 7, 1,
  ],
  3: [
    1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 10, 1, 1, 1, 1, 1, 1, 3, 1, 1, 1, 1, 1, 1, 1,
    1, 6, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 8, 1, 1, 1, 1, 1, 1, 2, 1, 1,
    1, 7, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 4, 1, 1, 3, 2, 1, 1, 13,
    1, 1, 1, 1, 9, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 9,
    1, 1, 1, 1, 1, 1, 1, 4, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 5, 1,
    1, 1, 1, 1, 5, 7, 1, 1, 1, 1, 5, 1, 1, 1, 1, 1, 6, 1, 1, 1, 1, 1, 1, 1, 1,
    1, 1, 1, 1, 1, 3, 3, 1, 1, 1, 1, 3, 3, 1, 1, 1, 1, 3, 4, 1, 1, 1, 1, 1, 1,
    1, 2, 1, 1, 11, 1,
  ],
  4: [
    1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 10, 1, 1, 1, 1, 1, 4, 1, 1, 1, 1, 1, 1, 1, 7,
    1, 1, 1, 1, 1, 2, 1, 4, 9, 1, 1, 1, 2, 3, 1, 1, 8, 1, 1, 1, 1, 1, 1, 1, 1,
    1, 1, 1, 1, 1, 1, 1, 4, 1, 7, 14, 1, 1, 1, 10, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
    1, 1, 1, 1, 1, 1, 1, 1, 1, 9, 1, 1, 1, 1, 2, 5, 1, 1, 1, 1, 1, 1, 1, 4, 1,
    1, 1, 6, 1, 1, 1, 1, 1, 12, 1, 1, 7, 1, 1, 1, 8, 1, 1, 1, 1, 1, 1, 1, 1, 1,
    1, 1, 1, 1, 6, 1, 1, 1, 1, 6, 1, 2, 8, 1, 1, 1, 3, 3, 1, 12, 1,
  ],
  5: [
    1, 1, 1, 1, 1, 4, 11, 1, 1, 1, 1, 5, 1, 1, 1, 1, 1, 1, 8, 1, 1, 1, 1, 3, 1,
    13, 1, 1, 1, 5, 10, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 5, 1, 7, 14,
    1, 1, 1, 10, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 11, 1, 1, 1,
    8, 1, 1, 1, 1, 2, 5, 1, 1, 7, 1, 1, 1, 14, 1, 8, 1, 1, 1, 8, 1, 1, 1, 1, 1,
    1, 1, 1, 1, 1, 1, 8, 1, 1, 8, 1, 2, 8, 1, 1, 1, 6, 1, 12, 1,
  ],
  6: [
    1, 1, 1, 1, 1, 15, 1, 2, 6, 1, 1, 3, 9, 1, 1, 1, 4, 14, 1, 1, 1, 5, 10, 1,
    1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 6, 1, 7, 14, 1, 1, 11, 1, 1, 1, 1, 1, 1,
    1, 1, 1, 1, 1, 1, 1, 1, 1, 14, 1, 1, 8, 1, 2, 1, 7, 9, 1, 1, 1, 14, 1, 8, 1,
    1, 1, 8, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 18, 1, 2, 8, 1, 1, 20, 1,
  ],
  7: [
    1, 1, 1, 1, 16, 1, 8, 1, 1, 12, 1, 1, 19, 1, 1, 1, 5, 10, 1, 1, 1, 1, 1, 1,
    1, 1, 1, 1, 1, 1, 7, 1, 7, 14, 1, 1, 11, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
    1, 1, 15, 1, 9, 1, 2, 1, 7, 9, 1, 1, 1, 14, 1, 8, 1, 1, 1, 8, 1, 1, 1, 1, 1,
    1, 1, 1, 1, 1, 19, 1, 2, 8, 1, 1, 20, 1,
  ],
  8: [
    2, 18, 1, 8, 1, 1, 12, 1, 1, 19, 1, 1, 1, 5, 10, 1, 1, 1, 1, 1, 1, 1, 1, 1,
    1, 1, 1, 7, 1, 7, 14, 1, 1, 11, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 25,
    1, 2, 1, 7, 9, 1, 1, 1, 14, 1, 8, 1, 1, 1, 8, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
    19, 1, 2, 8, 1, 1, 20, 1,
  ],
  9: [
    2, 18, 1, 8, 1, 1, 12, 1, 1, 19, 1, 1, 1, 5, 10, 1, 1, 1, 1, 1, 3, 1, 1, 1,
    8, 1, 7, 14, 1, 1, 11, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 28, 1, 2, 1, 7, 9,
    1, 1, 1, 14, 1, 8, 1, 1, 1, 8, 1, 1, 1, 1, 1, 1, 1, 1, 1, 20, 1, 2, 8, 1, 1,
    20, 1,
  ],
  10: [
    2, 18, 1, 8, 1, 1, 12, 1, 1, 19, 1, 1, 1, 5, 10, 1, 2, 1, 6, 9, 1, 7, 14, 1,
    1, 11, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 28, 1, 2, 1, 7, 9, 1, 1, 1, 14, 1,
    8, 1, 1, 1, 8, 1, 1, 1, 1, 1, 1, 1, 22, 1, 2, 8, 1, 1, 20, 1,
  ],
  11: [
    2, 18, 1, 8, 1, 1, 12, 1, 1, 19, 1, 1, 1, 5, 10, 1, 2, 1, 6, 9, 1, 7, 14, 1,
    1, 11, 1, 1, 1, 1, 1, 1, 1, 1, 2, 29, 1, 2, 1, 7, 9, 1, 1, 1, 14, 1, 8, 1,
    1, 1, 8, 1, 1, 1, 1, 1, 1, 23, 1, 2, 8, 1, 1, 20, 1,
  ],
  12: [
    2, 18, 1, 8, 1, 1, 12, 1, 1, 19, 1, 1, 1, 5, 10, 1, 2, 1, 6, 9, 1, 7, 14, 1,
    1, 11, 1, 1, 1, 1, 1, 1, 1, 1, 31, 1, 2, 1, 7, 9, 1, 1, 1, 14, 1, 8, 1, 1,
    1, 8, 1, 1, 1, 3, 23, 1, 2, 8, 1, 1, 20, 1,
  ],
  13: [
    2, 18, 1, 8, 1, 1, 12, 1, 1, 19, 1, 1, 1, 5, 10, 1, 2, 1, 6, 9, 1, 7, 14, 1,
    1, 11, 1, 1, 1, 1, 1, 1, 1, 32, 1, 2, 1, 7, 9, 1, 1, 1, 14, 1, 8, 1, 1, 1,
    8, 1, 1, 1, 3, 23, 1, 2, 8, 1, 1, 20, 1,
  ],
  14: [
    2, 18, 1, 8, 1, 1, 12, 1, 1, 19, 1, 1, 1, 5, 10, 1, 2, 1, 6, 9, 1, 7, 14, 1,
    1, 11, 1, 1, 1, 1, 1, 1, 33, 1, 2, 1, 7, 9, 1, 1, 1, 14, 1, 8, 1, 1, 1, 8,
    1, 1, 1, 3, 23, 1, 2, 8, 1, 1, 20, 1,
  ],
  15: [
    2, 18, 1, 8, 1, 1, 12, 1, 1, 19, 1, 1, 1, 5, 10, 1, 2, 1, 6, 9, 1, 7, 14, 1,
    1, 11, 1, 1, 1, 1, 1, 1, 33, 1, 2, 1, 7, 9, 1, 1, 1, 14, 1, 8, 1, 1, 1, 8,
    1, 1, 1, 3, 23, 1, 2, 8, 1, 1, 20, 1,
  ],
  16: [
    2, 18, 1, 8, 1, 1, 12, 1, 1, 19, 1, 1, 1, 5, 10, 1, 2, 1, 6, 9, 1, 7, 14, 1,
    1, 11, 1, 1, 1, 1, 1, 34, 1, 2, 1, 7, 9, 1, 1, 1, 14, 1, 8, 1, 1, 1, 8, 1,
    1, 1, 3, 23, 1, 2, 8, 1, 1, 20, 1,
  ],
  17: [
    2, 18, 1, 8, 1, 1, 12, 1, 1, 19, 1, 1, 1, 5, 10, 1, 2, 1, 6, 9, 1, 7, 14, 1,
    1, 11, 1, 1, 1, 1, 35, 1, 2, 1, 7, 9, 1, 1, 1, 14, 1, 8, 1, 1, 1, 8, 1, 1,
    1, 3, 23, 1, 2, 8, 1, 1, 20, 1,
  ],
  18: [
    2, 18, 1, 8, 1, 1, 12, 1, 1, 19, 1, 1, 1, 5, 10, 1, 2, 1, 6, 9, 1, 7, 14, 1,
    1, 11, 1, 2, 36, 1, 2, 1, 7, 9, 1, 1, 1, 14, 1, 8, 1, 1, 1, 8, 1, 1, 1, 3,
    23, 1, 2, 8, 1, 1, 20, 1,
  ],
  19: [21, 23, 21, 18, 19, 22, 13, 39, 20, 26, 11, 29, 11, 22],
  20: [44, 21, 18, 19, 22, 13, 39, 20, 26, 11, 29, 11, 22],
  21: [65, 18, 19, 22, 13, 39, 20, 26, 11, 29, 11, 22],
  22: [83, 19, 22, 13, 39, 20, 26, 11, 29, 11, 22],
  23: [102, 22, 13, 39, 20, 26, 11, 29, 11, 22],
  24: [124, 13, 39, 20, 26, 11, 29, 11, 22],
  25: [137, 39, 20, 26, 11, 29, 11, 22],
  26: [176, 20, 26, 11, 29, 11, 22],
  27: [196, 26, 11, 29, 11, 22],
  28: [222, 11, 29, 11, 22],
  29: [233, 29, 11, 22],
  30: [262, 11, 22],
  31: [273, 22],
  32: [295],
  33: [295],
}

export const hardcodeNodes = [
  {
    pos: 'ROOT',
    word: '',
    children: [
      {
        pos: 'S',
        posInfo: {
          description:
            'simple declarative clause, i.e. one that is not introduced by a (possible empty) subordinating conjunction or a wh-word and that does not exhibit subject-verb inversion.',
          examples: [],
        },
        word: '',
        children: [
          {
            pos: 'NP',
            posInfo: { description: 'Noun Phrase. ', examples: [] },
            word: '',
            children: [
              {
                pos: 'JJ',
                posInfo: { group: 'Adjective', tag: 'Adjective', examples: [] },
                word: 'Text',
                token: {
                  index: 1,
                  word: 'Text',
                  originalText: 'Text',
                  characterOffsetBegin: 0,
                  characterOffsetEnd: 4,
                  before: '',
                  after: ' ',
                  pos: 'JJ',
                },
                children: [],
              },
              {
                pos: 'NN',
                posInfo: {
                  group: 'Noun, singular or mass',
                  tag: 'Noun, singular or mass',
                  examples: [],
                },
                word: 'selection',
                token: {
                  index: 2,
                  word: 'selection',
                  originalText: 'selection',
                  characterOffsetBegin: 5,
                  characterOffsetEnd: 14,
                  before: ' ',
                  after: ' ',
                  pos: 'NN',
                },
                children: [],
              },
            ],
          },
          {
            pos: 'VP',
            posInfo: { description: 'Vereb Phrase. ', examples: [] },
            word: '',
            children: [
              {
                pos: 'VBZ',
                posInfo: {
                  group: 'Verb, 3rd person singular present',
                  tag: 'Verb, 3rd person singular present',
                  examples: [],
                },
                word: 'is',
                token: {
                  index: 3,
                  word: 'is',
                  originalText: 'is',
                  characterOffsetBegin: 15,
                  characterOffsetEnd: 17,
                  before: ' ',
                  after: ' ',
                  pos: 'VBZ',
                },
                children: [],
              },
              {
                pos: 'ADVP',
                posInfo: { description: 'Adverb Phrase.', examples: [] },
                word: '',
                children: [
                  {
                    pos: 'RB',
                    posInfo: { group: 'Adverb', tag: 'Adverb', examples: [] },
                    word: 'typically',
                    token: {
                      index: 4,
                      word: 'typically',
                      originalText: 'typically',
                      characterOffsetBegin: 18,
                      characterOffsetEnd: 27,
                      before: ' ',
                      after: ' ',
                      pos: 'RB',
                    },
                    children: [],
                  },
                ],
              },
              {
                pos: 'VP',
                posInfo: { description: 'Vereb Phrase. ', examples: [] },
                word: '',
                children: [
                  {
                    pos: 'VBN',
                    posInfo: {
                      group: 'Verb, past participle',
                      tag: 'Verb, past participle',
                      examples: [],
                    },
                    word: 'considered',
                    token: {
                      index: 5,
                      word: 'considered',
                      originalText: 'considered',
                      characterOffsetBegin: 28,
                      characterOffsetEnd: 38,
                      before: ' ',
                      after: ' ',
                      pos: 'VBN',
                    },
                    children: [],
                  },
                  {
                    pos: 'NP',
                    posInfo: { description: 'Noun Phrase. ', examples: [] },
                    word: '',
                    children: [
                      {
                        pos: 'NP',
                        posInfo: { description: 'Noun Phrase. ', examples: [] },
                        word: '',
                        children: [
                          {
                            pos: 'DT',
                            posInfo: {
                              group: 'Determiner',
                              tag: 'Determiner',
                              examples: [],
                            },
                            word: 'a',
                            token: {
                              index: 6,
                              word: 'a',
                              originalText: 'a',
                              characterOffsetBegin: 39,
                              characterOffsetEnd: 40,
                              before: ' ',
                              after: ' ',
                              pos: 'DT',
                            },
                            children: [],
                          },
                          {
                            pos: 'NN',
                            posInfo: {
                              group: 'Noun, singular or mass',
                              tag: 'Noun, singular or mass',
                              examples: [],
                            },
                            word: 'target',
                            token: {
                              index: 7,
                              word: 'target',
                              originalText: 'target',
                              characterOffsetBegin: 41,
                              characterOffsetEnd: 47,
                              before: ' ',
                              after: ' ',
                              pos: 'NN',
                            },
                            children: [],
                          },
                          {
                            pos: 'NN',
                            posInfo: {
                              group: 'Noun, singular or mass',
                              tag: 'Noun, singular or mass',
                              examples: [],
                            },
                            word: 'acquisition',
                            token: {
                              index: 8,
                              word: 'acquisition',
                              originalText: 'acquisition',
                              characterOffsetBegin: 48,
                              characterOffsetEnd: 59,
                              before: ' ',
                              after: ' ',
                              pos: 'NN',
                            },
                            children: [],
                          },
                          {
                            pos: 'NN',
                            posInfo: {
                              group: 'Noun, singular or mass',
                              tag: 'Noun, singular or mass',
                              examples: [],
                            },
                            word: 'task',
                            token: {
                              index: 9,
                              word: 'task',
                              originalText: 'task',
                              characterOffsetBegin: 60,
                              characterOffsetEnd: 64,
                              before: ' ',
                              after: ' ',
                              pos: 'NN',
                            },
                            children: [],
                          },
                        ],
                      },
                      {
                        pos: 'SBAR',
                        posInfo: {
                          description:
                            'Clause introduced by a (possibly empty) subordinating conjunction.',
                          examples: [],
                        },
                        word: '',
                        children: [
                          {
                            pos: 'WHNP',
                            posInfo: {
                              description:
                                'Wh-noun Phrase. Introduces a clause with an NP gap. May be null (containing the 0 complementizer) or lexical, containing some wh-word, e.g. who, which book, whose daughter, none of which, or how many leopards.',
                              examples: [],
                            },
                            word: '',
                            children: [
                              {
                                pos: 'WDT',
                                posInfo: {
                                  group: 'Wh-determiner',
                                  tag: 'Wh-determiner',
                                  examples: [],
                                },
                                word: 'that',
                                token: {
                                  index: 10,
                                  word: 'that',
                                  originalText: 'that',
                                  characterOffsetBegin: 65,
                                  characterOffsetEnd: 69,
                                  before: ' ',
                                  after: ' ',
                                  pos: 'WDT',
                                },
                                children: [],
                              },
                            ],
                          },
                          {
                            pos: 'S',
                            posInfo: {
                              description:
                                'simple declarative clause, i.e. one that is not introduced by a (possible empty) subordinating conjunction or a wh-word and that does not exhibit subject-verb inversion.',
                              examples: [],
                            },
                            word: '',
                            children: [
                              {
                                pos: 'VP',
                                posInfo: {
                                  description: 'Vereb Phrase. ',
                                  examples: [],
                                },
                                word: '',
                                children: [
                                  {
                                    pos: 'VBZ',
                                    posInfo: {
                                      group:
                                        'Verb, 3rd person singular present',
                                      tag: 'Verb, 3rd person singular present',
                                      examples: [],
                                    },
                                    word: 'defines',
                                    token: {
                                      index: 11,
                                      word: 'defines',
                                      originalText: 'defines',
                                      characterOffsetBegin: 70,
                                      characterOffsetEnd: 77,
                                      before: ' ',
                                      after: ' ',
                                      pos: 'VBZ',
                                    },
                                    children: [],
                                  },
                                  {
                                    pos: 'NP',
                                    posInfo: {
                                      description: 'Noun Phrase. ',
                                      examples: [],
                                    },
                                    word: '',
                                    children: [
                                      {
                                        pos: 'NP',
                                        posInfo: {
                                          description: 'Noun Phrase. ',
                                          examples: [],
                                        },
                                        word: '',
                                        children: [
                                          {
                                            pos: 'DT',
                                            posInfo: {
                                              group: 'Determiner',
                                              tag: 'Determiner',
                                              examples: [],
                                            },
                                            word: 'a',
                                            token: {
                                              index: 12,
                                              word: 'a',
                                              originalText: 'a',
                                              characterOffsetBegin: 78,
                                              characterOffsetEnd: 79,
                                              before: ' ',
                                              after: ' ',
                                              pos: 'DT',
                                            },
                                            children: [],
                                          },
                                          {
                                            pos: 'NN',
                                            posInfo: {
                                              group: 'Noun, singular or mass',
                                              tag: 'Noun, singular or mass',
                                              examples: [],
                                            },
                                            word: 'range',
                                            token: {
                                              index: 13,
                                              word: 'range',
                                              originalText: 'range',
                                              characterOffsetBegin: 80,
                                              characterOffsetEnd: 85,
                                              before: ' ',
                                              after: ' ',
                                              pos: 'NN',
                                            },
                                            children: [],
                                          },
                                        ],
                                      },
                                      {
                                        pos: 'PP',
                                        posInfo: {
                                          description: 'Prepositional Phrase.',
                                          examples: [],
                                        },
                                        word: '',
                                        children: [
                                          {
                                            pos: 'IN',
                                            posInfo: {
                                              group:
                                                'Preposition or subordinating conjunction',
                                              tag: 'Preposition or subordinating conjunction',
                                              examples: [],
                                            },
                                            word: 'from',
                                            token: {
                                              index: 14,
                                              word: 'from',
                                              originalText: 'from',
                                              characterOffsetBegin: 86,
                                              characterOffsetEnd: 90,
                                              before: ' ',
                                              after: ' ',
                                              pos: 'IN',
                                            },
                                            children: [],
                                          },
                                          {
                                            pos: 'NP',
                                            posInfo: {
                                              description: 'Noun Phrase. ',
                                              examples: [],
                                            },
                                            word: '',
                                            children: [
                                              {
                                                pos: 'DT',
                                                posInfo: {
                                                  group: 'Determiner',
                                                  tag: 'Determiner',
                                                  examples: [],
                                                },
                                                word: 'the',
                                                token: {
                                                  index: 15,
                                                  word: 'the',
                                                  originalText: 'the',
                                                  characterOffsetBegin: 91,
                                                  characterOffsetEnd: 94,
                                                  before: ' ',
                                                  after: ' ',
                                                  pos: 'DT',
                                                },
                                                children: [],
                                              },
                                              {
                                                pos: 'NN',
                                                posInfo: {
                                                  group:
                                                    'Noun, singular or mass',
                                                  tag: 'Noun, singular or mass',
                                                  examples: [],
                                                },
                                                word: 'start',
                                                token: {
                                                  index: 16,
                                                  word: 'start',
                                                  originalText: 'start',
                                                  characterOffsetBegin: 95,
                                                  characterOffsetEnd: 100,
                                                  before: ' ',
                                                  after: ' ',
                                                  pos: 'NN',
                                                },
                                                children: [],
                                              },
                                            ],
                                          },
                                        ],
                                      },
                                    ],
                                  },
                                  {
                                    pos: 'PP',
                                    posInfo: {
                                      description: 'Prepositional Phrase.',
                                      examples: [],
                                    },
                                    word: '',
                                    children: [
                                      {
                                        pos: 'IN',
                                        posInfo: {
                                          group:
                                            'Preposition or subordinating conjunction',
                                          tag: 'Preposition or subordinating conjunction',
                                          examples: [],
                                        },
                                        word: 'to',
                                        token: {
                                          index: 17,
                                          word: 'to',
                                          originalText: 'to',
                                          characterOffsetBegin: 101,
                                          characterOffsetEnd: 103,
                                          before: ' ',
                                          after: ' ',
                                          pos: 'IN',
                                        },
                                        children: [],
                                      },
                                      {
                                        pos: 'NP',
                                        posInfo: {
                                          description: 'Noun Phrase. ',
                                          examples: [],
                                        },
                                        word: '',
                                        children: [
                                          {
                                            pos: 'DT',
                                            posInfo: {
                                              group: 'Determiner',
                                              tag: 'Determiner',
                                              examples: [],
                                            },
                                            word: 'the',
                                            token: {
                                              index: 18,
                                              word: 'the',
                                              originalText: 'the',
                                              characterOffsetBegin: 104,
                                              characterOffsetEnd: 107,
                                              before: ' ',
                                              after: ' ',
                                              pos: 'DT',
                                            },
                                            children: [],
                                          },
                                          {
                                            pos: 'NN',
                                            posInfo: {
                                              group: 'Noun, singular or mass',
                                              tag: 'Noun, singular or mass',
                                              examples: [],
                                            },
                                            word: 'end',
                                            token: {
                                              index: 19,
                                              word: 'end',
                                              originalText: 'end',
                                              characterOffsetBegin: 108,
                                              characterOffsetEnd: 111,
                                              before: ' ',
                                              after: ' ',
                                              pos: 'NN',
                                            },
                                            children: [],
                                          },
                                          {
                                            pos: 'NN',
                                            posInfo: {
                                              group: 'Noun, singular or mass',
                                              tag: 'Noun, singular or mass',
                                              examples: [],
                                            },
                                            word: 'position',
                                            token: {
                                              index: 20,
                                              word: 'position',
                                              originalText: 'position',
                                              characterOffsetBegin: 112,
                                              characterOffsetEnd: 120,
                                              before: ' ',
                                              after: '',
                                              pos: 'NN',
                                            },
                                            children: [],
                                          },
                                        ],
                                      },
                                    ],
                                  },
                                ],
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            pos: '.',
            word: '.',
            token: {
              index: 21,
              word: '.',
              originalText: '.',
              characterOffsetBegin: 120,
              characterOffsetEnd: 121,
              before: '',
              after: ' ',
              pos: '.',
            },
            children: [],
          },
        ],
      },
    ],
  },
  {
    pos: 'ROOT',
    word: '',
    children: [
      {
        pos: 'S',
        posInfo: {
          description:
            'simple declarative clause, i.e. one that is not introduced by a (possible empty) subordinating conjunction or a wh-word and that does not exhibit subject-verb inversion.',
          examples: [],
        },
        word: '',
        children: [
          {
            pos: 'S',
            posInfo: {
              description:
                'simple declarative clause, i.e. one that is not introduced by a (possible empty) subordinating conjunction or a wh-word and that does not exhibit subject-verb inversion.',
              examples: [],
            },
            word: '',
            children: [
              {
                pos: 'NP',
                posInfo: { description: 'Noun Phrase. ', examples: [] },
                word: '',
                children: [
                  {
                    pos: 'DT',
                    posInfo: {
                      group: 'Determiner',
                      tag: 'Determiner',
                      examples: [],
                    },
                    word: 'The',
                    token: {
                      index: 1,
                      word: 'The',
                      originalText: 'The',
                      characterOffsetBegin: 122,
                      characterOffsetEnd: 125,
                      before: ' ',
                      after: ' ',
                      pos: 'DT',
                    },
                    children: [],
                  },
                  {
                    pos: 'NNS',
                    posInfo: {
                      group: 'Noun, plural',
                      tag: 'Noun, plural',
                      examples: [],
                    },
                    word: 'positions',
                    token: {
                      index: 2,
                      word: 'positions',
                      originalText: 'positions',
                      characterOffsetBegin: 126,
                      characterOffsetEnd: 135,
                      before: ' ',
                      after: ' ',
                      pos: 'NNS',
                    },
                    children: [],
                  },
                ],
              },
              {
                pos: 'VP',
                posInfo: { description: 'Vereb Phrase. ', examples: [] },
                word: '',
                children: [
                  {
                    pos: 'VBP',
                    posInfo: {
                      group: 'Verb, non-3rd person singular present',
                      tag: 'Verb, non-3rd person singular present',
                      examples: [],
                    },
                    word: 'are',
                    token: {
                      index: 3,
                      word: 'are',
                      originalText: 'are',
                      characterOffsetBegin: 136,
                      characterOffsetEnd: 139,
                      before: ' ',
                      after: ' ',
                      pos: 'VBP',
                    },
                    children: [],
                  },
                  {
                    pos: 'VP',
                    posInfo: { description: 'Vereb Phrase. ', examples: [] },
                    word: '',
                    children: [
                      {
                        pos: 'VBN',
                        posInfo: {
                          group: 'Verb, past participle',
                          tag: 'Verb, past participle',
                          examples: [],
                        },
                        word: 'chosen',
                        token: {
                          index: 4,
                          word: 'chosen',
                          originalText: 'chosen',
                          characterOffsetBegin: 140,
                          characterOffsetEnd: 146,
                          before: ' ',
                          after: ' ',
                          pos: 'VBN',
                        },
                        children: [],
                      },
                      {
                        pos: 'PP',
                        posInfo: {
                          description: 'Prepositional Phrase.',
                          examples: [],
                        },
                        word: '',
                        children: [
                          {
                            pos: 'IN',
                            posInfo: {
                              group: 'Preposition or subordinating conjunction',
                              tag: 'Preposition or subordinating conjunction',
                              examples: [],
                            },
                            word: 'by',
                            token: {
                              index: 5,
                              word: 'by',
                              originalText: 'by',
                              characterOffsetBegin: 147,
                              characterOffsetEnd: 149,
                              before: ' ',
                              after: ' ',
                              pos: 'IN',
                            },
                            children: [],
                          },
                          {
                            pos: 'S',
                            posInfo: {
                              description:
                                'simple declarative clause, i.e. one that is not introduced by a (possible empty) subordinating conjunction or a wh-word and that does not exhibit subject-verb inversion.',
                              examples: [],
                            },
                            word: '',
                            children: [
                              {
                                pos: 'VP',
                                posInfo: {
                                  description: 'Vereb Phrase. ',
                                  examples: [],
                                },
                                word: '',
                                children: [
                                  {
                                    pos: 'VBG',
                                    posInfo: {
                                      group:
                                        'Verb, gerund or present participle',
                                      tag: 'Verb, gerund or present participle',
                                      examples: [],
                                    },
                                    word: 'moving',
                                    token: {
                                      index: 6,
                                      word: 'moving',
                                      originalText: 'moving',
                                      characterOffsetBegin: 150,
                                      characterOffsetEnd: 156,
                                      before: ' ',
                                      after: ' ',
                                      pos: 'VBG',
                                    },
                                    children: [],
                                  },
                                  {
                                    pos: 'NP',
                                    posInfo: {
                                      description: 'Noun Phrase. ',
                                      examples: [],
                                    },
                                    word: '',
                                    children: [
                                      {
                                        pos: 'DT',
                                        posInfo: {
                                          group: 'Determiner',
                                          tag: 'Determiner',
                                          examples: [],
                                        },
                                        word: 'a',
                                        token: {
                                          index: 7,
                                          word: 'a',
                                          originalText: 'a',
                                          characterOffsetBegin: 157,
                                          characterOffsetEnd: 158,
                                          before: ' ',
                                          after: ' ',
                                          pos: 'DT',
                                        },
                                        children: [],
                                      },
                                      {
                                        pos: 'NN',
                                        posInfo: {
                                          group: 'Noun, singular or mass',
                                          tag: 'Noun, singular or mass',
                                          examples: [],
                                        },
                                        word: 'cursor',
                                        token: {
                                          index: 8,
                                          word: 'cursor',
                                          originalText: 'cursor',
                                          characterOffsetBegin: 159,
                                          characterOffsetEnd: 165,
                                          before: ' ',
                                          after: '',
                                          pos: 'NN',
                                        },
                                        children: [],
                                      },
                                    ],
                                  },
                                ],
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            pos: ',',
            word: ',',
            token: {
              index: 9,
              word: ',',
              originalText: ',',
              characterOffsetBegin: 165,
              characterOffsetEnd: 166,
              before: '',
              after: ' ',
              pos: ',',
            },
            children: [],
          },
          {
            pos: 'CC',
            posInfo: {
              group: 'Coordinating conjunction',
              tag: 'Coordinating conjunction',
              examples: [],
            },
            word: 'and',
            token: {
              index: 10,
              word: 'and',
              originalText: 'and',
              characterOffsetBegin: 167,
              characterOffsetEnd: 170,
              before: ' ',
              after: ' ',
              pos: 'CC',
            },
            children: [],
          },
          {
            pos: 'S',
            posInfo: {
              description:
                'simple declarative clause, i.e. one that is not introduced by a (possible empty) subordinating conjunction or a wh-word and that does not exhibit subject-verb inversion.',
              examples: [],
            },
            word: '',
            children: [
              {
                pos: 'NP',
                posInfo: { description: 'Noun Phrase. ', examples: [] },
                word: '',
                children: [
                  {
                    pos: 'DT',
                    posInfo: {
                      group: 'Determiner',
                      tag: 'Determiner',
                      examples: [],
                    },
                    word: 'the',
                    token: {
                      index: 11,
                      word: 'the',
                      originalText: 'the',
                      characterOffsetBegin: 171,
                      characterOffsetEnd: 174,
                      before: ' ',
                      after: ' ',
                      pos: 'DT',
                    },
                    children: [],
                  },
                  {
                    pos: 'VBN',
                    posInfo: {
                      group: 'Verb, past participle',
                      tag: 'Verb, past participle',
                      examples: [],
                    },
                    word: 'selected',
                    token: {
                      index: 12,
                      word: 'selected',
                      originalText: 'selected',
                      characterOffsetBegin: 175,
                      characterOffsetEnd: 183,
                      before: ' ',
                      after: ' ',
                      pos: 'VBN',
                    },
                    children: [],
                  },
                  {
                    pos: 'NN',
                    posInfo: {
                      group: 'Noun, singular or mass',
                      tag: 'Noun, singular or mass',
                      examples: [],
                    },
                    word: 'text',
                    token: {
                      index: 13,
                      word: 'text',
                      originalText: 'text',
                      characterOffsetBegin: 184,
                      characterOffsetEnd: 188,
                      before: ' ',
                      after: ' ',
                      pos: 'NN',
                    },
                    children: [],
                  },
                ],
              },
              {
                pos: 'VP',
                posInfo: { description: 'Vereb Phrase. ', examples: [] },
                word: '',
                children: [
                  {
                    pos: 'VBZ',
                    posInfo: {
                      group: 'Verb, 3rd person singular present',
                      tag: 'Verb, 3rd person singular present',
                      examples: [],
                    },
                    word: 'is',
                    token: {
                      index: 14,
                      word: 'is',
                      originalText: 'is',
                      characterOffsetBegin: 189,
                      characterOffsetEnd: 191,
                      before: ' ',
                      after: ' ',
                      pos: 'VBZ',
                    },
                    children: [],
                  },
                  {
                    pos: 'VP',
                    posInfo: { description: 'Vereb Phrase. ', examples: [] },
                    word: '',
                    children: [
                      {
                        pos: 'VBN',
                        posInfo: {
                          group: 'Verb, past participle',
                          tag: 'Verb, past participle',
                          examples: [],
                        },
                        word: 'highlighted',
                        token: {
                          index: 15,
                          word: 'highlighted',
                          originalText: 'highlighted',
                          characterOffsetBegin: 192,
                          characterOffsetEnd: 203,
                          before: ' ',
                          after: ' ',
                          pos: 'VBN',
                        },
                        children: [],
                      },
                      {
                        pos: 'PP',
                        posInfo: {
                          description: 'Prepositional Phrase.',
                          examples: [],
                        },
                        word: '',
                        children: [
                          {
                            pos: 'IN',
                            posInfo: {
                              group: 'Preposition or subordinating conjunction',
                              tag: 'Preposition or subordinating conjunction',
                              examples: [],
                            },
                            word: 'by',
                            token: {
                              index: 16,
                              word: 'by',
                              originalText: 'by',
                              characterOffsetBegin: 204,
                              characterOffsetEnd: 206,
                              before: ' ',
                              after: ' ',
                              pos: 'IN',
                            },
                            children: [],
                          },
                          {
                            pos: 'NP',
                            posInfo: {
                              description: 'Noun Phrase. ',
                              examples: [],
                            },
                            word: '',
                            children: [
                              {
                                pos: 'NP',
                                posInfo: {
                                  description: 'Noun Phrase. ',
                                  examples: [],
                                },
                                word: '',
                                children: [
                                  {
                                    pos: 'DT',
                                    posInfo: {
                                      group: 'Determiner',
                                      tag: 'Determiner',
                                      examples: [],
                                    },
                                    word: 'a',
                                    token: {
                                      index: 17,
                                      word: 'a',
                                      originalText: 'a',
                                      characterOffsetBegin: 207,
                                      characterOffsetEnd: 208,
                                      before: ' ',
                                      after: ' ',
                                      pos: 'DT',
                                    },
                                    children: [],
                                  },
                                  {
                                    pos: 'NN',
                                    posInfo: {
                                      group: 'Noun, singular or mass',
                                      tag: 'Noun, singular or mass',
                                      examples: [],
                                    },
                                    word: 'caret',
                                    token: {
                                      index: 18,
                                      word: 'caret',
                                      originalText: 'caret',
                                      characterOffsetBegin: 209,
                                      characterOffsetEnd: 214,
                                      before: ' ',
                                      after: ' ',
                                      pos: 'NN',
                                    },
                                    children: [],
                                  },
                                ],
                              },
                              {
                                pos: 'VP',
                                posInfo: {
                                  description: 'Vereb Phrase. ',
                                  examples: [],
                                },
                                word: '',
                                children: [
                                  {
                                    pos: 'VBN',
                                    posInfo: {
                                      group: 'Verb, past participle',
                                      tag: 'Verb, past participle',
                                      examples: [],
                                    },
                                    word: 'controlled',
                                    token: {
                                      index: 19,
                                      word: 'controlled',
                                      originalText: 'controlled',
                                      characterOffsetBegin: 215,
                                      characterOffsetEnd: 225,
                                      before: ' ',
                                      after: ' ',
                                      pos: 'VBN',
                                    },
                                    children: [],
                                  },
                                  {
                                    pos: 'PP',
                                    posInfo: {
                                      description: 'Prepositional Phrase.',
                                      examples: [],
                                    },
                                    word: '',
                                    children: [
                                      {
                                        pos: 'IN',
                                        posInfo: {
                                          group:
                                            'Preposition or subordinating conjunction',
                                          tag: 'Preposition or subordinating conjunction',
                                          examples: [],
                                        },
                                        word: 'by',
                                        token: {
                                          index: 20,
                                          word: 'by',
                                          originalText: 'by',
                                          characterOffsetBegin: 226,
                                          characterOffsetEnd: 228,
                                          before: ' ',
                                          after: ' ',
                                          pos: 'IN',
                                        },
                                        children: [],
                                      },
                                      {
                                        pos: 'NP',
                                        posInfo: {
                                          description: 'Noun Phrase. ',
                                          examples: [],
                                        },
                                        word: '',
                                        children: [
                                          {
                                            pos: 'CD',
                                            posInfo: {
                                              group: 'Cardinal number',
                                              tag: 'Cardinal number',
                                              examples: [],
                                            },
                                            word: 'two',
                                            token: {
                                              index: 21,
                                              word: 'two',
                                              originalText: 'two',
                                              characterOffsetBegin: 229,
                                              characterOffsetEnd: 232,
                                              before: ' ',
                                              after: ' ',
                                              pos: 'CD',
                                            },
                                            children: [],
                                          },
                                          {
                                            pos: 'NNS',
                                            posInfo: {
                                              group: 'Noun, plural',
                                              tag: 'Noun, plural',
                                              examples: [],
                                            },
                                            word: 'handles',
                                            token: {
                                              index: 22,
                                              word: 'handles',
                                              originalText: 'handles',
                                              characterOffsetBegin: 233,
                                              characterOffsetEnd: 240,
                                              before: ' ',
                                              after: '',
                                              pos: 'NNS',
                                            },
                                            children: [],
                                          },
                                        ],
                                      },
                                    ],
                                  },
                                ],
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            pos: '.',
            word: '.',
            token: {
              index: 23,
              word: '.',
              originalText: '.',
              characterOffsetBegin: 240,
              characterOffsetEnd: 241,
              before: '',
              after: ' ',
              pos: '.',
            },
            children: [],
          },
        ],
      },
    ],
  },
  {
    pos: 'ROOT',
    word: '',
    children: [
      {
        pos: 'S',
        posInfo: {
          description:
            'simple declarative clause, i.e. one that is not introduced by a (possible empty) subordinating conjunction or a wh-word and that does not exhibit subject-verb inversion.',
          examples: [],
        },
        word: '',
        children: [
          {
            pos: 'NP',
            posInfo: { description: 'Noun Phrase. ', examples: [] },
            word: '',
            children: [
              {
                pos: 'PRP',
                posInfo: {
                  group: 'Personal pronoun',
                  tag: 'Personal pronoun',
                  examples: [],
                },
                word: 'It',
                token: {
                  index: 1,
                  word: 'It',
                  originalText: 'It',
                  characterOffsetBegin: 242,
                  characterOffsetEnd: 244,
                  before: ' ',
                  after: ' ',
                  pos: 'PRP',
                },
                children: [],
              },
            ],
          },
          {
            pos: 'VP',
            posInfo: { description: 'Vereb Phrase. ', examples: [] },
            word: '',
            children: [
              {
                pos: 'VBZ',
                posInfo: {
                  group: 'Verb, 3rd person singular present',
                  tag: 'Verb, 3rd person singular present',
                  examples: [],
                },
                word: 'works',
                token: {
                  index: 2,
                  word: 'works',
                  originalText: 'works',
                  characterOffsetBegin: 245,
                  characterOffsetEnd: 250,
                  before: ' ',
                  after: ' ',
                  pos: 'VBZ',
                },
                children: [],
              },
              {
                pos: 'ADVP',
                posInfo: { description: 'Adverb Phrase.', examples: [] },
                word: '',
                children: [
                  {
                    pos: 'RB',
                    posInfo: { group: 'Adverb', tag: 'Adverb', examples: [] },
                    word: 'well',
                    token: {
                      index: 3,
                      word: 'well',
                      originalText: 'well',
                      characterOffsetBegin: 251,
                      characterOffsetEnd: 255,
                      before: ' ',
                      after: ' ',
                      pos: 'RB',
                    },
                    children: [],
                  },
                  {
                    pos: 'PP',
                    posInfo: {
                      description: 'Prepositional Phrase.',
                      examples: [],
                    },
                    word: '',
                    children: [
                      {
                        pos: 'IN',
                        posInfo: {
                          group: 'Preposition or subordinating conjunction',
                          tag: 'Preposition or subordinating conjunction',
                          examples: [],
                        },
                        word: 'on',
                        token: {
                          index: 4,
                          word: 'on',
                          originalText: 'on',
                          characterOffsetBegin: 256,
                          characterOffsetEnd: 258,
                          before: ' ',
                          after: ' ',
                          pos: 'IN',
                        },
                        children: [],
                      },
                      {
                        pos: 'NP',
                        posInfo: { description: 'Noun Phrase. ', examples: [] },
                        word: '',
                        children: [
                          {
                            pos: 'DT',
                            posInfo: {
                              group: 'Determiner',
                              tag: 'Determiner',
                              examples: [],
                            },
                            word: 'the',
                            token: {
                              index: 5,
                              word: 'the',
                              originalText: 'the',
                              characterOffsetBegin: 259,
                              characterOffsetEnd: 262,
                              before: ' ',
                              after: ' ',
                              pos: 'DT',
                            },
                            children: [],
                          },
                          {
                            pos: 'NN',
                            posInfo: {
                              group: 'Noun, singular or mass',
                              tag: 'Noun, singular or mass',
                              examples: [],
                            },
                            word: 'desktop',
                            token: {
                              index: 6,
                              word: 'desktop',
                              originalText: 'desktop',
                              characterOffsetBegin: 263,
                              characterOffsetEnd: 270,
                              before: ' ',
                              after: ' ',
                              pos: 'NN',
                            },
                            children: [],
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                pos: 'SBAR',
                posInfo: {
                  description:
                    'Clause introduced by a (possibly empty) subordinating conjunction.',
                  examples: [],
                },
                word: '',
                children: [
                  {
                    pos: 'IN',
                    posInfo: {
                      group: 'Preposition or subordinating conjunction',
                      tag: 'Preposition or subordinating conjunction',
                      examples: [],
                    },
                    word: 'because',
                    token: {
                      index: 7,
                      word: 'because',
                      originalText: 'because',
                      characterOffsetBegin: 271,
                      characterOffsetEnd: 278,
                      before: ' ',
                      after: ' ',
                      pos: 'IN',
                    },
                    children: [],
                  },
                  {
                    pos: 'S',
                    posInfo: {
                      description:
                        'simple declarative clause, i.e. one that is not introduced by a (possible empty) subordinating conjunction or a wh-word and that does not exhibit subject-verb inversion.',
                      examples: [],
                    },
                    word: '',
                    children: [
                      {
                        pos: 'NP',
                        posInfo: { description: 'Noun Phrase. ', examples: [] },
                        word: '',
                        children: [
                          {
                            pos: 'DT',
                            posInfo: {
                              group: 'Determiner',
                              tag: 'Determiner',
                              examples: [],
                            },
                            word: 'the',
                            token: {
                              index: 8,
                              word: 'the',
                              originalText: 'the',
                              characterOffsetBegin: 279,
                              characterOffsetEnd: 282,
                              before: ' ',
                              after: ' ',
                              pos: 'DT',
                            },
                            children: [],
                          },
                          {
                            pos: 'NN',
                            posInfo: {
                              group: 'Noun, singular or mass',
                              tag: 'Noun, singular or mass',
                              examples: [],
                            },
                            word: 'mouse',
                            token: {
                              index: 9,
                              word: 'mouse',
                              originalText: 'mouse',
                              characterOffsetBegin: 283,
                              characterOffsetEnd: 288,
                              before: ' ',
                              after: ' ',
                              pos: 'NN',
                            },
                            children: [],
                          },
                          {
                            pos: 'CC',
                            posInfo: {
                              group: 'Coordinating conjunction',
                              tag: 'Coordinating conjunction',
                              examples: [],
                            },
                            word: 'and',
                            token: {
                              index: 10,
                              word: 'and',
                              originalText: 'and',
                              characterOffsetBegin: 289,
                              characterOffsetEnd: 292,
                              before: ' ',
                              after: ' ',
                              pos: 'CC',
                            },
                            children: [],
                          },
                          {
                            pos: 'NN',
                            posInfo: {
                              group: 'Noun, singular or mass',
                              tag: 'Noun, singular or mass',
                              examples: [],
                            },
                            word: 'keyboard',
                            token: {
                              index: 11,
                              word: 'keyboard',
                              originalText: 'keyboard',
                              characterOffsetBegin: 293,
                              characterOffsetEnd: 301,
                              before: ' ',
                              after: ' ',
                              pos: 'NN',
                            },
                            children: [],
                          },
                        ],
                      },
                      {
                        pos: 'VP',
                        posInfo: {
                          description: 'Vereb Phrase. ',
                          examples: [],
                        },
                        word: '',
                        children: [
                          {
                            pos: 'VBP',
                            posInfo: {
                              group: 'Verb, non-3rd person singular present',
                              tag: 'Verb, non-3rd person singular present',
                              examples: [],
                            },
                            word: 'allow',
                            token: {
                              index: 12,
                              word: 'allow',
                              originalText: 'allow',
                              characterOffsetBegin: 302,
                              characterOffsetEnd: 307,
                              before: ' ',
                              after: ' ',
                              pos: 'VBP',
                            },
                            children: [],
                          },
                          {
                            pos: 'PP',
                            posInfo: {
                              description: 'Prepositional Phrase.',
                              examples: [],
                            },
                            word: '',
                            children: [
                              {
                                pos: 'IN',
                                posInfo: {
                                  group:
                                    'Preposition or subordinating conjunction',
                                  tag: 'Preposition or subordinating conjunction',
                                  examples: [],
                                },
                                word: 'for',
                                token: {
                                  index: 13,
                                  word: 'for',
                                  originalText: 'for',
                                  characterOffsetBegin: 308,
                                  characterOffsetEnd: 311,
                                  before: ' ',
                                  after: ' ',
                                  pos: 'IN',
                                },
                                children: [],
                              },
                              {
                                pos: 'NP',
                                posInfo: {
                                  description: 'Noun Phrase. ',
                                  examples: [],
                                },
                                word: '',
                                children: [
                                  {
                                    pos: 'NP',
                                    posInfo: {
                                      description: 'Noun Phrase. ',
                                      examples: [],
                                    },
                                    word: '',
                                    children: [
                                      {
                                        pos: 'ADJP',
                                        posInfo: {
                                          description: 'Adjective Phrase.',
                                          examples: [],
                                        },
                                        word: '',
                                        children: [
                                          {
                                            pos: 'RB',
                                            posInfo: {
                                              group: 'Adverb',
                                              tag: 'Adverb',
                                              examples: [],
                                            },
                                            word: 'highly',
                                            token: {
                                              index: 14,
                                              word: 'highly',
                                              originalText: 'highly',
                                              characterOffsetBegin: 312,
                                              characterOffsetEnd: 318,
                                              before: ' ',
                                              after: ' ',
                                              pos: 'RB',
                                            },
                                            children: [],
                                          },
                                          {
                                            pos: 'JJ',
                                            posInfo: {
                                              group: 'Adjective',
                                              tag: 'Adjective',
                                              examples: [],
                                            },
                                            word: 'precise',
                                            token: {
                                              index: 15,
                                              word: 'precise',
                                              originalText: 'precise',
                                              characterOffsetBegin: 319,
                                              characterOffsetEnd: 326,
                                              before: ' ',
                                              after: ' ',
                                              pos: 'JJ',
                                            },
                                            children: [],
                                          },
                                        ],
                                      },
                                      {
                                        pos: 'NN',
                                        posInfo: {
                                          group: 'Noun, singular or mass',
                                          tag: 'Noun, singular or mass',
                                          examples: [],
                                        },
                                        word: 'control',
                                        token: {
                                          index: 16,
                                          word: 'control',
                                          originalText: 'control',
                                          characterOffsetBegin: 327,
                                          characterOffsetEnd: 334,
                                          before: ' ',
                                          after: ' ',
                                          pos: 'NN',
                                        },
                                        children: [],
                                      },
                                    ],
                                  },
                                  {
                                    pos: 'PP',
                                    posInfo: {
                                      description: 'Prepositional Phrase.',
                                      examples: [],
                                    },
                                    word: '',
                                    children: [
                                      {
                                        pos: 'IN',
                                        posInfo: {
                                          group:
                                            'Preposition or subordinating conjunction',
                                          tag: 'Preposition or subordinating conjunction',
                                          examples: [],
                                        },
                                        word: 'of',
                                        token: {
                                          index: 17,
                                          word: 'of',
                                          originalText: 'of',
                                          characterOffsetBegin: 335,
                                          characterOffsetEnd: 337,
                                          before: ' ',
                                          after: ' ',
                                          pos: 'IN',
                                        },
                                        children: [],
                                      },
                                      {
                                        pos: 'NP',
                                        posInfo: {
                                          description: 'Noun Phrase. ',
                                          examples: [],
                                        },
                                        word: '',
                                        children: [
                                          {
                                            pos: 'DT',
                                            posInfo: {
                                              group: 'Determiner',
                                              tag: 'Determiner',
                                              examples: [],
                                            },
                                            word: 'the',
                                            token: {
                                              index: 18,
                                              word: 'the',
                                              originalText: 'the',
                                              characterOffsetBegin: 338,
                                              characterOffsetEnd: 341,
                                              before: ' ',
                                              after: ' ',
                                              pos: 'DT',
                                            },
                                            children: [],
                                          },
                                          {
                                            pos: 'NN',
                                            posInfo: {
                                              group: 'Noun, singular or mass',
                                              tag: 'Noun, singular or mass',
                                              examples: [],
                                            },
                                            word: 'cursor',
                                            token: {
                                              index: 19,
                                              word: 'cursor',
                                              originalText: 'cursor',
                                              characterOffsetBegin: 342,
                                              characterOffsetEnd: 348,
                                              before: ' ',
                                              after: ' ',
                                              pos: 'NN',
                                            },
                                            children: [],
                                          },
                                          {
                                            pos: 'NN',
                                            posInfo: {
                                              group: 'Noun, singular or mass',
                                              tag: 'Noun, singular or mass',
                                              examples: [],
                                            },
                                            word: 'position',
                                            token: {
                                              index: 20,
                                              word: 'position',
                                              originalText: 'position',
                                              characterOffsetBegin: 349,
                                              characterOffsetEnd: 357,
                                              before: ' ',
                                              after: '',
                                              pos: 'NN',
                                            },
                                            children: [],
                                          },
                                        ],
                                      },
                                    ],
                                  },
                                ],
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            pos: '.',
            word: '.',
            token: {
              index: 21,
              word: '.',
              originalText: '.',
              characterOffsetBegin: 357,
              characterOffsetEnd: 358,
              before: '',
              after: ' ',
              pos: '.',
            },
            children: [],
          },
        ],
      },
    ],
  },
  {
    pos: 'ROOT',
    word: '',
    children: [
      {
        pos: 'S',
        posInfo: {
          description:
            'simple declarative clause, i.e. one that is not introduced by a (possible empty) subordinating conjunction or a wh-word and that does not exhibit subject-verb inversion.',
          examples: [],
        },
        word: '',
        children: [
          {
            pos: 'ADVP',
            posInfo: { description: 'Adverb Phrase.', examples: [] },
            word: '',
            children: [
              {
                pos: 'RB',
                posInfo: { group: 'Adverb', tag: 'Adverb', examples: [] },
                word: 'However',
                token: {
                  index: 1,
                  word: 'However',
                  originalText: 'However',
                  characterOffsetBegin: 359,
                  characterOffsetEnd: 366,
                  before: ' ',
                  after: '',
                  pos: 'RB',
                },
                children: [],
              },
            ],
          },
          {
            pos: ',',
            word: ',',
            token: {
              index: 2,
              word: ',',
              originalText: ',',
              characterOffsetBegin: 366,
              characterOffsetEnd: 367,
              before: '',
              after: ' ',
              pos: ',',
            },
            children: [],
          },
          {
            pos: 'NP',
            posInfo: { description: 'Noun Phrase. ', examples: [] },
            word: '',
            children: [
              {
                pos: 'NP',
                posInfo: { description: 'Noun Phrase. ', examples: [] },
                word: '',
                children: [
                  {
                    pos: 'NN',
                    posInfo: {
                      group: 'Noun, singular or mass',
                      tag: 'Noun, singular or mass',
                      examples: [],
                    },
                    word: 'target',
                    token: {
                      index: 3,
                      word: 'target',
                      originalText: 'target',
                      characterOffsetBegin: 368,
                      characterOffsetEnd: 374,
                      before: ' ',
                      after: ' ',
                      pos: 'NN',
                    },
                    children: [],
                  },
                  {
                    pos: 'NN',
                    posInfo: {
                      group: 'Noun, singular or mass',
                      tag: 'Noun, singular or mass',
                      examples: [],
                    },
                    word: 'selection',
                    token: {
                      index: 4,
                      word: 'selection',
                      originalText: 'selection',
                      characterOffsetBegin: 375,
                      characterOffsetEnd: 384,
                      before: ' ',
                      after: ' ',
                      pos: 'NN',
                    },
                    children: [],
                  },
                ],
              },
              {
                pos: 'PP',
                posInfo: { description: 'Prepositional Phrase.', examples: [] },
                word: '',
                children: [
                  {
                    pos: 'IN',
                    posInfo: {
                      group: 'Preposition or subordinating conjunction',
                      tag: 'Preposition or subordinating conjunction',
                      examples: [],
                    },
                    word: 'with',
                    token: {
                      index: 5,
                      word: 'with',
                      originalText: 'with',
                      characterOffsetBegin: 385,
                      characterOffsetEnd: 389,
                      before: ' ',
                      after: ' ',
                      pos: 'IN',
                    },
                    children: [],
                  },
                  {
                    pos: 'NP',
                    posInfo: { description: 'Noun Phrase. ', examples: [] },
                    word: '',
                    children: [
                      {
                        pos: 'JJ',
                        posInfo: {
                          group: 'Adjective',
                          tag: 'Adjective',
                          examples: [],
                        },
                        word: 'such',
                        token: {
                          index: 6,
                          word: 'such',
                          originalText: 'such',
                          characterOffsetBegin: 390,
                          characterOffsetEnd: 394,
                          before: ' ',
                          after: ' ',
                          pos: 'JJ',
                        },
                        children: [],
                      },
                      {
                        pos: 'NN',
                        posInfo: {
                          group: 'Noun, singular or mass',
                          tag: 'Noun, singular or mass',
                          examples: [],
                        },
                        word: 'precision',
                        token: {
                          index: 7,
                          word: 'precision',
                          originalText: 'precision',
                          characterOffsetBegin: 395,
                          characterOffsetEnd: 404,
                          before: ' ',
                          after: ' ',
                          pos: 'NN',
                        },
                        children: [],
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            pos: 'VP',
            posInfo: { description: 'Vereb Phrase. ', examples: [] },
            word: '',
            children: [
              {
                pos: 'VBZ',
                posInfo: {
                  group: 'Verb, 3rd person singular present',
                  tag: 'Verb, 3rd person singular present',
                  examples: [],
                },
                word: 'becomes',
                token: {
                  index: 8,
                  word: 'becomes',
                  originalText: 'becomes',
                  characterOffsetBegin: 405,
                  characterOffsetEnd: 412,
                  before: ' ',
                  after: ' ',
                  pos: 'VBZ',
                },
                children: [],
              },
              {
                pos: 'ADJP',
                posInfo: { description: 'Adjective Phrase.', examples: [] },
                word: '',
                children: [
                  {
                    pos: 'JJ',
                    posInfo: {
                      group: 'Adjective',
                      tag: 'Adjective',
                      examples: [],
                    },
                    word: 'tricky',
                    token: {
                      index: 9,
                      word: 'tricky',
                      originalText: 'tricky',
                      characterOffsetBegin: 413,
                      characterOffsetEnd: 419,
                      before: ' ',
                      after: ' ',
                      pos: 'JJ',
                    },
                    children: [],
                  },
                ],
              },
              {
                pos: 'SBAR',
                posInfo: {
                  description:
                    'Clause introduced by a (possibly empty) subordinating conjunction.',
                  examples: [],
                },
                word: '',
                children: [
                  {
                    pos: 'IN',
                    posInfo: {
                      group: 'Preposition or subordinating conjunction',
                      tag: 'Preposition or subordinating conjunction',
                      examples: [],
                    },
                    word: 'as',
                    token: {
                      index: 10,
                      word: 'as',
                      originalText: 'as',
                      characterOffsetBegin: 420,
                      characterOffsetEnd: 422,
                      before: ' ',
                      after: ' ',
                      pos: 'IN',
                    },
                    children: [],
                  },
                  {
                    pos: 'S',
                    posInfo: {
                      description:
                        'simple declarative clause, i.e. one that is not introduced by a (possible empty) subordinating conjunction or a wh-word and that does not exhibit subject-verb inversion.',
                      examples: [],
                    },
                    word: '',
                    children: [
                      {
                        pos: 'NP',
                        posInfo: { description: 'Noun Phrase. ', examples: [] },
                        word: '',
                        children: [
                          {
                            pos: 'PRP',
                            posInfo: {
                              group: 'Personal pronoun',
                              tag: 'Personal pronoun',
                              examples: [],
                            },
                            word: 'we',
                            token: {
                              index: 11,
                              word: 'we',
                              originalText: 'we',
                              characterOffsetBegin: 423,
                              characterOffsetEnd: 425,
                              before: ' ',
                              after: ' ',
                              pos: 'PRP',
                            },
                            children: [],
                          },
                        ],
                      },
                      {
                        pos: 'VP',
                        posInfo: {
                          description: 'Vereb Phrase. ',
                          examples: [],
                        },
                        word: '',
                        children: [
                          {
                            pos: 'VBP',
                            posInfo: {
                              group: 'Verb, non-3rd person singular present',
                              tag: 'Verb, non-3rd person singular present',
                              examples: [],
                            },
                            word: 'move',
                            token: {
                              index: 12,
                              word: 'move',
                              originalText: 'move',
                              characterOffsetBegin: 426,
                              characterOffsetEnd: 430,
                              before: ' ',
                              after: ' ',
                              pos: 'VBP',
                            },
                            children: [],
                          },
                          {
                            pos: 'PRT',
                            posInfo: {
                              description:
                                'Particle. Category for words that should be tagged RP. ',
                              examples: [],
                            },
                            word: '',
                            children: [
                              {
                                pos: 'RP',
                                posInfo: {
                                  group: 'Particle',
                                  tag: 'Particle',
                                  examples: [],
                                },
                                word: 'away',
                                token: {
                                  index: 13,
                                  word: 'away',
                                  originalText: 'away',
                                  characterOffsetBegin: 431,
                                  characterOffsetEnd: 435,
                                  before: ' ',
                                  after: ' ',
                                  pos: 'RP',
                                },
                                children: [],
                              },
                            ],
                          },
                          {
                            pos: 'PP',
                            posInfo: {
                              description: 'Prepositional Phrase.',
                              examples: [],
                            },
                            word: '',
                            children: [
                              {
                                pos: 'IN',
                                posInfo: {
                                  group:
                                    'Preposition or subordinating conjunction',
                                  tag: 'Preposition or subordinating conjunction',
                                  examples: [],
                                },
                                word: 'from',
                                token: {
                                  index: 14,
                                  word: 'from',
                                  originalText: 'from',
                                  characterOffsetBegin: 436,
                                  characterOffsetEnd: 440,
                                  before: ' ',
                                  after: ' ',
                                  pos: 'IN',
                                },
                                children: [],
                              },
                              {
                                pos: 'NP',
                                posInfo: {
                                  description: 'Noun Phrase. ',
                                  examples: [],
                                },
                                word: '',
                                children: [
                                  {
                                    pos: 'DT',
                                    posInfo: {
                                      group: 'Determiner',
                                      tag: 'Determiner',
                                      examples: [],
                                    },
                                    word: 'the',
                                    token: {
                                      index: 15,
                                      word: 'the',
                                      originalText: 'the',
                                      characterOffsetBegin: 441,
                                      characterOffsetEnd: 444,
                                      before: ' ',
                                      after: ' ',
                                      pos: 'DT',
                                    },
                                    children: [],
                                  },
                                  {
                                    pos: 'JJ',
                                    posInfo: {
                                      group: 'Adjective',
                                      tag: 'Adjective',
                                      examples: [],
                                    },
                                    word: 'desktop',
                                    token: {
                                      index: 16,
                                      word: 'desktop',
                                      originalText: 'desktop',
                                      characterOffsetBegin: 445,
                                      characterOffsetEnd: 452,
                                      before: ' ',
                                      after: ' ',
                                      pos: 'JJ',
                                    },
                                    children: [],
                                  },
                                  {
                                    pos: 'NN',
                                    posInfo: {
                                      group: 'Noun, singular or mass',
                                      tag: 'Noun, singular or mass',
                                      examples: [],
                                    },
                                    word: 'setup',
                                    token: {
                                      index: 17,
                                      word: 'setup',
                                      originalText: 'setup',
                                      characterOffsetBegin: 453,
                                      characterOffsetEnd: 458,
                                      before: ' ',
                                      after: '',
                                      pos: 'NN',
                                    },
                                    children: [],
                                  },
                                ],
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            pos: '.',
            word: '.',
            token: {
              index: 18,
              word: '.',
              originalText: '.',
              characterOffsetBegin: 458,
              characterOffsetEnd: 459,
              before: '',
              after: ' ',
              pos: '.',
            },
            children: [],
          },
        ],
      },
    ],
  },
  {
    pos: 'ROOT',
    word: '',
    children: [
      {
        pos: 'S',
        posInfo: {
          description:
            'simple declarative clause, i.e. one that is not introduced by a (possible empty) subordinating conjunction or a wh-word and that does not exhibit subject-verb inversion.',
          examples: [],
        },
        word: '',
        children: [
          {
            pos: 'PP',
            posInfo: { description: 'Prepositional Phrase.', examples: [] },
            word: '',
            children: [
              {
                pos: 'IN',
                posInfo: {
                  group: 'Preposition or subordinating conjunction',
                  tag: 'Preposition or subordinating conjunction',
                  examples: [],
                },
                word: 'On',
                token: {
                  index: 1,
                  word: 'On',
                  originalText: 'On',
                  characterOffsetBegin: 460,
                  characterOffsetEnd: 462,
                  before: ' ',
                  after: ' ',
                  pos: 'IN',
                },
                children: [],
              },
              {
                pos: 'NP',
                posInfo: { description: 'Noun Phrase. ', examples: [] },
                word: '',
                children: [
                  {
                    pos: 'NNS',
                    posInfo: {
                      group: 'Noun, plural',
                      tag: 'Noun, plural',
                      examples: [],
                    },
                    word: 'touchscreens',
                    token: {
                      index: 2,
                      word: 'touchscreens',
                      originalText: 'touchscreens',
                      characterOffsetBegin: 463,
                      characterOffsetEnd: 475,
                      before: ' ',
                      after: '',
                      pos: 'NNS',
                    },
                    children: [],
                  },
                ],
              },
            ],
          },
          {
            pos: ',',
            word: ',',
            token: {
              index: 3,
              word: ',',
              originalText: ',',
              characterOffsetBegin: 475,
              characterOffsetEnd: 476,
              before: '',
              after: ' ',
              pos: ',',
            },
            children: [],
          },
          {
            pos: 'NP',
            posInfo: { description: 'Noun Phrase. ', examples: [] },
            word: '',
            children: [
              {
                pos: 'DT',
                posInfo: {
                  group: 'Determiner',
                  tag: 'Determiner',
                  examples: [],
                },
                word: 'the',
                token: {
                  index: 4,
                  word: 'the',
                  originalText: 'the',
                  characterOffsetBegin: 477,
                  characterOffsetEnd: 480,
                  before: ' ',
                  after: ' ',
                  pos: 'DT',
                },
                children: [],
              },
              {
                pos: 'ADJP',
                posInfo: { description: 'Adjective Phrase.', examples: [] },
                word: '',
                children: [
                  {
                    pos: 'NN',
                    posInfo: {
                      group: 'Noun, singular or mass',
                      tag: 'Noun, singular or mass',
                      examples: [],
                    },
                    word: 'touch',
                    token: {
                      index: 5,
                      word: 'touch',
                      originalText: 'touch',
                      characterOffsetBegin: 481,
                      characterOffsetEnd: 486,
                      before: ' ',
                      after: '',
                      pos: 'NN',
                    },
                    children: [],
                  },
                  {
                    pos: 'HYPH',
                    word: '-',
                    token: {
                      index: 6,
                      word: '-',
                      originalText: '-',
                      characterOffsetBegin: 486,
                      characterOffsetEnd: 487,
                      before: '',
                      after: '',
                      pos: 'HYPH',
                    },
                    children: [],
                  },
                  {
                    pos: 'VBN',
                    posInfo: {
                      group: 'Verb, past participle',
                      tag: 'Verb, past participle',
                      examples: [],
                    },
                    word: 'based',
                    token: {
                      index: 7,
                      word: 'based',
                      originalText: 'based',
                      characterOffsetBegin: 487,
                      characterOffsetEnd: 492,
                      before: '',
                      after: ' ',
                      pos: 'VBN',
                    },
                    children: [],
                  },
                ],
              },
              {
                pos: 'NN',
                posInfo: {
                  group: 'Noun, singular or mass',
                  tag: 'Noun, singular or mass',
                  examples: [],
                },
                word: 'text',
                token: {
                  index: 8,
                  word: 'text',
                  originalText: 'text',
                  characterOffsetBegin: 493,
                  characterOffsetEnd: 497,
                  before: ' ',
                  after: ' ',
                  pos: 'NN',
                },
                children: [],
              },
              {
                pos: 'NN',
                posInfo: {
                  group: 'Noun, singular or mass',
                  tag: 'Noun, singular or mass',
                  examples: [],
                },
                word: 'selection',
                token: {
                  index: 9,
                  word: 'selection',
                  originalText: 'selection',
                  characterOffsetBegin: 498,
                  characterOffsetEnd: 507,
                  before: ' ',
                  after: ' ',
                  pos: 'NN',
                },
                children: [],
              },
            ],
          },
          {
            pos: 'VP',
            posInfo: { description: 'Vereb Phrase. ', examples: [] },
            word: '',
            children: [
              {
                pos: 'VBZ',
                posInfo: {
                  group: 'Verb, 3rd person singular present',
                  tag: 'Verb, 3rd person singular present',
                  examples: [],
                },
                word: 'is',
                token: {
                  index: 10,
                  word: 'is',
                  originalText: 'is',
                  characterOffsetBegin: 508,
                  characterOffsetEnd: 510,
                  before: ' ',
                  after: ' ',
                  pos: 'VBZ',
                },
                children: [],
              },
              {
                pos: 'VP',
                posInfo: { description: 'Vereb Phrase. ', examples: [] },
                word: '',
                children: [
                  {
                    pos: 'VBN',
                    posInfo: {
                      group: 'Verb, past participle',
                      tag: 'Verb, past participle',
                      examples: [],
                    },
                    word: 'known',
                    token: {
                      index: 11,
                      word: 'known',
                      originalText: 'known',
                      characterOffsetBegin: 511,
                      characterOffsetEnd: 516,
                      before: ' ',
                      after: ' ',
                      pos: 'VBN',
                    },
                    children: [],
                  },
                  {
                    pos: 'S',
                    posInfo: {
                      description:
                        'simple declarative clause, i.e. one that is not introduced by a (possible empty) subordinating conjunction or a wh-word and that does not exhibit subject-verb inversion.',
                      examples: [],
                    },
                    word: '',
                    children: [
                      {
                        pos: 'VP',
                        posInfo: {
                          description: 'Vereb Phrase. ',
                          examples: [],
                        },
                        word: '',
                        children: [
                          {
                            pos: 'TO',
                            posInfo: { group: 'to', tag: 'to', examples: [] },
                            word: 'to',
                            token: {
                              index: 12,
                              word: 'to',
                              originalText: 'to',
                              characterOffsetBegin: 517,
                              characterOffsetEnd: 519,
                              before: ' ',
                              after: ' ',
                              pos: 'TO',
                            },
                            children: [],
                          },
                          {
                            pos: 'VP',
                            posInfo: {
                              description: 'Vereb Phrase. ',
                              examples: [],
                            },
                            word: '',
                            children: [
                              {
                                pos: 'VB',
                                posInfo: {
                                  group: 'Verb, base form',
                                  tag: 'Verb, base form',
                                  examples: [],
                                },
                                word: 'be',
                                token: {
                                  index: 13,
                                  word: 'be',
                                  originalText: 'be',
                                  characterOffsetBegin: 520,
                                  characterOffsetEnd: 522,
                                  before: ' ',
                                  after: ' ',
                                  pos: 'VB',
                                },
                                children: [],
                              },
                              {
                                pos: 'ADJP',
                                posInfo: {
                                  description: 'Adjective Phrase.',
                                  examples: [],
                                },
                                word: '',
                                children: [
                                  {
                                    pos: 'JJ',
                                    posInfo: {
                                      group: 'Adjective',
                                      tag: 'Adjective',
                                      examples: [],
                                    },
                                    word: 'difficult',
                                    token: {
                                      index: 14,
                                      word: 'difficult',
                                      originalText: 'difficult',
                                      characterOffsetBegin: 523,
                                      characterOffsetEnd: 532,
                                      before: ' ',
                                      after: ' ',
                                      pos: 'JJ',
                                    },
                                    children: [],
                                  },
                                  {
                                    pos: 'S',
                                    posInfo: {
                                      description:
                                        'simple declarative clause, i.e. one that is not introduced by a (possible empty) subordinating conjunction or a wh-word and that does not exhibit subject-verb inversion.',
                                      examples: [],
                                    },
                                    word: '',
                                    children: [
                                      {
                                        pos: 'VP',
                                        posInfo: {
                                          description: 'Vereb Phrase. ',
                                          examples: [],
                                        },
                                        word: '',
                                        children: [
                                          {
                                            pos: 'TO',
                                            posInfo: {
                                              group: 'to',
                                              tag: 'to',
                                              examples: [],
                                            },
                                            word: 'to',
                                            token: {
                                              index: 15,
                                              word: 'to',
                                              originalText: 'to',
                                              characterOffsetBegin: 533,
                                              characterOffsetEnd: 535,
                                              before: ' ',
                                              after: ' ',
                                              pos: 'TO',
                                            },
                                            children: [],
                                          },
                                          {
                                            pos: 'VP',
                                            posInfo: {
                                              description: 'Vereb Phrase. ',
                                              examples: [],
                                            },
                                            word: '',
                                            children: [
                                              {
                                                pos: 'VB',
                                                posInfo: {
                                                  group: 'Verb, base form',
                                                  tag: 'Verb, base form',
                                                  examples: [],
                                                },
                                                word: 'perform',
                                                token: {
                                                  index: 16,
                                                  word: 'perform',
                                                  originalText: 'perform',
                                                  characterOffsetBegin: 536,
                                                  characterOffsetEnd: 543,
                                                  before: ' ',
                                                  after: ' ',
                                                  pos: 'VB',
                                                },
                                                children: [],
                                              },
                                              {
                                                pos: 'PP',
                                                posInfo: {
                                                  description:
                                                    'Prepositional Phrase.',
                                                  examples: [],
                                                },
                                                word: '',
                                                children: [
                                                  {
                                                    pos: 'IN',
                                                    posInfo: {
                                                      group:
                                                        'Preposition or subordinating conjunction',
                                                      tag: 'Preposition or subordinating conjunction',
                                                      examples: [],
                                                    },
                                                    word: 'for',
                                                    token: {
                                                      index: 17,
                                                      word: 'for',
                                                      originalText: 'for',
                                                      characterOffsetBegin: 544,
                                                      characterOffsetEnd: 547,
                                                      before: ' ',
                                                      after: ' ',
                                                      pos: 'IN',
                                                    },
                                                    children: [],
                                                  },
                                                  {
                                                    pos: 'NP',
                                                    posInfo: {
                                                      description:
                                                        'Noun Phrase. ',
                                                      examples: [],
                                                    },
                                                    word: '',
                                                    children: [
                                                      {
                                                        pos: 'NNS',
                                                        posInfo: {
                                                          group: 'Noun, plural',
                                                          tag: 'Noun, plural',
                                                          examples: [],
                                                        },
                                                        word: 'users',
                                                        token: {
                                                          index: 18,
                                                          word: 'users',
                                                          originalText: 'users',
                                                          characterOffsetBegin: 548,
                                                          characterOffsetEnd: 553,
                                                          before: ' ',
                                                          after: '',
                                                          pos: 'NNS',
                                                        },
                                                        children: [],
                                                      },
                                                    ],
                                                  },
                                                ],
                                              },
                                            ],
                                          },
                                        ],
                                      },
                                    ],
                                  },
                                ],
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            pos: '.',
            word: '.',
            token: {
              index: 19,
              word: '.',
              originalText: '.',
              characterOffsetBegin: 553,
              characterOffsetEnd: 554,
              before: '',
              after: ' ',
              pos: '.',
            },
            children: [],
          },
        ],
      },
    ],
  },
  {
    pos: 'ROOT',
    word: '',
    children: [
      {
        pos: 'S',
        posInfo: {
          description:
            'simple declarative clause, i.e. one that is not introduced by a (possible empty) subordinating conjunction or a wh-word and that does not exhibit subject-verb inversion.',
          examples: [],
        },
        word: '',
        children: [
          {
            pos: 'NP',
            posInfo: { description: 'Noun Phrase. ', examples: [] },
            word: '',
            children: [
              {
                pos: 'DT',
                posInfo: {
                  group: 'Determiner',
                  tag: 'Determiner',
                  examples: [],
                },
                word: 'The',
                token: {
                  index: 1,
                  word: 'The',
                  originalText: 'The',
                  characterOffsetBegin: 555,
                  characterOffsetEnd: 558,
                  before: ' ',
                  after: ' ',
                  pos: 'DT',
                },
                children: [],
              },
              {
                pos: 'ADJP',
                posInfo: { description: 'Adjective Phrase.', examples: [] },
                word: '',
                children: [
                  {
                    pos: 'RB',
                    posInfo: { group: 'Adverb', tag: 'Adverb', examples: [] },
                    word: 'well',
                    token: {
                      index: 2,
                      word: 'well',
                      originalText: 'well',
                      characterOffsetBegin: 559,
                      characterOffsetEnd: 563,
                      before: ' ',
                      after: '',
                      pos: 'RB',
                    },
                    children: [],
                  },
                  {
                    pos: 'HYPH',
                    word: '-',
                    token: {
                      index: 3,
                      word: '-',
                      originalText: '-',
                      characterOffsetBegin: 563,
                      characterOffsetEnd: 564,
                      before: '',
                      after: '',
                      pos: 'HYPH',
                    },
                    children: [],
                  },
                  {
                    pos: 'VBN',
                    posInfo: {
                      group: 'Verb, past participle',
                      tag: 'Verb, past participle',
                      examples: [],
                    },
                    word: 'known',
                    token: {
                      index: 4,
                      word: 'known',
                      originalText: 'known',
                      characterOffsetBegin: 564,
                      characterOffsetEnd: 569,
                      before: '',
                      after: ' ',
                      pos: 'VBN',
                    },
                    children: [],
                  },
                ],
              },
              {
                pos: 'NML',
                word: '',
                children: [
                  {
                    pos: 'NN',
                    posInfo: {
                      group: 'Noun, singular or mass',
                      tag: 'Noun, singular or mass',
                      examples: [],
                    },
                    word: 'fat',
                    token: {
                      index: 5,
                      word: 'fat',
                      originalText: 'fat',
                      characterOffsetBegin: 570,
                      characterOffsetEnd: 573,
                      before: ' ',
                      after: ' ',
                      pos: 'NN',
                    },
                    children: [],
                  },
                  {
                    pos: 'NN',
                    posInfo: {
                      group: 'Noun, singular or mass',
                      tag: 'Noun, singular or mass',
                      examples: [],
                    },
                    word: 'finger',
                    token: {
                      index: 6,
                      word: 'finger',
                      originalText: 'finger',
                      characterOffsetBegin: 574,
                      characterOffsetEnd: 580,
                      before: ' ',
                      after: ' ',
                      pos: 'NN',
                    },
                    children: [],
                  },
                ],
              },
              {
                pos: 'NN',
                posInfo: {
                  group: 'Noun, singular or mass',
                  tag: 'Noun, singular or mass',
                  examples: [],
                },
                word: 'problem',
                token: {
                  index: 7,
                  word: 'problem',
                  originalText: 'problem',
                  characterOffsetBegin: 581,
                  characterOffsetEnd: 588,
                  before: ' ',
                  after: ' ',
                  pos: 'NN',
                },
                children: [],
              },
            ],
          },
          {
            pos: 'VP',
            posInfo: { description: 'Vereb Phrase. ', examples: [] },
            word: '',
            children: [
              {
                pos: 'VBZ',
                posInfo: {
                  group: 'Verb, 3rd person singular present',
                  tag: 'Verb, 3rd person singular present',
                  examples: [],
                },
                word: 'causes',
                token: {
                  index: 8,
                  word: 'causes',
                  originalText: 'causes',
                  characterOffsetBegin: 589,
                  characterOffsetEnd: 595,
                  before: ' ',
                  after: ' ',
                  pos: 'VBZ',
                },
                children: [],
              },
              {
                pos: 'NP',
                posInfo: { description: 'Noun Phrase. ', examples: [] },
                word: '',
                children: [
                  {
                    pos: 'NP',
                    posInfo: { description: 'Noun Phrase. ', examples: [] },
                    word: '',
                    children: [
                      {
                        pos: 'NP',
                        posInfo: { description: 'Noun Phrase. ', examples: [] },
                        word: '',
                        children: [
                          {
                            pos: 'JJ',
                            posInfo: {
                              group: 'Adjective',
                              tag: 'Adjective',
                              examples: [],
                            },
                            word: 'inaccurate',
                            token: {
                              index: 9,
                              word: 'inaccurate',
                              originalText: 'inaccurate',
                              characterOffsetBegin: 596,
                              characterOffsetEnd: 606,
                              before: ' ',
                              after: ' ',
                              pos: 'JJ',
                            },
                            children: [],
                          },
                          {
                            pos: 'NN',
                            posInfo: {
                              group: 'Noun, singular or mass',
                              tag: 'Noun, singular or mass',
                              examples: [],
                            },
                            word: 'control',
                            token: {
                              index: 10,
                              word: 'control',
                              originalText: 'control',
                              characterOffsetBegin: 607,
                              characterOffsetEnd: 614,
                              before: ' ',
                              after: ' ',
                              pos: 'NN',
                            },
                            children: [],
                          },
                        ],
                      },
                      {
                        pos: 'PP',
                        posInfo: {
                          description: 'Prepositional Phrase.',
                          examples: [],
                        },
                        word: '',
                        children: [
                          {
                            pos: 'IN',
                            posInfo: {
                              group: 'Preposition or subordinating conjunction',
                              tag: 'Preposition or subordinating conjunction',
                              examples: [],
                            },
                            word: 'of',
                            token: {
                              index: 11,
                              word: 'of',
                              originalText: 'of',
                              characterOffsetBegin: 615,
                              characterOffsetEnd: 617,
                              before: ' ',
                              after: ' ',
                              pos: 'IN',
                            },
                            children: [],
                          },
                          {
                            pos: 'NP',
                            posInfo: {
                              description: 'Noun Phrase. ',
                              examples: [],
                            },
                            word: '',
                            children: [
                              {
                                pos: 'DT',
                                posInfo: {
                                  group: 'Determiner',
                                  tag: 'Determiner',
                                  examples: [],
                                },
                                word: 'the',
                                token: {
                                  index: 12,
                                  word: 'the',
                                  originalText: 'the',
                                  characterOffsetBegin: 618,
                                  characterOffsetEnd: 621,
                                  before: ' ',
                                  after: ' ',
                                  pos: 'DT',
                                },
                                children: [],
                              },
                              {
                                pos: 'NN',
                                posInfo: {
                                  group: 'Noun, singular or mass',
                                  tag: 'Noun, singular or mass',
                                  examples: [],
                                },
                                word: 'touch',
                                token: {
                                  index: 13,
                                  word: 'touch',
                                  originalText: 'touch',
                                  characterOffsetBegin: 622,
                                  characterOffsetEnd: 627,
                                  before: ' ',
                                  after: ' ',
                                  pos: 'NN',
                                },
                                children: [],
                              },
                              {
                                pos: 'NN',
                                posInfo: {
                                  group: 'Noun, singular or mass',
                                  tag: 'Noun, singular or mass',
                                  examples: [],
                                },
                                word: 'position',
                                token: {
                                  index: 14,
                                  word: 'position',
                                  originalText: 'position',
                                  characterOffsetBegin: 628,
                                  characterOffsetEnd: 636,
                                  before: ' ',
                                  after: ' ',
                                  pos: 'NN',
                                },
                                children: [],
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                  {
                    pos: 'CC',
                    posInfo: {
                      group: 'Coordinating conjunction',
                      tag: 'Coordinating conjunction',
                      examples: [],
                    },
                    word: 'and',
                    token: {
                      index: 15,
                      word: 'and',
                      originalText: 'and',
                      characterOffsetBegin: 637,
                      characterOffsetEnd: 640,
                      before: ' ',
                      after: ' ',
                      pos: 'CC',
                    },
                    children: [],
                  },
                  {
                    pos: 'NP',
                    posInfo: { description: 'Noun Phrase. ', examples: [] },
                    word: '',
                    children: [
                      {
                        pos: 'NP',
                        posInfo: { description: 'Noun Phrase. ', examples: [] },
                        word: '',
                        children: [
                          {
                            pos: 'JJ',
                            posInfo: {
                              group: 'Adjective',
                              tag: 'Adjective',
                              examples: [],
                            },
                            word: 'severe',
                            token: {
                              index: 16,
                              word: 'severe',
                              originalText: 'severe',
                              characterOffsetBegin: 641,
                              characterOffsetEnd: 647,
                              before: ' ',
                              after: ' ',
                              pos: 'JJ',
                            },
                            children: [],
                          },
                          {
                            pos: 'NN',
                            posInfo: {
                              group: 'Noun, singular or mass',
                              tag: 'Noun, singular or mass',
                              examples: [],
                            },
                            word: 'occlusion',
                            token: {
                              index: 17,
                              word: 'occlusion',
                              originalText: 'occlusion',
                              characterOffsetBegin: 648,
                              characterOffsetEnd: 657,
                              before: ' ',
                              after: ' ',
                              pos: 'NN',
                            },
                            children: [],
                          },
                        ],
                      },
                      {
                        pos: 'PP',
                        posInfo: {
                          description: 'Prepositional Phrase.',
                          examples: [],
                        },
                        word: '',
                        children: [
                          {
                            pos: 'IN',
                            posInfo: {
                              group: 'Preposition or subordinating conjunction',
                              tag: 'Preposition or subordinating conjunction',
                              examples: [],
                            },
                            word: 'of',
                            token: {
                              index: 18,
                              word: 'of',
                              originalText: 'of',
                              characterOffsetBegin: 658,
                              characterOffsetEnd: 660,
                              before: ' ',
                              after: ' ',
                              pos: 'IN',
                            },
                            children: [],
                          },
                          {
                            pos: 'NP',
                            posInfo: {
                              description: 'Noun Phrase. ',
                              examples: [],
                            },
                            word: '',
                            children: [
                              {
                                pos: 'DT',
                                posInfo: {
                                  group: 'Determiner',
                                  tag: 'Determiner',
                                  examples: [],
                                },
                                word: 'the',
                                token: {
                                  index: 19,
                                  word: 'the',
                                  originalText: 'the',
                                  characterOffsetBegin: 661,
                                  characterOffsetEnd: 664,
                                  before: ' ',
                                  after: ' ',
                                  pos: 'DT',
                                },
                                children: [],
                              },
                              {
                                pos: 'NN',
                                posInfo: {
                                  group: 'Noun, singular or mass',
                                  tag: 'Noun, singular or mass',
                                  examples: [],
                                },
                                word: 'target',
                                token: {
                                  index: 20,
                                  word: 'target',
                                  originalText: 'target',
                                  characterOffsetBegin: 665,
                                  characterOffsetEnd: 671,
                                  before: ' ',
                                  after: ' ',
                                  pos: 'NN',
                                },
                                children: [],
                              },
                              {
                                pos: 'NN',
                                posInfo: {
                                  group: 'Noun, singular or mass',
                                  tag: 'Noun, singular or mass',
                                  examples: [],
                                },
                                word: 'text',
                                token: {
                                  index: 21,
                                  word: 'text',
                                  originalText: 'text',
                                  characterOffsetBegin: 672,
                                  characterOffsetEnd: 676,
                                  before: ' ',
                                  after: '',
                                  pos: 'NN',
                                },
                                children: [],
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            pos: '.',
            word: '.',
            token: {
              index: 22,
              word: '.',
              originalText: '.',
              characterOffsetBegin: 676,
              characterOffsetEnd: 677,
              before: '',
              after: ' ',
              pos: '.',
            },
            children: [],
          },
        ],
      },
    ],
  },
  {
    pos: 'ROOT',
    word: '',
    children: [
      {
        pos: 'S',
        posInfo: {
          description:
            'simple declarative clause, i.e. one that is not introduced by a (possible empty) subordinating conjunction or a wh-word and that does not exhibit subject-verb inversion.',
          examples: [],
        },
        word: '',
        children: [
          {
            pos: 'NP',
            posInfo: { description: 'Noun Phrase. ', examples: [] },
            word: '',
            children: [
              {
                pos: 'NNS',
                posInfo: {
                  group: 'Noun, plural',
                  tag: 'Noun, plural',
                  examples: [],
                },
                word: 'Users',
                token: {
                  index: 1,
                  word: 'Users',
                  originalText: 'Users',
                  characterOffsetBegin: 678,
                  characterOffsetEnd: 683,
                  before: ' ',
                  after: ' ',
                  pos: 'NNS',
                },
                children: [],
              },
            ],
          },
          {
            pos: 'VP',
            posInfo: { description: 'Vereb Phrase. ', examples: [] },
            word: '',
            children: [
              {
                pos: 'VBP',
                posInfo: {
                  group: 'Verb, non-3rd person singular present',
                  tag: 'Verb, non-3rd person singular present',
                  examples: [],
                },
                word: 'have',
                token: {
                  index: 2,
                  word: 'have',
                  originalText: 'have',
                  characterOffsetBegin: 684,
                  characterOffsetEnd: 688,
                  before: ' ',
                  after: ' ',
                  pos: 'VBP',
                },
                children: [],
              },
              {
                pos: 'S',
                posInfo: {
                  description:
                    'simple declarative clause, i.e. one that is not introduced by a (possible empty) subordinating conjunction or a wh-word and that does not exhibit subject-verb inversion.',
                  examples: [],
                },
                word: '',
                children: [
                  {
                    pos: 'VP',
                    posInfo: { description: 'Vereb Phrase. ', examples: [] },
                    word: '',
                    children: [
                      {
                        pos: 'TO',
                        posInfo: { group: 'to', tag: 'to', examples: [] },
                        word: 'to',
                        token: {
                          index: 3,
                          word: 'to',
                          originalText: 'to',
                          characterOffsetBegin: 689,
                          characterOffsetEnd: 691,
                          before: ' ',
                          after: ' ',
                          pos: 'TO',
                        },
                        children: [],
                      },
                      {
                        pos: 'VP',
                        posInfo: {
                          description: 'Vereb Phrase. ',
                          examples: [],
                        },
                        word: '',
                        children: [
                          {
                            pos: 'VP',
                            posInfo: {
                              description: 'Vereb Phrase. ',
                              examples: [],
                            },
                            word: '',
                            children: [
                              {
                                pos: 'VB',
                                posInfo: {
                                  group: 'Verb, base form',
                                  tag: 'Verb, base form',
                                  examples: [],
                                },
                                word: 'stop',
                                token: {
                                  index: 4,
                                  word: 'stop',
                                  originalText: 'stop',
                                  characterOffsetBegin: 692,
                                  characterOffsetEnd: 696,
                                  before: ' ',
                                  after: ' ',
                                  pos: 'VB',
                                },
                                children: [],
                              },
                              {
                                pos: 'NP',
                                posInfo: {
                                  description: 'Noun Phrase. ',
                                  examples: [],
                                },
                                word: '',
                                children: [
                                  {
                                    pos: 'JJ',
                                    posInfo: {
                                      group: 'Adjective',
                                      tag: 'Adjective',
                                      examples: [],
                                    },
                                    word: 'other',
                                    token: {
                                      index: 5,
                                      word: 'other',
                                      originalText: 'other',
                                      characterOffsetBegin: 697,
                                      characterOffsetEnd: 702,
                                      before: ' ',
                                      after: ' ',
                                      pos: 'JJ',
                                    },
                                    children: [],
                                  },
                                  {
                                    pos: 'NNS',
                                    posInfo: {
                                      group: 'Noun, plural',
                                      tag: 'Noun, plural',
                                      examples: [],
                                    },
                                    word: 'tasks',
                                    token: {
                                      index: 6,
                                      word: 'tasks',
                                      originalText: 'tasks',
                                      characterOffsetBegin: 703,
                                      characterOffsetEnd: 708,
                                      before: ' ',
                                      after: ' ',
                                      pos: 'NNS',
                                    },
                                    children: [],
                                  },
                                ],
                              },
                            ],
                          },
                          {
                            pos: 'CC',
                            posInfo: {
                              group: 'Coordinating conjunction',
                              tag: 'Coordinating conjunction',
                              examples: [],
                            },
                            word: 'and',
                            token: {
                              index: 7,
                              word: 'and',
                              originalText: 'and',
                              characterOffsetBegin: 709,
                              characterOffsetEnd: 712,
                              before: ' ',
                              after: ' ',
                              pos: 'CC',
                            },
                            children: [],
                          },
                          {
                            pos: 'VP',
                            posInfo: {
                              description: 'Vereb Phrase. ',
                              examples: [],
                            },
                            word: '',
                            children: [
                              {
                                pos: 'VB',
                                posInfo: {
                                  group: 'Verb, base form',
                                  tag: 'Verb, base form',
                                  examples: [],
                                },
                                word: 'stare',
                                token: {
                                  index: 8,
                                  word: 'stare',
                                  originalText: 'stare',
                                  characterOffsetBegin: 713,
                                  characterOffsetEnd: 718,
                                  before: ' ',
                                  after: ' ',
                                  pos: 'VB',
                                },
                                children: [],
                              },
                              {
                                pos: 'PP',
                                posInfo: {
                                  description: 'Prepositional Phrase.',
                                  examples: [],
                                },
                                word: '',
                                children: [
                                  {
                                    pos: 'IN',
                                    posInfo: {
                                      group:
                                        'Preposition or subordinating conjunction',
                                      tag: 'Preposition or subordinating conjunction',
                                      examples: [],
                                    },
                                    word: 'at',
                                    token: {
                                      index: 9,
                                      word: 'at',
                                      originalText: 'at',
                                      characterOffsetBegin: 719,
                                      characterOffsetEnd: 721,
                                      before: ' ',
                                      after: ' ',
                                      pos: 'IN',
                                    },
                                    children: [],
                                  },
                                  {
                                    pos: 'NP',
                                    posInfo: {
                                      description: 'Noun Phrase. ',
                                      examples: [],
                                    },
                                    word: '',
                                    children: [
                                      {
                                        pos: 'DT',
                                        posInfo: {
                                          group: 'Determiner',
                                          tag: 'Determiner',
                                          examples: [],
                                        },
                                        word: 'a',
                                        token: {
                                          index: 10,
                                          word: 'a',
                                          originalText: 'a',
                                          characterOffsetBegin: 722,
                                          characterOffsetEnd: 723,
                                          before: ' ',
                                          after: ' ',
                                          pos: 'DT',
                                        },
                                        children: [],
                                      },
                                      {
                                        pos: 'JJ',
                                        posInfo: {
                                          group: 'Adjective',
                                          tag: 'Adjective',
                                          examples: [],
                                        },
                                        word: 'mobile',
                                        token: {
                                          index: 11,
                                          word: 'mobile',
                                          originalText: 'mobile',
                                          characterOffsetBegin: 724,
                                          characterOffsetEnd: 730,
                                          before: ' ',
                                          after: ' ',
                                          pos: 'JJ',
                                        },
                                        children: [],
                                      },
                                      {
                                        pos: 'NN',
                                        posInfo: {
                                          group: 'Noun, singular or mass',
                                          tag: 'Noun, singular or mass',
                                          examples: [],
                                        },
                                        word: 'phone',
                                        token: {
                                          index: 12,
                                          word: 'phone',
                                          originalText: 'phone',
                                          characterOffsetBegin: 731,
                                          characterOffsetEnd: 736,
                                          before: ' ',
                                          after: '',
                                          pos: 'NN',
                                        },
                                        children: [],
                                      },
                                    ],
                                  },
                                ],
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            pos: '.',
            word: '.',
            token: {
              index: 13,
              word: '.',
              originalText: '.',
              characterOffsetBegin: 736,
              characterOffsetEnd: 737,
              before: '',
              after: ' ',
              pos: '.',
            },
            children: [],
          },
        ],
      },
    ],
  },
  {
    pos: 'ROOT',
    word: '',
    children: [
      {
        pos: 'S',
        posInfo: {
          description:
            'simple declarative clause, i.e. one that is not introduced by a (possible empty) subordinating conjunction or a wh-word and that does not exhibit subject-verb inversion.',
          examples: [],
        },
        word: '',
        children: [
          {
            pos: 'NP',
            posInfo: { description: 'Noun Phrase. ', examples: [] },
            word: '',
            children: [
              {
                pos: 'JJ',
                posInfo: { group: 'Adjective', tag: 'Adjective', examples: [] },
                word: 'Many',
                token: {
                  index: 1,
                  word: 'Many',
                  originalText: 'Many',
                  characterOffsetBegin: 738,
                  characterOffsetEnd: 742,
                  before: ' ',
                  after: ' ',
                  pos: 'JJ',
                },
                children: [],
              },
              {
                pos: 'NNS',
                posInfo: {
                  group: 'Noun, plural',
                  tag: 'Noun, plural',
                  examples: [],
                },
                word: 'methods',
                token: {
                  index: 2,
                  word: 'methods',
                  originalText: 'methods',
                  characterOffsetBegin: 743,
                  characterOffsetEnd: 750,
                  before: ' ',
                  after: ' ',
                  pos: 'NNS',
                },
                children: [],
              },
            ],
          },
          {
            pos: 'VP',
            posInfo: { description: 'Vereb Phrase. ', examples: [] },
            word: '',
            children: [
              {
                pos: 'VBP',
                posInfo: {
                  group: 'Verb, non-3rd person singular present',
                  tag: 'Verb, non-3rd person singular present',
                  examples: [],
                },
                word: 'have',
                token: {
                  index: 3,
                  word: 'have',
                  originalText: 'have',
                  characterOffsetBegin: 751,
                  characterOffsetEnd: 755,
                  before: ' ',
                  after: ' ',
                  pos: 'VBP',
                },
                children: [],
              },
              {
                pos: 'VP',
                posInfo: { description: 'Vereb Phrase. ', examples: [] },
                word: '',
                children: [
                  {
                    pos: 'VBN',
                    posInfo: {
                      group: 'Verb, past participle',
                      tag: 'Verb, past participle',
                      examples: [],
                    },
                    word: 'been',
                    token: {
                      index: 4,
                      word: 'been',
                      originalText: 'been',
                      characterOffsetBegin: 756,
                      characterOffsetEnd: 760,
                      before: ' ',
                      after: ' ',
                      pos: 'VBN',
                    },
                    children: [],
                  },
                  {
                    pos: 'VP',
                    posInfo: { description: 'Vereb Phrase. ', examples: [] },
                    word: '',
                    children: [
                      {
                        pos: 'VBN',
                        posInfo: {
                          group: 'Verb, past participle',
                          tag: 'Verb, past participle',
                          examples: [],
                        },
                        word: 'employed',
                        token: {
                          index: 5,
                          word: 'employed',
                          originalText: 'employed',
                          characterOffsetBegin: 761,
                          characterOffsetEnd: 769,
                          before: ' ',
                          after: ' ',
                          pos: 'VBN',
                        },
                        children: [],
                      },
                      {
                        pos: 'S',
                        posInfo: {
                          description:
                            'simple declarative clause, i.e. one that is not introduced by a (possible empty) subordinating conjunction or a wh-word and that does not exhibit subject-verb inversion.',
                          examples: [],
                        },
                        word: '',
                        children: [
                          {
                            pos: 'VP',
                            posInfo: {
                              description: 'Vereb Phrase. ',
                              examples: [],
                            },
                            word: '',
                            children: [
                              {
                                pos: 'TO',
                                posInfo: {
                                  group: 'to',
                                  tag: 'to',
                                  examples: [],
                                },
                                word: 'to',
                                token: {
                                  index: 6,
                                  word: 'to',
                                  originalText: 'to',
                                  characterOffsetBegin: 770,
                                  characterOffsetEnd: 772,
                                  before: ' ',
                                  after: ' ',
                                  pos: 'TO',
                                },
                                children: [],
                              },
                              {
                                pos: 'VP',
                                posInfo: {
                                  description: 'Vereb Phrase. ',
                                  examples: [],
                                },
                                word: '',
                                children: [
                                  {
                                    pos: 'VB',
                                    posInfo: {
                                      group: 'Verb, base form',
                                      tag: 'Verb, base form',
                                      examples: [],
                                    },
                                    word: 'mitigate',
                                    token: {
                                      index: 7,
                                      word: 'mitigate',
                                      originalText: 'mitigate',
                                      characterOffsetBegin: 773,
                                      characterOffsetEnd: 781,
                                      before: ' ',
                                      after: ' ',
                                      pos: 'VB',
                                    },
                                    children: [],
                                  },
                                  {
                                    pos: 'NP',
                                    posInfo: {
                                      description: 'Noun Phrase. ',
                                      examples: [],
                                    },
                                    word: '',
                                    children: [
                                      {
                                        pos: 'NP',
                                        posInfo: {
                                          description: 'Noun Phrase. ',
                                          examples: [],
                                        },
                                        word: '',
                                        children: [
                                          {
                                            pos: 'DT',
                                            posInfo: {
                                              group: 'Determiner',
                                              tag: 'Determiner',
                                              examples: [],
                                            },
                                            word: 'the',
                                            token: {
                                              index: 8,
                                              word: 'the',
                                              originalText: 'the',
                                              characterOffsetBegin: 782,
                                              characterOffsetEnd: 785,
                                              before: ' ',
                                              after: ' ',
                                              pos: 'DT',
                                            },
                                            children: [],
                                          },
                                          {
                                            pos: 'NN',
                                            posInfo: {
                                              group: 'Noun, singular or mass',
                                              tag: 'Noun, singular or mass',
                                              examples: [],
                                            },
                                            word: 'difficulty',
                                            token: {
                                              index: 9,
                                              word: 'difficulty',
                                              originalText: 'difficulty',
                                              characterOffsetBegin: 786,
                                              characterOffsetEnd: 796,
                                              before: ' ',
                                              after: ' ',
                                              pos: 'NN',
                                            },
                                            children: [],
                                          },
                                        ],
                                      },
                                      {
                                        pos: 'PP',
                                        posInfo: {
                                          description: 'Prepositional Phrase.',
                                          examples: [],
                                        },
                                        word: '',
                                        children: [
                                          {
                                            pos: 'IN',
                                            posInfo: {
                                              group:
                                                'Preposition or subordinating conjunction',
                                              tag: 'Preposition or subordinating conjunction',
                                              examples: [],
                                            },
                                            word: 'of',
                                            token: {
                                              index: 10,
                                              word: 'of',
                                              originalText: 'of',
                                              characterOffsetBegin: 797,
                                              characterOffsetEnd: 799,
                                              before: ' ',
                                              after: ' ',
                                              pos: 'IN',
                                            },
                                            children: [],
                                          },
                                          {
                                            pos: 'S',
                                            posInfo: {
                                              description:
                                                'simple declarative clause, i.e. one that is not introduced by a (possible empty) subordinating conjunction or a wh-word and that does not exhibit subject-verb inversion.',
                                              examples: [],
                                            },
                                            word: '',
                                            children: [
                                              {
                                                pos: 'VP',
                                                posInfo: {
                                                  description: 'Vereb Phrase. ',
                                                  examples: [],
                                                },
                                                word: '',
                                                children: [
                                                  {
                                                    pos: 'VBG',
                                                    posInfo: {
                                                      group:
                                                        'Verb, gerund or present participle',
                                                      tag: 'Verb, gerund or present participle',
                                                      examples: [],
                                                    },
                                                    word: 'controlling',
                                                    token: {
                                                      index: 11,
                                                      word: 'controlling',
                                                      originalText:
                                                        'controlling',
                                                      characterOffsetBegin: 800,
                                                      characterOffsetEnd: 811,
                                                      before: ' ',
                                                      after: ' ',
                                                      pos: 'VBG',
                                                    },
                                                    children: [],
                                                  },
                                                  {
                                                    pos: 'NP',
                                                    posInfo: {
                                                      description:
                                                        'Noun Phrase. ',
                                                      examples: [],
                                                    },
                                                    word: '',
                                                    children: [
                                                      {
                                                        pos: 'DT',
                                                        posInfo: {
                                                          group: 'Determiner',
                                                          tag: 'Determiner',
                                                          examples: [],
                                                        },
                                                        word: 'the',
                                                        token: {
                                                          index: 12,
                                                          word: 'the',
                                                          originalText: 'the',
                                                          characterOffsetBegin: 812,
                                                          characterOffsetEnd: 815,
                                                          before: ' ',
                                                          after: ' ',
                                                          pos: 'DT',
                                                        },
                                                        children: [],
                                                      },
                                                      {
                                                        pos: 'NN',
                                                        posInfo: {
                                                          group:
                                                            'Noun, singular or mass',
                                                          tag: 'Noun, singular or mass',
                                                          examples: [],
                                                        },
                                                        word: 'caret',
                                                        token: {
                                                          index: 13,
                                                          word: 'caret',
                                                          originalText: 'caret',
                                                          characterOffsetBegin: 816,
                                                          characterOffsetEnd: 821,
                                                          before: ' ',
                                                          after: ' ',
                                                          pos: 'NN',
                                                        },
                                                        children: [],
                                                      },
                                                    ],
                                                  },
                                                  {
                                                    pos: 'PP',
                                                    posInfo: {
                                                      description:
                                                        'Prepositional Phrase.',
                                                      examples: [],
                                                    },
                                                    word: '',
                                                    children: [
                                                      {
                                                        pos: 'PP',
                                                        posInfo: {
                                                          description:
                                                            'Prepositional Phrase.',
                                                          examples: [],
                                                        },
                                                        word: '',
                                                        children: [
                                                          {
                                                            pos: 'IN',
                                                            posInfo: {
                                                              group:
                                                                'Preposition or subordinating conjunction',
                                                              tag: 'Preposition or subordinating conjunction',
                                                              examples: [],
                                                            },
                                                            word: 'on',
                                                            token: {
                                                              index: 14,
                                                              word: 'on',
                                                              originalText:
                                                                'on',
                                                              characterOffsetBegin: 822,
                                                              characterOffsetEnd: 824,
                                                              before: ' ',
                                                              after: ' ',
                                                              pos: 'IN',
                                                            },
                                                            children: [],
                                                          },
                                                          {
                                                            pos: 'NP',
                                                            posInfo: {
                                                              description:
                                                                'Noun Phrase. ',
                                                              examples: [],
                                                            },
                                                            word: '',
                                                            children: [
                                                              {
                                                                pos: 'NP',
                                                                posInfo: {
                                                                  description:
                                                                    'Noun Phrase. ',
                                                                  examples: [],
                                                                },
                                                                word: '',
                                                                children: [
                                                                  {
                                                                    pos: 'NNS',
                                                                    posInfo: {
                                                                      group:
                                                                        'Noun, plural',
                                                                      tag: 'Noun, plural',
                                                                      examples:
                                                                        [],
                                                                    },
                                                                    word: 'touchscreens',
                                                                    token: {
                                                                      index: 15,
                                                                      word: 'touchscreens',
                                                                      originalText:
                                                                        'touchscreens',
                                                                      characterOffsetBegin: 825,
                                                                      characterOffsetEnd: 837,
                                                                      before:
                                                                        ' ',
                                                                      after: '',
                                                                      pos: 'NNS',
                                                                    },
                                                                    children:
                                                                      [],
                                                                  },
                                                                ],
                                                              },
                                                              {
                                                                pos: ',',
                                                                word: ',',
                                                                token: {
                                                                  index: 16,
                                                                  word: ',',
                                                                  originalText:
                                                                    ',',
                                                                  characterOffsetBegin: 837,
                                                                  characterOffsetEnd: 838,
                                                                  before: '',
                                                                  after: ' ',
                                                                  pos: ',',
                                                                },
                                                                children: [],
                                                              },
                                                              {
                                                                pos: 'PP',
                                                                posInfo: {
                                                                  description:
                                                                    'Prepositional Phrase.',
                                                                  examples: [],
                                                                },
                                                                word: '',
                                                                children: [
                                                                  {
                                                                    pos: 'JJ',
                                                                    posInfo: {
                                                                      group:
                                                                        'Adjective',
                                                                      tag: 'Adjective',
                                                                      examples:
                                                                        [],
                                                                    },
                                                                    word: 'such',
                                                                    token: {
                                                                      index: 17,
                                                                      word: 'such',
                                                                      originalText:
                                                                        'such',
                                                                      characterOffsetBegin: 839,
                                                                      characterOffsetEnd: 843,
                                                                      before:
                                                                        ' ',
                                                                      after:
                                                                        ' ',
                                                                      pos: 'JJ',
                                                                    },
                                                                    children:
                                                                      [],
                                                                  },
                                                                  {
                                                                    pos: 'IN',
                                                                    posInfo: {
                                                                      group:
                                                                        'Preposition or subordinating conjunction',
                                                                      tag: 'Preposition or subordinating conjunction',
                                                                      examples:
                                                                        [],
                                                                    },
                                                                    word: 'as',
                                                                    token: {
                                                                      index: 18,
                                                                      word: 'as',
                                                                      originalText:
                                                                        'as',
                                                                      characterOffsetBegin: 844,
                                                                      characterOffsetEnd: 846,
                                                                      before:
                                                                        ' ',
                                                                      after:
                                                                        ' ',
                                                                      pos: 'IN',
                                                                    },
                                                                    children:
                                                                      [],
                                                                  },
                                                                  {
                                                                    pos: 'S',
                                                                    posInfo: {
                                                                      description:
                                                                        'simple declarative clause, i.e. one that is not introduced by a (possible empty) subordinating conjunction or a wh-word and that does not exhibit subject-verb inversion.',
                                                                      examples:
                                                                        [],
                                                                    },
                                                                    word: '',
                                                                    children: [
                                                                      {
                                                                        pos: 'VP',
                                                                        posInfo:
                                                                          {
                                                                            description:
                                                                              'Vereb Phrase. ',
                                                                            examples:
                                                                              [],
                                                                          },
                                                                        word: '',
                                                                        children:
                                                                          [
                                                                            {
                                                                              pos: 'VP',
                                                                              posInfo:
                                                                                {
                                                                                  description:
                                                                                    'Vereb Phrase. ',
                                                                                  examples:
                                                                                    [],
                                                                                },
                                                                              word: '',
                                                                              children:
                                                                                [
                                                                                  {
                                                                                    pos: 'VBG',
                                                                                    posInfo:
                                                                                      {
                                                                                        group:
                                                                                          'Verb, gerund or present participle',
                                                                                        tag: 'Verb, gerund or present participle',
                                                                                        examples:
                                                                                          [],
                                                                                      },
                                                                                    word: 'adding',
                                                                                    token:
                                                                                      {
                                                                                        index: 19,
                                                                                        word: 'adding',
                                                                                        originalText:
                                                                                          'adding',
                                                                                        characterOffsetBegin: 847,
                                                                                        characterOffsetEnd: 853,
                                                                                        before:
                                                                                          ' ',
                                                                                        after:
                                                                                          ' ',
                                                                                        pos: 'VBG',
                                                                                      },
                                                                                    children:
                                                                                      [],
                                                                                  },
                                                                                  {
                                                                                    pos: 'NP',
                                                                                    posInfo:
                                                                                      {
                                                                                        description:
                                                                                          'Noun Phrase. ',
                                                                                        examples:
                                                                                          [],
                                                                                      },
                                                                                    word: '',
                                                                                    children:
                                                                                      [
                                                                                        {
                                                                                          pos: 'DT',
                                                                                          posInfo:
                                                                                            {
                                                                                              group:
                                                                                                'Determiner',
                                                                                              tag: 'Determiner',
                                                                                              examples:
                                                                                                [],
                                                                                            },
                                                                                          word: 'a',
                                                                                          token:
                                                                                            {
                                                                                              index: 20,
                                                                                              word: 'a',
                                                                                              originalText:
                                                                                                'a',
                                                                                              characterOffsetBegin: 854,
                                                                                              characterOffsetEnd: 855,
                                                                                              before:
                                                                                                ' ',
                                                                                              after:
                                                                                                ' ',
                                                                                              pos: 'DT',
                                                                                            },
                                                                                          children:
                                                                                            [],
                                                                                        },
                                                                                        {
                                                                                          pos: 'NN',
                                                                                          posInfo:
                                                                                            {
                                                                                              group:
                                                                                                'Noun, singular or mass',
                                                                                              tag: 'Noun, singular or mass',
                                                                                              examples:
                                                                                                [],
                                                                                            },
                                                                                          word: 'magnifier',
                                                                                          token:
                                                                                            {
                                                                                              index: 21,
                                                                                              word: 'magnifier',
                                                                                              originalText:
                                                                                                'magnifier',
                                                                                              characterOffsetBegin: 856,
                                                                                              characterOffsetEnd: 865,
                                                                                              before:
                                                                                                ' ',
                                                                                              after:
                                                                                                '',
                                                                                              pos: 'NN',
                                                                                            },
                                                                                          children:
                                                                                            [],
                                                                                        },
                                                                                      ],
                                                                                  },
                                                                                ],
                                                                            },
                                                                            {
                                                                              pos: ',',
                                                                              word: ',',
                                                                              token:
                                                                                {
                                                                                  index: 22,
                                                                                  word: ',',
                                                                                  originalText:
                                                                                    ',',
                                                                                  characterOffsetBegin: 865,
                                                                                  characterOffsetEnd: 866,
                                                                                  before:
                                                                                    '',
                                                                                  after:
                                                                                    ' ',
                                                                                  pos: ',',
                                                                                },
                                                                              children:
                                                                                [],
                                                                            },
                                                                            {
                                                                              pos: 'VP',
                                                                              posInfo:
                                                                                {
                                                                                  description:
                                                                                    'Vereb Phrase. ',
                                                                                  examples:
                                                                                    [],
                                                                                },
                                                                              word: '',
                                                                              children:
                                                                                [
                                                                                  {
                                                                                    pos: 'VBG',
                                                                                    posInfo:
                                                                                      {
                                                                                        group:
                                                                                          'Verb, gerund or present participle',
                                                                                        tag: 'Verb, gerund or present participle',
                                                                                        examples:
                                                                                          [],
                                                                                      },
                                                                                    word: 'using',
                                                                                    token:
                                                                                      {
                                                                                        index: 23,
                                                                                        word: 'using',
                                                                                        originalText:
                                                                                          'using',
                                                                                        characterOffsetBegin: 867,
                                                                                        characterOffsetEnd: 872,
                                                                                        before:
                                                                                          ' ',
                                                                                        after:
                                                                                          ' ',
                                                                                        pos: 'VBG',
                                                                                      },
                                                                                    children:
                                                                                      [],
                                                                                  },
                                                                                  {
                                                                                    pos: 'NP',
                                                                                    posInfo:
                                                                                      {
                                                                                        description:
                                                                                          'Noun Phrase. ',
                                                                                        examples:
                                                                                          [],
                                                                                      },
                                                                                    word: '',
                                                                                    children:
                                                                                      [
                                                                                        {
                                                                                          pos: 'DT',
                                                                                          posInfo:
                                                                                            {
                                                                                              group:
                                                                                                'Determiner',
                                                                                              tag: 'Determiner',
                                                                                              examples:
                                                                                                [],
                                                                                            },
                                                                                          word: 'the',
                                                                                          token:
                                                                                            {
                                                                                              index: 24,
                                                                                              word: 'the',
                                                                                              originalText:
                                                                                                'the',
                                                                                              characterOffsetBegin: 873,
                                                                                              characterOffsetEnd: 876,
                                                                                              before:
                                                                                                ' ',
                                                                                              after:
                                                                                                ' ',
                                                                                              pos: 'DT',
                                                                                            },
                                                                                          children:
                                                                                            [],
                                                                                        },
                                                                                        {
                                                                                          pos: 'NN',
                                                                                          posInfo:
                                                                                            {
                                                                                              group:
                                                                                                'Noun, singular or mass',
                                                                                              tag: 'Noun, singular or mass',
                                                                                              examples:
                                                                                                [],
                                                                                            },
                                                                                          word: 'keyboard',
                                                                                          token:
                                                                                            {
                                                                                              index: 25,
                                                                                              word: 'keyboard',
                                                                                              originalText:
                                                                                                'keyboard',
                                                                                              characterOffsetBegin: 877,
                                                                                              characterOffsetEnd: 885,
                                                                                              before:
                                                                                                ' ',
                                                                                              after:
                                                                                                ' ',
                                                                                              pos: 'NN',
                                                                                            },
                                                                                          children:
                                                                                            [],
                                                                                        },
                                                                                      ],
                                                                                  },
                                                                                  {
                                                                                    pos: 'PP',
                                                                                    posInfo:
                                                                                      {
                                                                                        description:
                                                                                          'Prepositional Phrase.',
                                                                                        examples:
                                                                                          [],
                                                                                      },
                                                                                    word: '',
                                                                                    children:
                                                                                      [
                                                                                        {
                                                                                          pos: 'IN',
                                                                                          posInfo:
                                                                                            {
                                                                                              group:
                                                                                                'Preposition or subordinating conjunction',
                                                                                              tag: 'Preposition or subordinating conjunction',
                                                                                              examples:
                                                                                                [],
                                                                                            },
                                                                                          word: 'as',
                                                                                          token:
                                                                                            {
                                                                                              index: 26,
                                                                                              word: 'as',
                                                                                              originalText:
                                                                                                'as',
                                                                                              characterOffsetBegin: 886,
                                                                                              characterOffsetEnd: 888,
                                                                                              before:
                                                                                                ' ',
                                                                                              after:
                                                                                                ' ',
                                                                                              pos: 'IN',
                                                                                            },
                                                                                          children:
                                                                                            [],
                                                                                        },
                                                                                        {
                                                                                          pos: 'NP',
                                                                                          posInfo:
                                                                                            {
                                                                                              description:
                                                                                                'Noun Phrase. ',
                                                                                              examples:
                                                                                                [],
                                                                                            },
                                                                                          word: '',
                                                                                          children:
                                                                                            [
                                                                                              {
                                                                                                pos: 'NN',
                                                                                                posInfo:
                                                                                                  {
                                                                                                    group:
                                                                                                      'Noun, singular or mass',
                                                                                                    tag: 'Noun, singular or mass',
                                                                                                    examples:
                                                                                                      [],
                                                                                                  },
                                                                                                word: 'trackpad',
                                                                                                token:
                                                                                                  {
                                                                                                    index: 27,
                                                                                                    word: 'trackpad',
                                                                                                    originalText:
                                                                                                      'trackpad',
                                                                                                    characterOffsetBegin: 889,
                                                                                                    characterOffsetEnd: 897,
                                                                                                    before:
                                                                                                      ' ',
                                                                                                    after:
                                                                                                      '',
                                                                                                    pos: 'NN',
                                                                                                  },
                                                                                                children:
                                                                                                  [],
                                                                                              },
                                                                                            ],
                                                                                        },
                                                                                      ],
                                                                                  },
                                                                                ],
                                                                            },
                                                                          ],
                                                                      },
                                                                    ],
                                                                  },
                                                                ],
                                                              },
                                                              {
                                                                pos: ',',
                                                                word: ',',
                                                                token: {
                                                                  index: 28,
                                                                  word: ',',
                                                                  originalText:
                                                                    ',',
                                                                  characterOffsetBegin: 897,
                                                                  characterOffsetEnd: 898,
                                                                  before: '',
                                                                  after: ' ',
                                                                  pos: ',',
                                                                },
                                                                children: [],
                                                              },
                                                            ],
                                                          },
                                                        ],
                                                      },
                                                      {
                                                        pos: 'CC',
                                                        posInfo: {
                                                          group:
                                                            'Coordinating conjunction',
                                                          tag: 'Coordinating conjunction',
                                                          examples: [],
                                                        },
                                                        word: 'or',
                                                        token: {
                                                          index: 29,
                                                          word: 'or',
                                                          originalText: 'or',
                                                          characterOffsetBegin: 899,
                                                          characterOffsetEnd: 901,
                                                          before: ' ',
                                                          after: ' ',
                                                          pos: 'CC',
                                                        },
                                                        children: [],
                                                      },
                                                      {
                                                        pos: 'PP',
                                                        posInfo: {
                                                          description:
                                                            'Prepositional Phrase.',
                                                          examples: [],
                                                        },
                                                        word: '',
                                                        children: [
                                                          {
                                                            pos: 'IN',
                                                            posInfo: {
                                                              group:
                                                                'Preposition or subordinating conjunction',
                                                              tag: 'Preposition or subordinating conjunction',
                                                              examples: [],
                                                            },
                                                            word: 'by',
                                                            token: {
                                                              index: 30,
                                                              word: 'by',
                                                              originalText:
                                                                'by',
                                                              characterOffsetBegin: 902,
                                                              characterOffsetEnd: 904,
                                                              before: ' ',
                                                              after: ' ',
                                                              pos: 'IN',
                                                            },
                                                            children: [],
                                                          },
                                                          {
                                                            pos: 'S',
                                                            posInfo: {
                                                              description:
                                                                'simple declarative clause, i.e. one that is not introduced by a (possible empty) subordinating conjunction or a wh-word and that does not exhibit subject-verb inversion.',
                                                              examples: [],
                                                            },
                                                            word: '',
                                                            children: [
                                                              {
                                                                pos: 'VP',
                                                                posInfo: {
                                                                  description:
                                                                    'Vereb Phrase. ',
                                                                  examples: [],
                                                                },
                                                                word: '',
                                                                children: [
                                                                  {
                                                                    pos: 'VBG',
                                                                    posInfo: {
                                                                      group:
                                                                        'Verb, gerund or present participle',
                                                                      tag: 'Verb, gerund or present participle',
                                                                      examples:
                                                                        [],
                                                                    },
                                                                    word: 'tilting',
                                                                    token: {
                                                                      index: 31,
                                                                      word: 'tilting',
                                                                      originalText:
                                                                        'tilting',
                                                                      characterOffsetBegin: 905,
                                                                      characterOffsetEnd: 912,
                                                                      before:
                                                                        ' ',
                                                                      after:
                                                                        ' ',
                                                                      pos: 'VBG',
                                                                    },
                                                                    children:
                                                                      [],
                                                                  },
                                                                  {
                                                                    pos: 'NP',
                                                                    posInfo: {
                                                                      description:
                                                                        'Noun Phrase. ',
                                                                      examples:
                                                                        [],
                                                                    },
                                                                    word: '',
                                                                    children: [
                                                                      {
                                                                        pos: 'DT',
                                                                        posInfo:
                                                                          {
                                                                            group:
                                                                              'Determiner',
                                                                            tag: 'Determiner',
                                                                            examples:
                                                                              [],
                                                                          },
                                                                        word: 'the',
                                                                        token: {
                                                                          index: 32,
                                                                          word: 'the',
                                                                          originalText:
                                                                            'the',
                                                                          characterOffsetBegin: 913,
                                                                          characterOffsetEnd: 916,
                                                                          before:
                                                                            ' ',
                                                                          after:
                                                                            ' ',
                                                                          pos: 'DT',
                                                                        },
                                                                        children:
                                                                          [],
                                                                      },
                                                                      {
                                                                        pos: 'NN',
                                                                        posInfo:
                                                                          {
                                                                            group:
                                                                              'Noun, singular or mass',
                                                                            tag: 'Noun, singular or mass',
                                                                            examples:
                                                                              [],
                                                                          },
                                                                        word: 'device',
                                                                        token: {
                                                                          index: 33,
                                                                          word: 'device',
                                                                          originalText:
                                                                            'device',
                                                                          characterOffsetBegin: 917,
                                                                          characterOffsetEnd: 923,
                                                                          before:
                                                                            ' ',
                                                                          after:
                                                                            ' ',
                                                                          pos: 'NN',
                                                                        },
                                                                        children:
                                                                          [],
                                                                      },
                                                                    ],
                                                                  },
                                                                  {
                                                                    pos: 'PP',
                                                                    posInfo: {
                                                                      description:
                                                                        'Prepositional Phrase.',
                                                                      examples:
                                                                        [],
                                                                    },
                                                                    word: '',
                                                                    children: [
                                                                      {
                                                                        pos: 'IN',
                                                                        posInfo:
                                                                          {
                                                                            group:
                                                                              'Preposition or subordinating conjunction',
                                                                            tag: 'Preposition or subordinating conjunction',
                                                                            examples:
                                                                              [],
                                                                          },
                                                                        word: 'to',
                                                                        token: {
                                                                          index: 34,
                                                                          word: 'to',
                                                                          originalText:
                                                                            'to',
                                                                          characterOffsetBegin: 924,
                                                                          characterOffsetEnd: 926,
                                                                          before:
                                                                            ' ',
                                                                          after:
                                                                            ' ',
                                                                          pos: 'IN',
                                                                        },
                                                                        children:
                                                                          [],
                                                                      },
                                                                      {
                                                                        pos: 'NP',
                                                                        posInfo:
                                                                          {
                                                                            description:
                                                                              'Noun Phrase. ',
                                                                            examples:
                                                                              [],
                                                                          },
                                                                        word: '',
                                                                        children:
                                                                          [
                                                                            {
                                                                              pos: 'NP',
                                                                              posInfo:
                                                                                {
                                                                                  description:
                                                                                    'Noun Phrase. ',
                                                                                  examples:
                                                                                    [],
                                                                                },
                                                                              word: '',
                                                                              children:
                                                                                [
                                                                                  {
                                                                                    pos: 'NN',
                                                                                    posInfo:
                                                                                      {
                                                                                        group:
                                                                                          'Noun, singular or mass',
                                                                                        tag: 'Noun, singular or mass',
                                                                                        examples:
                                                                                          [],
                                                                                      },
                                                                                    word: 'control',
                                                                                    token:
                                                                                      {
                                                                                        index: 35,
                                                                                        word: 'control',
                                                                                        originalText:
                                                                                          'control',
                                                                                        characterOffsetBegin: 927,
                                                                                        characterOffsetEnd: 934,
                                                                                        before:
                                                                                          ' ',
                                                                                        after:
                                                                                          ' ',
                                                                                        pos: 'NN',
                                                                                      },
                                                                                    children:
                                                                                      [],
                                                                                  },
                                                                                  {
                                                                                    pos: 'NN',
                                                                                    posInfo:
                                                                                      {
                                                                                        group:
                                                                                          'Noun, singular or mass',
                                                                                        tag: 'Noun, singular or mass',
                                                                                        examples:
                                                                                          [],
                                                                                      },
                                                                                    word: 'selection',
                                                                                    token:
                                                                                      {
                                                                                        index: 36,
                                                                                        word: 'selection',
                                                                                        originalText:
                                                                                          'selection',
                                                                                        characterOffsetBegin: 935,
                                                                                        characterOffsetEnd: 944,
                                                                                        before:
                                                                                          ' ',
                                                                                        after:
                                                                                          '',
                                                                                        pos: 'NN',
                                                                                      },
                                                                                    children:
                                                                                      [],
                                                                                  },
                                                                                ],
                                                                            },
                                                                            {
                                                                              pos: ',',
                                                                              word: ',',
                                                                              token:
                                                                                {
                                                                                  index: 37,
                                                                                  word: ',',
                                                                                  originalText:
                                                                                    ',',
                                                                                  characterOffsetBegin: 944,
                                                                                  characterOffsetEnd: 945,
                                                                                  before:
                                                                                    '',
                                                                                  after:
                                                                                    ' ',
                                                                                  pos: ',',
                                                                                },
                                                                              children:
                                                                                [],
                                                                            },
                                                                            {
                                                                              pos: 'ADVP',
                                                                              posInfo:
                                                                                {
                                                                                  description:
                                                                                    'Adverb Phrase.',
                                                                                  examples:
                                                                                    [],
                                                                                },
                                                                              word: '',
                                                                              children:
                                                                                [
                                                                                  {
                                                                                    pos: 'FW',
                                                                                    posInfo:
                                                                                      {
                                                                                        group:
                                                                                          'Foreign word',
                                                                                        tag: 'Foreign word',
                                                                                        examples:
                                                                                          [],
                                                                                      },
                                                                                    word: 'etc.',
                                                                                    token:
                                                                                      {
                                                                                        index: 38,
                                                                                        word: 'etc.',
                                                                                        originalText:
                                                                                          'etc',
                                                                                        characterOffsetBegin: 946,
                                                                                        characterOffsetEnd: 949,
                                                                                        before:
                                                                                          ' ',
                                                                                        after:
                                                                                          '',
                                                                                        pos: 'FW',
                                                                                      },
                                                                                    children:
                                                                                      [],
                                                                                  },
                                                                                ],
                                                                            },
                                                                          ],
                                                                      },
                                                                    ],
                                                                  },
                                                                ],
                                                              },
                                                            ],
                                                          },
                                                        ],
                                                      },
                                                    ],
                                                  },
                                                ],
                                              },
                                            ],
                                          },
                                        ],
                                      },
                                    ],
                                  },
                                ],
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            pos: '.',
            word: '.',
            token: {
              index: 39,
              word: '.',
              originalText: '.',
              characterOffsetBegin: 949,
              characterOffsetEnd: 950,
              before: '',
              after: ' ',
              pos: '.',
            },
            children: [],
          },
        ],
      },
    ],
  },
  {
    pos: 'ROOT',
    word: '',
    children: [
      {
        pos: 'S',
        posInfo: {
          description:
            'simple declarative clause, i.e. one that is not introduced by a (possible empty) subordinating conjunction or a wh-word and that does not exhibit subject-verb inversion.',
          examples: [],
        },
        word: '',
        children: [
          {
            pos: 'PP',
            posInfo: { description: 'Prepositional Phrase.', examples: [] },
            word: '',
            children: [
              {
                pos: 'IN',
                posInfo: {
                  group: 'Preposition or subordinating conjunction',
                  tag: 'Preposition or subordinating conjunction',
                  examples: [],
                },
                word: 'To',
                token: {
                  index: 1,
                  word: 'To',
                  originalText: 'To',
                  characterOffsetBegin: 951,
                  characterOffsetEnd: 953,
                  before: ' ',
                  after: ' ',
                  pos: 'IN',
                },
                children: [],
              },
              {
                pos: 'NP',
                posInfo: { description: 'Noun Phrase. ', examples: [] },
                word: '',
                children: [
                  {
                    pos: 'NN',
                    posInfo: {
                      group: 'Noun, singular or mass',
                      tag: 'Noun, singular or mass',
                      examples: [],
                    },
                    word: 'date',
                    token: {
                      index: 2,
                      word: 'date',
                      originalText: 'date',
                      characterOffsetBegin: 954,
                      characterOffsetEnd: 958,
                      before: ' ',
                      after: '',
                      pos: 'NN',
                    },
                    children: [],
                  },
                ],
              },
            ],
          },
          {
            pos: ',',
            word: ',',
            token: {
              index: 3,
              word: ',',
              originalText: ',',
              characterOffsetBegin: 958,
              characterOffsetEnd: 959,
              before: '',
              after: ' ',
              pos: ',',
            },
            children: [],
          },
          {
            pos: 'NP',
            posInfo: { description: 'Noun Phrase. ', examples: [] },
            word: '',
            children: [
              {
                pos: 'NP',
                posInfo: { description: 'Noun Phrase. ', examples: [] },
                word: '',
                children: [
                  {
                    pos: 'DT',
                    posInfo: {
                      group: 'Determiner',
                      tag: 'Determiner',
                      examples: [],
                    },
                    word: 'the',
                    token: {
                      index: 4,
                      word: 'the',
                      originalText: 'the',
                      characterOffsetBegin: 960,
                      characterOffsetEnd: 963,
                      before: ' ',
                      after: ' ',
                      pos: 'DT',
                    },
                    children: [],
                  },
                  {
                    pos: 'NN',
                    posInfo: {
                      group: 'Noun, singular or mass',
                      tag: 'Noun, singular or mass',
                      examples: [],
                    },
                    word: 'selection',
                    token: {
                      index: 5,
                      word: 'selection',
                      originalText: 'selection',
                      characterOffsetBegin: 964,
                      characterOffsetEnd: 973,
                      before: ' ',
                      after: ' ',
                      pos: 'NN',
                    },
                    children: [],
                  },
                ],
              },
              {
                pos: 'PP',
                posInfo: { description: 'Prepositional Phrase.', examples: [] },
                word: '',
                children: [
                  {
                    pos: 'IN',
                    posInfo: {
                      group: 'Preposition or subordinating conjunction',
                      tag: 'Preposition or subordinating conjunction',
                      examples: [],
                    },
                    word: 'of',
                    token: {
                      index: 6,
                      word: 'of',
                      originalText: 'of',
                      characterOffsetBegin: 974,
                      characterOffsetEnd: 976,
                      before: ' ',
                      after: ' ',
                      pos: 'IN',
                    },
                    children: [],
                  },
                  {
                    pos: 'NP',
                    posInfo: { description: 'Noun Phrase. ', examples: [] },
                    word: '',
                    children: [
                      {
                        pos: 'DT',
                        posInfo: {
                          group: 'Determiner',
                          tag: 'Determiner',
                          examples: [],
                        },
                        word: 'a',
                        token: {
                          index: 7,
                          word: 'a',
                          originalText: 'a',
                          characterOffsetBegin: 977,
                          characterOffsetEnd: 978,
                          before: ' ',
                          after: ' ',
                          pos: 'DT',
                        },
                        children: [],
                      },
                      {
                        pos: 'VBN',
                        posInfo: {
                          group: 'Verb, past participle',
                          tag: 'Verb, past participle',
                          examples: [],
                        },
                        word: 'chosen',
                        token: {
                          index: 8,
                          word: 'chosen',
                          originalText: 'chosen',
                          characterOffsetBegin: 979,
                          characterOffsetEnd: 985,
                          before: ' ',
                          after: ' ',
                          pos: 'VBN',
                        },
                        children: [],
                      },
                      {
                        pos: 'NN',
                        posInfo: {
                          group: 'Noun, singular or mass',
                          tag: 'Noun, singular or mass',
                          examples: [],
                        },
                        word: 'text',
                        token: {
                          index: 9,
                          word: 'text',
                          originalText: 'text',
                          characterOffsetBegin: 986,
                          characterOffsetEnd: 990,
                          before: ' ',
                          after: ' ',
                          pos: 'NN',
                        },
                        children: [],
                      },
                      {
                        pos: 'NN',
                        posInfo: {
                          group: 'Noun, singular or mass',
                          tag: 'Noun, singular or mass',
                          examples: [],
                        },
                        word: 'range',
                        token: {
                          index: 10,
                          word: 'range',
                          originalText: 'range',
                          characterOffsetBegin: 991,
                          characterOffsetEnd: 996,
                          before: ' ',
                          after: ' ',
                          pos: 'NN',
                        },
                        children: [],
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            pos: 'VP',
            posInfo: { description: 'Vereb Phrase. ', examples: [] },
            word: '',
            children: [
              {
                pos: 'VBZ',
                posInfo: {
                  group: 'Verb, 3rd person singular present',
                  tag: 'Verb, 3rd person singular present',
                  examples: [],
                },
                word: 'has',
                token: {
                  index: 11,
                  word: 'has',
                  originalText: 'has',
                  characterOffsetBegin: 997,
                  characterOffsetEnd: 1000,
                  before: ' ',
                  after: ' ',
                  pos: 'VBZ',
                },
                children: [],
              },
              {
                pos: 'ADVP',
                posInfo: { description: 'Adverb Phrase.', examples: [] },
                word: '',
                children: [
                  {
                    pos: 'RB',
                    posInfo: { group: 'Adverb', tag: 'Adverb', examples: [] },
                    word: 'largely',
                    token: {
                      index: 12,
                      word: 'largely',
                      originalText: 'largely',
                      characterOffsetBegin: 1001,
                      characterOffsetEnd: 1008,
                      before: ' ',
                      after: ' ',
                      pos: 'RB',
                    },
                    children: [],
                  },
                ],
              },
              {
                pos: 'VP',
                posInfo: { description: 'Vereb Phrase. ', examples: [] },
                word: '',
                children: [
                  {
                    pos: 'VBN',
                    posInfo: {
                      group: 'Verb, past participle',
                      tag: 'Verb, past participle',
                      examples: [],
                    },
                    word: 'been',
                    token: {
                      index: 13,
                      word: 'been',
                      originalText: 'been',
                      characterOffsetBegin: 1009,
                      characterOffsetEnd: 1013,
                      before: ' ',
                      after: ' ',
                      pos: 'VBN',
                    },
                    children: [],
                  },
                  {
                    pos: 'VP',
                    posInfo: { description: 'Vereb Phrase. ', examples: [] },
                    word: '',
                    children: [
                      {
                        pos: 'VBN',
                        posInfo: {
                          group: 'Verb, past participle',
                          tag: 'Verb, past participle',
                          examples: [],
                        },
                        word: 'fixated',
                        token: {
                          index: 14,
                          word: 'fixated',
                          originalText: 'fixated',
                          characterOffsetBegin: 1014,
                          characterOffsetEnd: 1021,
                          before: ' ',
                          after: ' ',
                          pos: 'VBN',
                        },
                        children: [],
                      },
                      {
                        pos: 'PP',
                        posInfo: {
                          description: 'Prepositional Phrase.',
                          examples: [],
                        },
                        word: '',
                        children: [
                          {
                            pos: 'IN',
                            posInfo: {
                              group: 'Preposition or subordinating conjunction',
                              tag: 'Preposition or subordinating conjunction',
                              examples: [],
                            },
                            word: 'on',
                            token: {
                              index: 15,
                              word: 'on',
                              originalText: 'on',
                              characterOffsetBegin: 1022,
                              characterOffsetEnd: 1024,
                              before: ' ',
                              after: ' ',
                              pos: 'IN',
                            },
                            children: [],
                          },
                          {
                            pos: 'NP',
                            posInfo: {
                              description: 'Noun Phrase. ',
                              examples: [],
                            },
                            word: '',
                            children: [
                              {
                                pos: 'NP',
                                posInfo: {
                                  description: 'Noun Phrase. ',
                                  examples: [],
                                },
                                word: '',
                                children: [
                                  {
                                    pos: 'DT',
                                    posInfo: {
                                      group: 'Determiner',
                                      tag: 'Determiner',
                                      examples: [],
                                    },
                                    word: 'the',
                                    token: {
                                      index: 16,
                                      word: 'the',
                                      originalText: 'the',
                                      characterOffsetBegin: 1025,
                                      characterOffsetEnd: 1028,
                                      before: ' ',
                                      after: ' ',
                                      pos: 'DT',
                                    },
                                    children: [],
                                  },
                                  {
                                    pos: 'NN',
                                    posInfo: {
                                      group: 'Noun, singular or mass',
                                      tag: 'Noun, singular or mass',
                                      examples: [],
                                    },
                                    word: 'use',
                                    token: {
                                      index: 17,
                                      word: 'use',
                                      originalText: 'use',
                                      characterOffsetBegin: 1029,
                                      characterOffsetEnd: 1032,
                                      before: ' ',
                                      after: ' ',
                                      pos: 'NN',
                                    },
                                    children: [],
                                  },
                                ],
                              },
                              {
                                pos: 'PP',
                                posInfo: {
                                  description: 'Prepositional Phrase.',
                                  examples: [],
                                },
                                word: '',
                                children: [
                                  {
                                    pos: 'IN',
                                    posInfo: {
                                      group:
                                        'Preposition or subordinating conjunction',
                                      tag: 'Preposition or subordinating conjunction',
                                      examples: [],
                                    },
                                    word: 'of',
                                    token: {
                                      index: 18,
                                      word: 'of',
                                      originalText: 'of',
                                      characterOffsetBegin: 1033,
                                      characterOffsetEnd: 1035,
                                      before: ' ',
                                      after: ' ',
                                      pos: 'IN',
                                    },
                                    children: [],
                                  },
                                  {
                                    pos: 'NP',
                                    posInfo: {
                                      description: 'Noun Phrase. ',
                                      examples: [],
                                    },
                                    word: '',
                                    children: [
                                      {
                                        pos: 'JJ',
                                        posInfo: {
                                          group: 'Adjective',
                                          tag: 'Adjective',
                                          examples: [],
                                        },
                                        word: 'absolute',
                                        token: {
                                          index: 19,
                                          word: 'absolute',
                                          originalText: 'absolute',
                                          characterOffsetBegin: 1036,
                                          characterOffsetEnd: 1044,
                                          before: ' ',
                                          after: '',
                                          pos: 'JJ',
                                        },
                                        children: [],
                                      },
                                    ],
                                  },
                                ],
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            pos: '.',
            word: '.',
            token: {
              index: 20,
              word: '.',
              originalText: '.',
              characterOffsetBegin: 1044,
              characterOffsetEnd: 1045,
              before: '',
              after: ' ',
              pos: '.',
            },
            children: [],
          },
        ],
      },
    ],
  },
  {
    pos: 'ROOT',
    word: '',
    children: [
      {
        pos: 'S',
        posInfo: {
          description:
            'simple declarative clause, i.e. one that is not introduced by a (possible empty) subordinating conjunction or a wh-word and that does not exhibit subject-verb inversion.',
          examples: [],
        },
        word: '',
        children: [
          {
            pos: 'ADVP',
            posInfo: { description: 'Adverb Phrase.', examples: [] },
            word: '',
            children: [
              {
                pos: 'RB',
                posInfo: { group: 'Adverb', tag: 'Adverb', examples: [] },
                word: 'However',
                token: {
                  index: 1,
                  word: 'However',
                  originalText: 'However',
                  characterOffsetBegin: 1046,
                  characterOffsetEnd: 1053,
                  before: ' ',
                  after: '',
                  pos: 'RB',
                },
                children: [],
              },
            ],
          },
          {
            pos: ',',
            word: ',',
            token: {
              index: 2,
              word: ',',
              originalText: ',',
              characterOffsetBegin: 1053,
              characterOffsetEnd: 1054,
              before: '',
              after: ' ',
              pos: ',',
            },
            children: [],
          },
          {
            pos: 'SBAR',
            posInfo: {
              description:
                'Clause introduced by a (possibly empty) subordinating conjunction.',
              examples: [],
            },
            word: '',
            children: [
              {
                pos: 'RB',
                posInfo: { group: 'Adverb', tag: 'Adverb', examples: [] },
                word: 'even',
                token: {
                  index: 3,
                  word: 'even',
                  originalText: 'even',
                  characterOffsetBegin: 1055,
                  characterOffsetEnd: 1059,
                  before: ' ',
                  after: ' ',
                  pos: 'RB',
                },
                children: [],
              },
              {
                pos: 'IN',
                posInfo: {
                  group: 'Preposition or subordinating conjunction',
                  tag: 'Preposition or subordinating conjunction',
                  examples: [],
                },
                word: 'if',
                token: {
                  index: 4,
                  word: 'if',
                  originalText: 'if',
                  characterOffsetBegin: 1060,
                  characterOffsetEnd: 1062,
                  before: ' ',
                  after: ' ',
                  pos: 'IN',
                },
                children: [],
              },
              {
                pos: 'S',
                posInfo: {
                  description:
                    'simple declarative clause, i.e. one that is not introduced by a (possible empty) subordinating conjunction or a wh-word and that does not exhibit subject-verb inversion.',
                  examples: [],
                },
                word: '',
                children: [
                  {
                    pos: 'NP',
                    posInfo: { description: 'Noun Phrase. ', examples: [] },
                    word: '',
                    children: [
                      {
                        pos: 'NP',
                        posInfo: { description: 'Noun Phrase. ', examples: [] },
                        word: '',
                        children: [
                          {
                            pos: 'DT',
                            posInfo: {
                              group: 'Determiner',
                              tag: 'Determiner',
                              examples: [],
                            },
                            word: 'the',
                            token: {
                              index: 5,
                              word: 'the',
                              originalText: 'the',
                              characterOffsetBegin: 1063,
                              characterOffsetEnd: 1066,
                              before: ' ',
                              after: ' ',
                              pos: 'DT',
                            },
                            children: [],
                          },
                          {
                            pos: 'NN',
                            posInfo: {
                              group: 'Noun, singular or mass',
                              tag: 'Noun, singular or mass',
                              examples: [],
                            },
                            word: 'text',
                            token: {
                              index: 6,
                              word: 'text',
                              originalText: 'text',
                              characterOffsetBegin: 1067,
                              characterOffsetEnd: 1071,
                              before: ' ',
                              after: ' ',
                              pos: 'NN',
                            },
                            children: [],
                          },
                          {
                            pos: 'NN',
                            posInfo: {
                              group: 'Noun, singular or mass',
                              tag: 'Noun, singular or mass',
                              examples: [],
                            },
                            word: 'representation',
                            token: {
                              index: 7,
                              word: 'representation',
                              originalText: 'representation',
                              characterOffsetBegin: 1072,
                              characterOffsetEnd: 1086,
                              before: ' ',
                              after: ' ',
                              pos: 'NN',
                            },
                            children: [],
                          },
                        ],
                      },
                      {
                        pos: 'PP',
                        posInfo: {
                          description: 'Prepositional Phrase.',
                          examples: [],
                        },
                        word: '',
                        children: [
                          {
                            pos: 'IN',
                            posInfo: {
                              group: 'Preposition or subordinating conjunction',
                              tag: 'Preposition or subordinating conjunction',
                              examples: [],
                            },
                            word: 'on',
                            token: {
                              index: 8,
                              word: 'on',
                              originalText: 'on',
                              characterOffsetBegin: 1087,
                              characterOffsetEnd: 1089,
                              before: ' ',
                              after: ' ',
                              pos: 'IN',
                            },
                            children: [],
                          },
                          {
                            pos: 'NP',
                            posInfo: {
                              description: 'Noun Phrase. ',
                              examples: [],
                            },
                            word: '',
                            children: [
                              {
                                pos: 'NNP',
                                posInfo: {
                                  group: 'Proper noun, singular',
                                  tag: 'Proper noun, singular',
                                  examples: [],
                                },
                                word: 'GUI',
                                token: {
                                  index: 9,
                                  word: 'GUI',
                                  originalText: 'GUI',
                                  characterOffsetBegin: 1090,
                                  characterOffsetEnd: 1093,
                                  before: ' ',
                                  after: ' ',
                                  pos: 'NNP',
                                },
                                children: [],
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                  {
                    pos: 'VP',
                    posInfo: { description: 'Vereb Phrase. ', examples: [] },
                    word: '',
                    children: [
                      {
                        pos: 'VBZ',
                        posInfo: {
                          group: 'Verb, 3rd person singular present',
                          tag: 'Verb, 3rd person singular present',
                          examples: [],
                        },
                        word: 'corresponds',
                        token: {
                          index: 10,
                          word: 'corresponds',
                          originalText: 'corresponds',
                          characterOffsetBegin: 1094,
                          characterOffsetEnd: 1105,
                          before: ' ',
                          after: ' ',
                          pos: 'VBZ',
                        },
                        children: [],
                      },
                      {
                        pos: 'PP',
                        posInfo: {
                          description: 'Prepositional Phrase.',
                          examples: [],
                        },
                        word: '',
                        children: [
                          {
                            pos: 'IN',
                            posInfo: {
                              group: 'Preposition or subordinating conjunction',
                              tag: 'Preposition or subordinating conjunction',
                              examples: [],
                            },
                            word: 'to',
                            token: {
                              index: 11,
                              word: 'to',
                              originalText: 'to',
                              characterOffsetBegin: 1106,
                              characterOffsetEnd: 1108,
                              before: ' ',
                              after: ' ',
                              pos: 'IN',
                            },
                            children: [],
                          },
                          {
                            pos: 'NP',
                            posInfo: {
                              description: 'Noun Phrase. ',
                              examples: [],
                            },
                            word: '',
                            children: [
                              {
                                pos: 'NP',
                                posInfo: {
                                  description: 'Noun Phrase. ',
                                  examples: [],
                                },
                                word: '',
                                children: [
                                  {
                                    pos: 'NN',
                                    posInfo: {
                                      group: 'Noun, singular or mass',
                                      tag: 'Noun, singular or mass',
                                      examples: [],
                                    },
                                    word: 'pixel',
                                    token: {
                                      index: 12,
                                      word: 'pixel',
                                      originalText: 'pixel',
                                      characterOffsetBegin: 1109,
                                      characterOffsetEnd: 1114,
                                      before: ' ',
                                      after: ' ',
                                      pos: 'NN',
                                    },
                                    children: [],
                                  },
                                  {
                                    pos: 'NNS',
                                    posInfo: {
                                      group: 'Noun, plural',
                                      tag: 'Noun, plural',
                                      examples: [],
                                    },
                                    word: 'positions',
                                    token: {
                                      index: 13,
                                      word: 'positions',
                                      originalText: 'positions',
                                      characterOffsetBegin: 1115,
                                      characterOffsetEnd: 1124,
                                      before: ' ',
                                      after: '',
                                      pos: 'NNS',
                                    },
                                    children: [],
                                  },
                                ],
                              },
                              {
                                pos: ',',
                                word: ',',
                                token: {
                                  index: 14,
                                  word: ',',
                                  originalText: ',',
                                  characterOffsetBegin: 1124,
                                  characterOffsetEnd: 1125,
                                  before: '',
                                  after: ' ',
                                  pos: ',',
                                },
                                children: [],
                              },
                              {
                                pos: 'NP',
                                posInfo: {
                                  description: 'Noun Phrase. ',
                                  examples: [],
                                },
                                word: '',
                                children: [
                                  {
                                    pos: 'DT',
                                    posInfo: {
                                      group: 'Determiner',
                                      tag: 'Determiner',
                                      examples: [],
                                    },
                                    word: 'the',
                                    token: {
                                      index: 15,
                                      word: 'the',
                                      originalText: 'the',
                                      characterOffsetBegin: 1126,
                                      characterOffsetEnd: 1129,
                                      before: ' ',
                                      after: ' ',
                                      pos: 'DT',
                                    },
                                    children: [],
                                  },
                                  {
                                    pos: 'NN',
                                    posInfo: {
                                      group: 'Noun, singular or mass',
                                      tag: 'Noun, singular or mass',
                                      examples: [],
                                    },
                                    word: 'text',
                                    token: {
                                      index: 16,
                                      word: 'text',
                                      originalText: 'text',
                                      characterOffsetBegin: 1130,
                                      characterOffsetEnd: 1134,
                                      before: ' ',
                                      after: ' ',
                                      pos: 'NN',
                                    },
                                    children: [],
                                  },
                                ],
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            pos: 'NP',
            posInfo: { description: 'Noun Phrase. ', examples: [] },
            word: '',
            children: [
              {
                pos: 'PRP',
                posInfo: {
                  group: 'Personal pronoun',
                  tag: 'Personal pronoun',
                  examples: [],
                },
                word: 'itself',
                token: {
                  index: 17,
                  word: 'itself',
                  originalText: 'itself',
                  characterOffsetBegin: 1135,
                  characterOffsetEnd: 1141,
                  before: ' ',
                  after: ' ',
                  pos: 'PRP',
                },
                children: [],
              },
            ],
          },
          {
            pos: 'VP',
            posInfo: { description: 'Vereb Phrase. ', examples: [] },
            word: '',
            children: [
              {
                pos: 'VBZ',
                posInfo: {
                  group: 'Verb, 3rd person singular present',
                  tag: 'Verb, 3rd person singular present',
                  examples: [],
                },
                word: 'is',
                token: {
                  index: 18,
                  word: 'is',
                  originalText: 'is',
                  characterOffsetBegin: 1142,
                  characterOffsetEnd: 1144,
                  before: ' ',
                  after: ' ',
                  pos: 'VBZ',
                },
                children: [],
              },
              {
                pos: 'VP',
                posInfo: { description: 'Vereb Phrase. ', examples: [] },
                word: '',
                children: [
                  {
                    pos: 'VBN',
                    posInfo: {
                      group: 'Verb, past participle',
                      tag: 'Verb, past participle',
                      examples: [],
                    },
                    word: 'composed',
                    token: {
                      index: 19,
                      word: 'composed',
                      originalText: 'composed',
                      characterOffsetBegin: 1145,
                      characterOffsetEnd: 1153,
                      before: ' ',
                      after: ' ',
                      pos: 'VBN',
                    },
                    children: [],
                  },
                  {
                    pos: 'ADVP',
                    posInfo: { description: 'Adverb Phrase.', examples: [] },
                    word: '',
                    children: [
                      {
                        pos: 'RB',
                        posInfo: {
                          group: 'Adverb',
                          tag: 'Adverb',
                          examples: [],
                        },
                        word: 'primarily',
                        token: {
                          index: 20,
                          word: 'primarily',
                          originalText: 'primarily',
                          characterOffsetBegin: 1154,
                          characterOffsetEnd: 1163,
                          before: ' ',
                          after: ' ',
                          pos: 'RB',
                        },
                        children: [],
                      },
                    ],
                  },
                  {
                    pos: 'PP',
                    posInfo: {
                      description: 'Prepositional Phrase.',
                      examples: [],
                    },
                    word: '',
                    children: [
                      {
                        pos: 'IN',
                        posInfo: {
                          group: 'Preposition or subordinating conjunction',
                          tag: 'Preposition or subordinating conjunction',
                          examples: [],
                        },
                        word: 'of',
                        token: {
                          index: 21,
                          word: 'of',
                          originalText: 'of',
                          characterOffsetBegin: 1164,
                          characterOffsetEnd: 1166,
                          before: ' ',
                          after: ' ',
                          pos: 'IN',
                        },
                        children: [],
                      },
                      {
                        pos: 'NP',
                        posInfo: { description: 'Noun Phrase. ', examples: [] },
                        word: '',
                        children: [
                          {
                            pos: 'ADJP',
                            posInfo: {
                              description: 'Adjective Phrase.',
                              examples: [],
                            },
                            word: '',
                            children: [
                              {
                                pos: 'JJ',
                                posInfo: {
                                  group: 'Adjective',
                                  tag: 'Adjective',
                                  examples: [],
                                },
                                word: 'syntactic',
                                token: {
                                  index: 22,
                                  word: 'syntactic',
                                  originalText: 'syntactic',
                                  characterOffsetBegin: 1167,
                                  characterOffsetEnd: 1176,
                                  before: ' ',
                                  after: ' ',
                                  pos: 'JJ',
                                },
                                children: [],
                              },
                              {
                                pos: 'CC',
                                posInfo: {
                                  group: 'Coordinating conjunction',
                                  tag: 'Coordinating conjunction',
                                  examples: [],
                                },
                                word: 'and',
                                token: {
                                  index: 23,
                                  word: 'and',
                                  originalText: 'and',
                                  characterOffsetBegin: 1177,
                                  characterOffsetEnd: 1180,
                                  before: ' ',
                                  after: ' ',
                                  pos: 'CC',
                                },
                                children: [],
                              },
                              {
                                pos: 'JJ',
                                posInfo: {
                                  group: 'Adjective',
                                  tag: 'Adjective',
                                  examples: [],
                                },
                                word: 'lexical',
                                token: {
                                  index: 24,
                                  word: 'lexical',
                                  originalText: 'lexical',
                                  characterOffsetBegin: 1181,
                                  characterOffsetEnd: 1188,
                                  before: ' ',
                                  after: ' ',
                                  pos: 'JJ',
                                },
                                children: [],
                              },
                            ],
                          },
                          {
                            pos: 'NNS',
                            posInfo: {
                              group: 'Noun, plural',
                              tag: 'Noun, plural',
                              examples: [],
                            },
                            word: 'chunks',
                            token: {
                              index: 25,
                              word: 'chunks',
                              originalText: 'chunks',
                              characterOffsetBegin: 1189,
                              characterOffsetEnd: 1195,
                              before: ' ',
                              after: '',
                              pos: 'NNS',
                            },
                            children: [],
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            pos: '.',
            word: '.',
            token: {
              index: 26,
              word: '.',
              originalText: '.',
              characterOffsetBegin: 1195,
              characterOffsetEnd: 1196,
              before: '',
              after: ' ',
              pos: '.',
            },
            children: [],
          },
        ],
      },
    ],
  },
  {
    pos: 'ROOT',
    word: '',
    children: [
      {
        pos: 'SBARQ',
        posInfo: {
          description:
            'Direct question introduced by a wh-word or a wh-phrase. Indirect questions and relative clauses should be bracketed as SBAR, not SBARQ.',
          examples: [],
        },
        word: '',
        children: [
          {
            pos: 'RB',
            posInfo: { group: 'Adverb', tag: 'Adverb', examples: [] },
            word: 'So',
            token: {
              index: 1,
              word: 'So',
              originalText: 'So',
              characterOffsetBegin: 1197,
              characterOffsetEnd: 1199,
              before: ' ',
              after: ' ',
              pos: 'RB',
            },
            children: [],
          },
          {
            pos: 'WHADVP',
            word: '',
            children: [
              {
                pos: 'WRB',
                posInfo: { group: 'Wh-adverb', tag: 'Wh-adverb', examples: [] },
                word: 'why',
                token: {
                  index: 2,
                  word: 'why',
                  originalText: 'why',
                  characterOffsetBegin: 1200,
                  characterOffsetEnd: 1203,
                  before: ' ',
                  after: ' ',
                  pos: 'WRB',
                },
                children: [],
              },
            ],
          },
          {
            pos: 'SQ',
            posInfo: {
              description:
                'Inverted yes/no question, or main clause of a wh-question, following the wh-phrase in SBARQ.',
              examples: [],
            },
            word: '',
            children: [
              {
                pos: 'VBP',
                posInfo: {
                  group: 'Verb, non-3rd person singular present',
                  tag: 'Verb, non-3rd person singular present',
                  examples: [],
                },
                word: 'are',
                token: {
                  index: 3,
                  word: 'are',
                  originalText: 'are',
                  characterOffsetBegin: 1204,
                  characterOffsetEnd: 1207,
                  before: ' ',
                  after: ' ',
                  pos: 'VBP',
                },
                children: [],
              },
              {
                pos: 'NP',
                posInfo: { description: 'Noun Phrase. ', examples: [] },
                word: '',
                children: [
                  {
                    pos: 'PRP',
                    posInfo: {
                      group: 'Personal pronoun',
                      tag: 'Personal pronoun',
                      examples: [],
                    },
                    word: 'we',
                    token: {
                      index: 4,
                      word: 'we',
                      originalText: 'we',
                      characterOffsetBegin: 1208,
                      characterOffsetEnd: 1210,
                      before: ' ',
                      after: ' ',
                      pos: 'PRP',
                    },
                    children: [],
                  },
                ],
              },
              {
                pos: 'ADJP',
                posInfo: { description: 'Adjective Phrase.', examples: [] },
                word: '',
                children: [
                  {
                    pos: 'RB',
                    posInfo: { group: 'Adverb', tag: 'Adverb', examples: [] },
                    word: 'so',
                    token: {
                      index: 5,
                      word: 'so',
                      originalText: 'so',
                      characterOffsetBegin: 1211,
                      characterOffsetEnd: 1213,
                      before: ' ',
                      after: ' ',
                      pos: 'RB',
                    },
                    children: [],
                  },
                  {
                    pos: 'JJ',
                    posInfo: {
                      group: 'Adjective',
                      tag: 'Adjective',
                      examples: [],
                    },
                    word: 'obsessed',
                    token: {
                      index: 6,
                      word: 'obsessed',
                      originalText: 'obsessed',
                      characterOffsetBegin: 1214,
                      characterOffsetEnd: 1222,
                      before: ' ',
                      after: ' ',
                      pos: 'JJ',
                    },
                    children: [],
                  },
                  {
                    pos: 'PP',
                    posInfo: {
                      description: 'Prepositional Phrase.',
                      examples: [],
                    },
                    word: '',
                    children: [
                      {
                        pos: 'IN',
                        posInfo: {
                          group: 'Preposition or subordinating conjunction',
                          tag: 'Preposition or subordinating conjunction',
                          examples: [],
                        },
                        word: 'about',
                        token: {
                          index: 7,
                          word: 'about',
                          originalText: 'about',
                          characterOffsetBegin: 1223,
                          characterOffsetEnd: 1228,
                          before: ' ',
                          after: ' ',
                          pos: 'IN',
                        },
                        children: [],
                      },
                      {
                        pos: 'NP',
                        posInfo: { description: 'Noun Phrase. ', examples: [] },
                        word: '',
                        children: [
                          {
                            pos: 'NP',
                            posInfo: {
                              description: 'Noun Phrase. ',
                              examples: [],
                            },
                            word: '',
                            children: [
                              {
                                pos: 'NNS',
                                posInfo: {
                                  group: 'Noun, plural',
                                  tag: 'Noun, plural',
                                  examples: [],
                                },
                                word: 'positions',
                                token: {
                                  index: 8,
                                  word: 'positions',
                                  originalText: 'positions',
                                  characterOffsetBegin: 1229,
                                  characterOffsetEnd: 1238,
                                  before: ' ',
                                  after: '',
                                  pos: 'NNS',
                                },
                                children: [],
                              },
                            ],
                          },
                          {
                            pos: ',',
                            word: ',',
                            token: {
                              index: 9,
                              word: ',',
                              originalText: ',',
                              characterOffsetBegin: 1238,
                              characterOffsetEnd: 1239,
                              before: '',
                              after: ' ',
                              pos: ',',
                            },
                            children: [],
                          },
                          {
                            pos: 'ADVP',
                            posInfo: {
                              description: 'Adverb Phrase.',
                              examples: [],
                            },
                            word: '',
                            children: [
                              {
                                pos: 'RB',
                                posInfo: {
                                  group: 'Adverb',
                                  tag: 'Adverb',
                                  examples: [],
                                },
                                word: 'then',
                                token: {
                                  index: 10,
                                  word: 'then',
                                  originalText: 'then',
                                  characterOffsetBegin: 1240,
                                  characterOffsetEnd: 1244,
                                  before: ' ',
                                  after: '',
                                  pos: 'RB',
                                },
                                children: [],
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            pos: '.',
            word: '?',
            token: {
              index: 11,
              word: '?',
              originalText: '?',
              characterOffsetBegin: 1244,
              characterOffsetEnd: 1245,
              before: '',
              after: ' ',
              pos: '.',
            },
            children: [],
          },
        ],
      },
    ],
  },
  {
    pos: 'ROOT',
    word: '',
    children: [
      {
        pos: 'SQ',
        posInfo: {
          description:
            'Inverted yes/no question, or main clause of a wh-question, following the wh-phrase in SBARQ.',
          examples: [],
        },
        word: '',
        children: [
          {
            pos: 'VBZ',
            posInfo: {
              group: 'Verb, 3rd person singular present',
              tag: 'Verb, 3rd person singular present',
              examples: [],
            },
            word: 'Is',
            token: {
              index: 1,
              word: 'Is',
              originalText: 'Is',
              characterOffsetBegin: 1246,
              characterOffsetEnd: 1248,
              before: ' ',
              after: ' ',
              pos: 'VBZ',
            },
            children: [],
          },
          {
            pos: 'NP',
            posInfo: { description: 'Noun Phrase. ', examples: [] },
            word: '',
            children: [
              {
                pos: 'PRP',
                posInfo: {
                  group: 'Personal pronoun',
                  tag: 'Personal pronoun',
                  examples: [],
                },
                word: 'it',
                token: {
                  index: 2,
                  word: 'it',
                  originalText: 'it',
                  characterOffsetBegin: 1249,
                  characterOffsetEnd: 1251,
                  before: ' ',
                  after: ' ',
                  pos: 'PRP',
                },
                children: [],
              },
            ],
          },
          {
            pos: 'ADJP',
            posInfo: { description: 'Adjective Phrase.', examples: [] },
            word: '',
            children: [
              {
                pos: 'JJ',
                posInfo: { group: 'Adjective', tag: 'Adjective', examples: [] },
                word: 'possible',
                token: {
                  index: 3,
                  word: 'possible',
                  originalText: 'possible',
                  characterOffsetBegin: 1252,
                  characterOffsetEnd: 1260,
                  before: ' ',
                  after: ' ',
                  pos: 'JJ',
                },
                children: [],
              },
              {
                pos: 'CC',
                posInfo: {
                  group: 'Coordinating conjunction',
                  tag: 'Coordinating conjunction',
                  examples: [],
                },
                word: 'and',
                token: {
                  index: 4,
                  word: 'and',
                  originalText: 'and',
                  characterOffsetBegin: 1261,
                  characterOffsetEnd: 1264,
                  before: ' ',
                  after: ' ',
                  pos: 'CC',
                },
                children: [],
              },
              {
                pos: 'JJ',
                posInfo: { group: 'Adjective', tag: 'Adjective', examples: [] },
                word: 'useful',
                token: {
                  index: 5,
                  word: 'useful',
                  originalText: 'useful',
                  characterOffsetBegin: 1265,
                  characterOffsetEnd: 1271,
                  before: ' ',
                  after: ' ',
                  pos: 'JJ',
                },
                children: [],
              },
            ],
          },
          {
            pos: 'S',
            posInfo: {
              description:
                'simple declarative clause, i.e. one that is not introduced by a (possible empty) subordinating conjunction or a wh-word and that does not exhibit subject-verb inversion.',
              examples: [],
            },
            word: '',
            children: [
              {
                pos: 'VP',
                posInfo: { description: 'Vereb Phrase. ', examples: [] },
                word: '',
                children: [
                  {
                    pos: 'TO',
                    posInfo: { group: 'to', tag: 'to', examples: [] },
                    word: 'to',
                    token: {
                      index: 6,
                      word: 'to',
                      originalText: 'to',
                      characterOffsetBegin: 1272,
                      characterOffsetEnd: 1274,
                      before: ' ',
                      after: ' ',
                      pos: 'TO',
                    },
                    children: [],
                  },
                  {
                    pos: 'VP',
                    posInfo: { description: 'Vereb Phrase. ', examples: [] },
                    word: '',
                    children: [
                      {
                        pos: 'VB',
                        posInfo: {
                          group: 'Verb, base form',
                          tag: 'Verb, base form',
                          examples: [],
                        },
                        word: 'select',
                        token: {
                          index: 7,
                          word: 'select',
                          originalText: 'select',
                          characterOffsetBegin: 1275,
                          characterOffsetEnd: 1281,
                          before: ' ',
                          after: ' ',
                          pos: 'VB',
                        },
                        children: [],
                      },
                      {
                        pos: 'NP',
                        posInfo: { description: 'Noun Phrase. ', examples: [] },
                        word: '',
                        children: [
                          {
                            pos: 'NN',
                            posInfo: {
                              group: 'Noun, singular or mass',
                              tag: 'Noun, singular or mass',
                              examples: [],
                            },
                            word: 'text',
                            token: {
                              index: 8,
                              word: 'text',
                              originalText: 'text',
                              characterOffsetBegin: 1282,
                              characterOffsetEnd: 1286,
                              before: ' ',
                              after: ' ',
                              pos: 'NN',
                            },
                            children: [],
                          },
                        ],
                      },
                      {
                        pos: 'PP',
                        posInfo: {
                          description: 'Prepositional Phrase.',
                          examples: [],
                        },
                        word: '',
                        children: [
                          {
                            pos: 'IN',
                            posInfo: {
                              group: 'Preposition or subordinating conjunction',
                              tag: 'Preposition or subordinating conjunction',
                              examples: [],
                            },
                            word: 'by',
                            token: {
                              index: 9,
                              word: 'by',
                              originalText: 'by',
                              characterOffsetBegin: 1287,
                              characterOffsetEnd: 1289,
                              before: ' ',
                              after: ' ',
                              pos: 'IN',
                            },
                            children: [],
                          },
                          {
                            pos: 'S',
                            posInfo: {
                              description:
                                'simple declarative clause, i.e. one that is not introduced by a (possible empty) subordinating conjunction or a wh-word and that does not exhibit subject-verb inversion.',
                              examples: [],
                            },
                            word: '',
                            children: [
                              {
                                pos: 'VP',
                                posInfo: {
                                  description: 'Vereb Phrase. ',
                                  examples: [],
                                },
                                word: '',
                                children: [
                                  {
                                    pos: 'VBG',
                                    posInfo: {
                                      group:
                                        'Verb, gerund or present participle',
                                      tag: 'Verb, gerund or present participle',
                                      examples: [],
                                    },
                                    word: 'focusing',
                                    token: {
                                      index: 10,
                                      word: 'focusing',
                                      originalText: 'focusing',
                                      characterOffsetBegin: 1290,
                                      characterOffsetEnd: 1298,
                                      before: ' ',
                                      after: ' ',
                                      pos: 'VBG',
                                    },
                                    children: [],
                                  },
                                  {
                                    pos: 'PP',
                                    posInfo: {
                                      description: 'Prepositional Phrase.',
                                      examples: [],
                                    },
                                    word: '',
                                    children: [
                                      {
                                        pos: 'PP',
                                        posInfo: {
                                          description: 'Prepositional Phrase.',
                                          examples: [],
                                        },
                                        word: '',
                                        children: [
                                          {
                                            pos: 'RBR',
                                            posInfo: {
                                              group: 'Adverb, comparative',
                                              tag: 'Adverb, comparative',
                                              examples: [],
                                            },
                                            word: 'more',
                                            token: {
                                              index: 11,
                                              word: 'more',
                                              originalText: 'more',
                                              characterOffsetBegin: 1299,
                                              characterOffsetEnd: 1303,
                                              before: ' ',
                                              after: ' ',
                                              pos: 'RBR',
                                            },
                                            children: [],
                                          },
                                          {
                                            pos: 'IN',
                                            posInfo: {
                                              group:
                                                'Preposition or subordinating conjunction',
                                              tag: 'Preposition or subordinating conjunction',
                                              examples: [],
                                            },
                                            word: 'on',
                                            token: {
                                              index: 12,
                                              word: 'on',
                                              originalText: 'on',
                                              characterOffsetBegin: 1304,
                                              characterOffsetEnd: 1306,
                                              before: ' ',
                                              after: ' ',
                                              pos: 'IN',
                                            },
                                            children: [],
                                          },
                                          {
                                            pos: 'NP',
                                            posInfo: {
                                              description: 'Noun Phrase. ',
                                              examples: [],
                                            },
                                            word: '',
                                            children: [
                                              {
                                                pos: 'NP',
                                                posInfo: {
                                                  description: 'Noun Phrase. ',
                                                  examples: [],
                                                },
                                                word: '',
                                                children: [
                                                  {
                                                    pos: 'PRP$',
                                                    posInfo: {
                                                      group:
                                                        'Possessive pronoun (prolog version PRP-S)',
                                                      tag: 'Possessive pronoun (prolog version PRP-S)',
                                                      examples: [],
                                                    },
                                                    word: 'its',
                                                    token: {
                                                      index: 13,
                                                      word: 'its',
                                                      originalText: 'its',
                                                      characterOffsetBegin: 1307,
                                                      characterOffsetEnd: 1310,
                                                      before: ' ',
                                                      after: ' ',
                                                      pos: 'PRP$',
                                                    },
                                                    children: [],
                                                  },
                                                  {
                                                    pos: 'JJ',
                                                    posInfo: {
                                                      group: 'Adjective',
                                                      tag: 'Adjective',
                                                      examples: [],
                                                    },
                                                    word: 'primary',
                                                    token: {
                                                      index: 14,
                                                      word: 'primary',
                                                      originalText: 'primary',
                                                      characterOffsetBegin: 1311,
                                                      characterOffsetEnd: 1318,
                                                      before: ' ',
                                                      after: ' ',
                                                      pos: 'JJ',
                                                    },
                                                    children: [],
                                                  },
                                                  {
                                                    pos: 'NNS',
                                                    posInfo: {
                                                      group: 'Noun, plural',
                                                      tag: 'Noun, plural',
                                                      examples: [],
                                                    },
                                                    word: 'structures',
                                                    token: {
                                                      index: 15,
                                                      word: 'structures',
                                                      originalText:
                                                        'structures',
                                                      characterOffsetBegin: 1319,
                                                      characterOffsetEnd: 1329,
                                                      before: ' ',
                                                      after: ' ',
                                                      pos: 'NNS',
                                                    },
                                                    children: [],
                                                  },
                                                ],
                                              },
                                              {
                                                pos: 'SBAR',
                                                posInfo: {
                                                  description:
                                                    'Clause introduced by a (possibly empty) subordinating conjunction.',
                                                  examples: [],
                                                },
                                                word: '',
                                                children: [
                                                  {
                                                    pos: 'WHNP',
                                                    posInfo: {
                                                      description:
                                                        'Wh-noun Phrase. Introduces a clause with an NP gap. May be null (containing the 0 complementizer) or lexical, containing some wh-word, e.g. who, which book, whose daughter, none of which, or how many leopards.',
                                                      examples: [],
                                                    },
                                                    word: '',
                                                    children: [
                                                      {
                                                        pos: 'WDT',
                                                        posInfo: {
                                                          group:
                                                            'Wh-determiner',
                                                          tag: 'Wh-determiner',
                                                          examples: [],
                                                        },
                                                        word: 'that',
                                                        token: {
                                                          index: 16,
                                                          word: 'that',
                                                          originalText: 'that',
                                                          characterOffsetBegin: 1330,
                                                          characterOffsetEnd: 1334,
                                                          before: ' ',
                                                          after: ' ',
                                                          pos: 'WDT',
                                                        },
                                                        children: [],
                                                      },
                                                    ],
                                                  },
                                                  {
                                                    pos: 'S',
                                                    posInfo: {
                                                      description:
                                                        'simple declarative clause, i.e. one that is not introduced by a (possible empty) subordinating conjunction or a wh-word and that does not exhibit subject-verb inversion.',
                                                      examples: [],
                                                    },
                                                    word: '',
                                                    children: [
                                                      {
                                                        pos: 'VP',
                                                        posInfo: {
                                                          description:
                                                            'Vereb Phrase. ',
                                                          examples: [],
                                                        },
                                                        word: '',
                                                        children: [
                                                          {
                                                            pos: 'VBP',
                                                            posInfo: {
                                                              group:
                                                                'Verb, non-3rd person singular present',
                                                              tag: 'Verb, non-3rd person singular present',
                                                              examples: [],
                                                            },
                                                            word: 'represent',
                                                            token: {
                                                              index: 17,
                                                              word: 'represent',
                                                              originalText:
                                                                'represent',
                                                              characterOffsetBegin: 1335,
                                                              characterOffsetEnd: 1344,
                                                              before: ' ',
                                                              after: ' ',
                                                              pos: 'VBP',
                                                            },
                                                            children: [],
                                                          },
                                                          {
                                                            pos: 'NP',
                                                            posInfo: {
                                                              description:
                                                                'Noun Phrase. ',
                                                              examples: [],
                                                            },
                                                            word: '',
                                                            children: [
                                                              {
                                                                pos: 'NNS',
                                                                posInfo: {
                                                                  group:
                                                                    'Noun, plural',
                                                                  tag: 'Noun, plural',
                                                                  examples: [],
                                                                },
                                                                word: 'meanings',
                                                                token: {
                                                                  index: 18,
                                                                  word: 'meanings',
                                                                  originalText:
                                                                    'meanings',
                                                                  characterOffsetBegin: 1345,
                                                                  characterOffsetEnd: 1353,
                                                                  before: ' ',
                                                                  after: '',
                                                                  pos: 'NNS',
                                                                },
                                                                children: [],
                                                              },
                                                            ],
                                                          },
                                                        ],
                                                      },
                                                    ],
                                                  },
                                                ],
                                              },
                                            ],
                                          },
                                        ],
                                      },
                                      {
                                        pos: ',',
                                        word: ',',
                                        token: {
                                          index: 19,
                                          word: ',',
                                          originalText: ',',
                                          characterOffsetBegin: 1353,
                                          characterOffsetEnd: 1354,
                                          before: '',
                                          after: ' ',
                                          pos: ',',
                                        },
                                        children: [],
                                      },
                                      {
                                        pos: 'CC',
                                        posInfo: {
                                          group: 'Coordinating conjunction',
                                          tag: 'Coordinating conjunction',
                                          examples: [],
                                        },
                                        word: 'and',
                                        token: {
                                          index: 20,
                                          word: 'and',
                                          originalText: 'and',
                                          characterOffsetBegin: 1355,
                                          characterOffsetEnd: 1358,
                                          before: ' ',
                                          after: ' ',
                                          pos: 'CC',
                                        },
                                        children: [],
                                      },
                                      {
                                        pos: 'PP',
                                        posInfo: {
                                          description: 'Prepositional Phrase.',
                                          examples: [],
                                        },
                                        word: '',
                                        children: [
                                          {
                                            pos: 'ADVP',
                                            posInfo: {
                                              description: 'Adverb Phrase.',
                                              examples: [],
                                            },
                                            word: '',
                                            children: [
                                              {
                                                pos: 'RBR',
                                                posInfo: {
                                                  group: 'Adverb, comparative',
                                                  tag: 'Adverb, comparative',
                                                  examples: [],
                                                },
                                                word: 'less',
                                                token: {
                                                  index: 21,
                                                  word: 'less',
                                                  originalText: 'less',
                                                  characterOffsetBegin: 1359,
                                                  characterOffsetEnd: 1363,
                                                  before: ' ',
                                                  after: ' ',
                                                  pos: 'RBR',
                                                },
                                                children: [],
                                              },
                                            ],
                                          },
                                          {
                                            pos: 'IN',
                                            posInfo: {
                                              group:
                                                'Preposition or subordinating conjunction',
                                              tag: 'Preposition or subordinating conjunction',
                                              examples: [],
                                            },
                                            word: 'on',
                                            token: {
                                              index: 22,
                                              word: 'on',
                                              originalText: 'on',
                                              characterOffsetBegin: 1364,
                                              characterOffsetEnd: 1366,
                                              before: ' ',
                                              after: ' ',
                                              pos: 'IN',
                                            },
                                            children: [],
                                          },
                                          {
                                            pos: 'NP',
                                            posInfo: {
                                              description: 'Noun Phrase. ',
                                              examples: [],
                                            },
                                            word: '',
                                            children: [
                                              {
                                                pos: 'NP',
                                                posInfo: {
                                                  description: 'Noun Phrase. ',
                                                  examples: [],
                                                },
                                                word: '',
                                                children: [
                                                  {
                                                    pos: 'PRP$',
                                                    posInfo: {
                                                      group:
                                                        'Possessive pronoun (prolog version PRP-S)',
                                                      tag: 'Possessive pronoun (prolog version PRP-S)',
                                                      examples: [],
                                                    },
                                                    word: 'its',
                                                    token: {
                                                      index: 23,
                                                      word: 'its',
                                                      originalText: 'its',
                                                      characterOffsetBegin: 1367,
                                                      characterOffsetEnd: 1370,
                                                      before: ' ',
                                                      after: ' ',
                                                      pos: 'PRP$',
                                                    },
                                                    children: [],
                                                  },
                                                  {
                                                    pos: 'JJ',
                                                    posInfo: {
                                                      group: 'Adjective',
                                                      tag: 'Adjective',
                                                      examples: [],
                                                    },
                                                    word: 'representational',
                                                    token: {
                                                      index: 24,
                                                      word: 'representational',
                                                      originalText:
                                                        'representational',
                                                      characterOffsetBegin: 1371,
                                                      characterOffsetEnd: 1387,
                                                      before: ' ',
                                                      after: ' ',
                                                      pos: 'JJ',
                                                    },
                                                    children: [],
                                                  },
                                                  {
                                                    pos: 'NNS',
                                                    posInfo: {
                                                      group: 'Noun, plural',
                                                      tag: 'Noun, plural',
                                                      examples: [],
                                                    },
                                                    word: 'structures',
                                                    token: {
                                                      index: 25,
                                                      word: 'structures',
                                                      originalText:
                                                        'structures',
                                                      characterOffsetBegin: 1388,
                                                      characterOffsetEnd: 1398,
                                                      before: ' ',
                                                      after: ' ',
                                                      pos: 'NNS',
                                                    },
                                                    children: [],
                                                  },
                                                ],
                                              },
                                              {
                                                pos: 'PP',
                                                posInfo: {
                                                  description:
                                                    'Prepositional Phrase.',
                                                  examples: [],
                                                },
                                                word: '',
                                                children: [
                                                  {
                                                    pos: 'VBN',
                                                    posInfo: {
                                                      group:
                                                        'Verb, past participle',
                                                      tag: 'Verb, past participle',
                                                      examples: [],
                                                    },
                                                    word: 'based',
                                                    token: {
                                                      index: 26,
                                                      word: 'based',
                                                      originalText: 'based',
                                                      characterOffsetBegin: 1399,
                                                      characterOffsetEnd: 1404,
                                                      before: ' ',
                                                      after: ' ',
                                                      pos: 'VBN',
                                                    },
                                                    children: [],
                                                  },
                                                  {
                                                    pos: 'PP',
                                                    posInfo: {
                                                      description:
                                                        'Prepositional Phrase.',
                                                      examples: [],
                                                    },
                                                    word: '',
                                                    children: [
                                                      {
                                                        pos: 'IN',
                                                        posInfo: {
                                                          group:
                                                            'Preposition or subordinating conjunction',
                                                          tag: 'Preposition or subordinating conjunction',
                                                          examples: [],
                                                        },
                                                        word: 'on',
                                                        token: {
                                                          index: 27,
                                                          word: 'on',
                                                          originalText: 'on',
                                                          characterOffsetBegin: 1405,
                                                          characterOffsetEnd: 1407,
                                                          before: ' ',
                                                          after: ' ',
                                                          pos: 'IN',
                                                        },
                                                        children: [],
                                                      },
                                                      {
                                                        pos: 'NP',
                                                        posInfo: {
                                                          description:
                                                            'Noun Phrase. ',
                                                          examples: [],
                                                        },
                                                        word: '',
                                                        children: [
                                                          {
                                                            pos: 'NNS',
                                                            posInfo: {
                                                              group:
                                                                'Noun, plural',
                                                              tag: 'Noun, plural',
                                                              examples: [],
                                                            },
                                                            word: 'positions',
                                                            token: {
                                                              index: 28,
                                                              word: 'positions',
                                                              originalText:
                                                                'positions',
                                                              characterOffsetBegin: 1408,
                                                              characterOffsetEnd: 1417,
                                                              before: ' ',
                                                              after: '',
                                                              pos: 'NNS',
                                                            },
                                                            children: [],
                                                          },
                                                        ],
                                                      },
                                                    ],
                                                  },
                                                ],
                                              },
                                            ],
                                          },
                                        ],
                                      },
                                    ],
                                  },
                                ],
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            pos: '.',
            word: '?',
            token: {
              index: 29,
              word: '?',
              originalText: '?',
              characterOffsetBegin: 1417,
              characterOffsetEnd: 1418,
              before: '',
              after: ' ',
              pos: '.',
            },
            children: [],
          },
        ],
      },
    ],
  },
  {
    pos: 'ROOT',
    word: '',
    children: [
      {
        pos: 'S',
        posInfo: {
          description:
            'simple declarative clause, i.e. one that is not introduced by a (possible empty) subordinating conjunction or a wh-word and that does not exhibit subject-verb inversion.',
          examples: [],
        },
        word: '',
        children: [
          {
            pos: 'NP',
            posInfo: { description: 'Noun Phrase. ', examples: [] },
            word: '',
            children: [
              {
                pos: 'DT',
                posInfo: {
                  group: 'Determiner',
                  tag: 'Determiner',
                  examples: [],
                },
                word: 'This',
                token: {
                  index: 1,
                  word: 'This',
                  originalText: 'This',
                  characterOffsetBegin: 1419,
                  characterOffsetEnd: 1423,
                  before: ' ',
                  after: ' ',
                  pos: 'DT',
                },
                children: [],
              },
              {
                pos: 'NN',
                posInfo: {
                  group: 'Noun, singular or mass',
                  tag: 'Noun, singular or mass',
                  examples: [],
                },
                word: 'paper',
                token: {
                  index: 2,
                  word: 'paper',
                  originalText: 'paper',
                  characterOffsetBegin: 1424,
                  characterOffsetEnd: 1429,
                  before: ' ',
                  after: ' ',
                  pos: 'NN',
                },
                children: [],
              },
            ],
          },
          {
            pos: 'VP',
            posInfo: { description: 'Vereb Phrase. ', examples: [] },
            word: '',
            children: [
              {
                pos: 'VBZ',
                posInfo: {
                  group: 'Verb, 3rd person singular present',
                  tag: 'Verb, 3rd person singular present',
                  examples: [],
                },
                word: 'treads',
                token: {
                  index: 3,
                  word: 'treads',
                  originalText: 'treads',
                  characterOffsetBegin: 1430,
                  characterOffsetEnd: 1436,
                  before: ' ',
                  after: ' ',
                  pos: 'VBZ',
                },
                children: [],
              },
              {
                pos: 'NP',
                posInfo: { description: 'Noun Phrase. ', examples: [] },
                word: '',
                children: [
                  {
                    pos: 'DT',
                    posInfo: {
                      group: 'Determiner',
                      tag: 'Determiner',
                      examples: [],
                    },
                    word: 'the',
                    token: {
                      index: 4,
                      word: 'the',
                      originalText: 'the',
                      characterOffsetBegin: 1437,
                      characterOffsetEnd: 1440,
                      before: ' ',
                      after: ' ',
                      pos: 'DT',
                    },
                    children: [],
                  },
                  {
                    pos: 'JJ',
                    posInfo: {
                      group: 'Adjective',
                      tag: 'Adjective',
                      examples: [],
                    },
                    word: 'first',
                    token: {
                      index: 5,
                      word: 'first',
                      originalText: 'first',
                      characterOffsetBegin: 1441,
                      characterOffsetEnd: 1446,
                      before: ' ',
                      after: ' ',
                      pos: 'JJ',
                    },
                    children: [],
                  },
                  {
                    pos: 'NN',
                    posInfo: {
                      group: 'Noun, singular or mass',
                      tag: 'Noun, singular or mass',
                      examples: [],
                    },
                    word: 'step',
                    token: {
                      index: 6,
                      word: 'step',
                      originalText: 'step',
                      characterOffsetBegin: 1447,
                      characterOffsetEnd: 1451,
                      before: ' ',
                      after: ' ',
                      pos: 'NN',
                    },
                    children: [],
                  },
                ],
              },
              {
                pos: 'PP',
                posInfo: { description: 'Prepositional Phrase.', examples: [] },
                word: '',
                children: [
                  {
                    pos: 'IN',
                    posInfo: {
                      group: 'Preposition or subordinating conjunction',
                      tag: 'Preposition or subordinating conjunction',
                      examples: [],
                    },
                    word: 'toward',
                    token: {
                      index: 7,
                      word: 'toward',
                      originalText: 'toward',
                      characterOffsetBegin: 1452,
                      characterOffsetEnd: 1458,
                      before: ' ',
                      after: ' ',
                      pos: 'IN',
                    },
                    children: [],
                  },
                  {
                    pos: 'S',
                    posInfo: {
                      description:
                        'simple declarative clause, i.e. one that is not introduced by a (possible empty) subordinating conjunction or a wh-word and that does not exhibit subject-verb inversion.',
                      examples: [],
                    },
                    word: '',
                    children: [
                      {
                        pos: 'VP',
                        posInfo: {
                          description: 'Vereb Phrase. ',
                          examples: [],
                        },
                        word: '',
                        children: [
                          {
                            pos: 'VBG',
                            posInfo: {
                              group: 'Verb, gerund or present participle',
                              tag: 'Verb, gerund or present participle',
                              examples: [],
                            },
                            word: 'exploring',
                            token: {
                              index: 8,
                              word: 'exploring',
                              originalText: 'exploring',
                              characterOffsetBegin: 1459,
                              characterOffsetEnd: 1468,
                              before: ' ',
                              after: ' ',
                              pos: 'VBG',
                            },
                            children: [],
                          },
                          {
                            pos: 'NP',
                            posInfo: {
                              description: 'Noun Phrase. ',
                              examples: [],
                            },
                            word: '',
                            children: [
                              {
                                pos: 'DT',
                                posInfo: {
                                  group: 'Determiner',
                                  tag: 'Determiner',
                                  examples: [],
                                },
                                word: 'these',
                                token: {
                                  index: 9,
                                  word: 'these',
                                  originalText: 'these',
                                  characterOffsetBegin: 1469,
                                  characterOffsetEnd: 1474,
                                  before: ' ',
                                  after: ' ',
                                  pos: 'DT',
                                },
                                children: [],
                              },
                              {
                                pos: 'NNS',
                                posInfo: {
                                  group: 'Noun, plural',
                                  tag: 'Noun, plural',
                                  examples: [],
                                },
                                word: 'questions',
                                token: {
                                  index: 10,
                                  word: 'questions',
                                  originalText: 'questions',
                                  characterOffsetBegin: 1475,
                                  characterOffsetEnd: 1484,
                                  before: ' ',
                                  after: '',
                                  pos: 'NNS',
                                },
                                children: [],
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            pos: '.',
            word: '.',
            token: {
              index: 11,
              word: '.',
              originalText: '.',
              characterOffsetBegin: 1484,
              characterOffsetEnd: 1485,
              before: '',
              after: ' ',
              pos: '.',
            },
            children: [],
          },
        ],
      },
    ],
  },
  {
    pos: 'ROOT',
    word: '',
    children: [
      {
        pos: 'S',
        posInfo: {
          description:
            'simple declarative clause, i.e. one that is not introduced by a (possible empty) subordinating conjunction or a wh-word and that does not exhibit subject-verb inversion.',
          examples: [],
        },
        word: '',
        children: [
          {
            pos: 'NP',
            posInfo: { description: 'Noun Phrase. ', examples: [] },
            word: '',
            children: [
              {
                pos: 'PRP',
                posInfo: {
                  group: 'Personal pronoun',
                  tag: 'Personal pronoun',
                  examples: [],
                },
                word: 'We',
                token: {
                  index: 1,
                  word: 'We',
                  originalText: 'We',
                  characterOffsetBegin: 1486,
                  characterOffsetEnd: 1488,
                  before: ' ',
                  after: ' ',
                  pos: 'PRP',
                },
                children: [],
              },
            ],
          },
          {
            pos: 'VP',
            posInfo: { description: 'Vereb Phrase. ', examples: [] },
            word: '',
            children: [
              {
                pos: 'VBP',
                posInfo: {
                  group: 'Verb, non-3rd person singular present',
                  tag: 'Verb, non-3rd person singular present',
                  examples: [],
                },
                word: 'propose',
                token: {
                  index: 2,
                  word: 'propose',
                  originalText: 'propose',
                  characterOffsetBegin: 1489,
                  characterOffsetEnd: 1496,
                  before: ' ',
                  after: ' ',
                  pos: 'VBP',
                },
                children: [],
              },
              {
                pos: 'NP',
                posInfo: { description: 'Noun Phrase. ', examples: [] },
                word: '',
                children: [
                  {
                    pos: 'NP',
                    posInfo: { description: 'Noun Phrase. ', examples: [] },
                    word: '',
                    children: [
                      {
                        pos: 'DT',
                        posInfo: {
                          group: 'Determiner',
                          tag: 'Determiner',
                          examples: [],
                        },
                        word: 'a',
                        token: {
                          index: 3,
                          word: 'a',
                          originalText: 'a',
                          characterOffsetBegin: 1497,
                          characterOffsetEnd: 1498,
                          before: ' ',
                          after: ' ',
                          pos: 'DT',
                        },
                        children: [],
                      },
                      {
                        pos: 'JJ',
                        posInfo: {
                          group: 'Adjective',
                          tag: 'Adjective',
                          examples: [],
                        },
                        word: 'conceptual',
                        token: {
                          index: 4,
                          word: 'conceptual',
                          originalText: 'conceptual',
                          characterOffsetBegin: 1499,
                          characterOffsetEnd: 1509,
                          before: ' ',
                          after: ' ',
                          pos: 'JJ',
                        },
                        children: [],
                      },
                      {
                        pos: 'NN',
                        posInfo: {
                          group: 'Noun, singular or mass',
                          tag: 'Noun, singular or mass',
                          examples: [],
                        },
                        word: 'shift',
                        token: {
                          index: 5,
                          word: 'shift',
                          originalText: 'shift',
                          characterOffsetBegin: 1510,
                          characterOffsetEnd: 1515,
                          before: ' ',
                          after: ' ',
                          pos: 'NN',
                        },
                        children: [],
                      },
                    ],
                  },
                  {
                    pos: 'PP',
                    posInfo: {
                      description: 'Prepositional Phrase.',
                      examples: [],
                    },
                    word: '',
                    children: [
                      {
                        pos: 'IN',
                        posInfo: {
                          group: 'Preposition or subordinating conjunction',
                          tag: 'Preposition or subordinating conjunction',
                          examples: [],
                        },
                        word: 'for',
                        token: {
                          index: 6,
                          word: 'for',
                          originalText: 'for',
                          characterOffsetBegin: 1516,
                          characterOffsetEnd: 1519,
                          before: ' ',
                          after: ' ',
                          pos: 'IN',
                        },
                        children: [],
                      },
                      {
                        pos: 'NP',
                        posInfo: { description: 'Noun Phrase. ', examples: [] },
                        word: '',
                        children: [
                          {
                            pos: 'NN',
                            posInfo: {
                              group: 'Noun, singular or mass',
                              tag: 'Noun, singular or mass',
                              examples: [],
                            },
                            word: 'text',
                            token: {
                              index: 7,
                              word: 'text',
                              originalText: 'text',
                              characterOffsetBegin: 1520,
                              characterOffsetEnd: 1524,
                              before: ' ',
                              after: ' ',
                              pos: 'NN',
                            },
                            children: [],
                          },
                          {
                            pos: 'NN',
                            posInfo: {
                              group: 'Noun, singular or mass',
                              tag: 'Noun, singular or mass',
                              examples: [],
                            },
                            word: 'selection',
                            token: {
                              index: 8,
                              word: 'selection',
                              originalText: 'selection',
                              characterOffsetBegin: 1525,
                              characterOffsetEnd: 1534,
                              before: ' ',
                              after: '',
                              pos: 'NN',
                            },
                            children: [],
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                pos: ',',
                word: ',',
                token: {
                  index: 9,
                  word: ',',
                  originalText: ',',
                  characterOffsetBegin: 1534,
                  characterOffsetEnd: 1535,
                  before: '',
                  after: ' ',
                  pos: ',',
                },
                children: [],
              },
              {
                pos: 'S',
                posInfo: {
                  description:
                    'simple declarative clause, i.e. one that is not introduced by a (possible empty) subordinating conjunction or a wh-word and that does not exhibit subject-verb inversion.',
                  examples: [],
                },
                word: '',
                children: [
                  {
                    pos: 'VP',
                    posInfo: { description: 'Vereb Phrase. ', examples: [] },
                    word: '',
                    children: [
                      {
                        pos: 'TO',
                        posInfo: { group: 'to', tag: 'to', examples: [] },
                        word: 'to',
                        token: {
                          index: 10,
                          word: 'to',
                          originalText: 'to',
                          characterOffsetBegin: 1536,
                          characterOffsetEnd: 1538,
                          before: ' ',
                          after: ' ',
                          pos: 'TO',
                        },
                        children: [],
                      },
                      {
                        pos: 'VP',
                        posInfo: {
                          description: 'Vereb Phrase. ',
                          examples: [],
                        },
                        word: '',
                        children: [
                          {
                            pos: 'VB',
                            posInfo: {
                              group: 'Verb, base form',
                              tag: 'Verb, base form',
                              examples: [],
                            },
                            word: 'support',
                            token: {
                              index: 11,
                              word: 'support',
                              originalText: 'support',
                              characterOffsetBegin: 1539,
                              characterOffsetEnd: 1546,
                              before: ' ',
                              after: ' ',
                              pos: 'VB',
                            },
                            children: [],
                          },
                          {
                            pos: 'NP',
                            posInfo: {
                              description: 'Noun Phrase. ',
                              examples: [],
                            },
                            word: '',
                            children: [
                              {
                                pos: 'NN',
                                posInfo: {
                                  group: 'Noun, singular or mass',
                                  tag: 'Noun, singular or mass',
                                  examples: [],
                                },
                                word: 'user',
                                token: {
                                  index: 12,
                                  word: 'user',
                                  originalText: 'user',
                                  characterOffsetBegin: 1547,
                                  characterOffsetEnd: 1551,
                                  before: ' ',
                                  after: ' ',
                                  pos: 'NN',
                                },
                                children: [],
                              },
                              {
                                pos: 'NN',
                                posInfo: {
                                  group: 'Noun, singular or mass',
                                  tag: 'Noun, singular or mass',
                                  examples: [],
                                },
                                word: 'interaction',
                                token: {
                                  index: 13,
                                  word: 'interaction',
                                  originalText: 'interaction',
                                  characterOffsetBegin: 1552,
                                  characterOffsetEnd: 1563,
                                  before: ' ',
                                  after: ' ',
                                  pos: 'NN',
                                },
                                children: [],
                              },
                            ],
                          },
                          {
                            pos: 'PP',
                            posInfo: {
                              description: 'Prepositional Phrase.',
                              examples: [],
                            },
                            word: '',
                            children: [
                              {
                                pos: 'IN',
                                posInfo: {
                                  group:
                                    'Preposition or subordinating conjunction',
                                  tag: 'Preposition or subordinating conjunction',
                                  examples: [],
                                },
                                word: 'with',
                                token: {
                                  index: 14,
                                  word: 'with',
                                  originalText: 'with',
                                  characterOffsetBegin: 1564,
                                  characterOffsetEnd: 1568,
                                  before: ' ',
                                  after: ' ',
                                  pos: 'IN',
                                },
                                children: [],
                              },
                              {
                                pos: 'NP',
                                posInfo: {
                                  description: 'Noun Phrase. ',
                                  examples: [],
                                },
                                word: '',
                                children: [
                                  {
                                    pos: 'NP',
                                    posInfo: {
                                      description: 'Noun Phrase. ',
                                      examples: [],
                                    },
                                    word: '',
                                    children: [
                                      {
                                        pos: 'PRP$',
                                        posInfo: {
                                          group:
                                            'Possessive pronoun (prolog version PRP-S)',
                                          tag: 'Possessive pronoun (prolog version PRP-S)',
                                          examples: [],
                                        },
                                        word: 'its',
                                        token: {
                                          index: 15,
                                          word: 'its',
                                          originalText: 'its',
                                          characterOffsetBegin: 1569,
                                          characterOffsetEnd: 1572,
                                          before: ' ',
                                          after: ' ',
                                          pos: 'PRP$',
                                        },
                                        children: [],
                                      },
                                      {
                                        pos: 'NNS',
                                        posInfo: {
                                          group: 'Noun, plural',
                                          tag: 'Noun, plural',
                                          examples: [],
                                        },
                                        word: 'meanings',
                                        token: {
                                          index: 16,
                                          word: 'meanings',
                                          originalText: 'meanings',
                                          characterOffsetBegin: 1573,
                                          characterOffsetEnd: 1581,
                                          before: ' ',
                                          after: ' ',
                                          pos: 'NNS',
                                        },
                                        children: [],
                                      },
                                    ],
                                  },
                                  {
                                    pos: 'CONJP',
                                    posInfo: {
                                      description: 'Conjunction Phrase.',
                                      examples: [],
                                    },
                                    word: '',
                                    children: [
                                      {
                                        pos: 'RB',
                                        posInfo: {
                                          group: 'Adverb',
                                          tag: 'Adverb',
                                          examples: [],
                                        },
                                        word: 'rather',
                                        token: {
                                          index: 17,
                                          word: 'rather',
                                          originalText: 'rather',
                                          characterOffsetBegin: 1582,
                                          characterOffsetEnd: 1588,
                                          before: ' ',
                                          after: ' ',
                                          pos: 'RB',
                                        },
                                        children: [],
                                      },
                                      {
                                        pos: 'IN',
                                        posInfo: {
                                          group:
                                            'Preposition or subordinating conjunction',
                                          tag: 'Preposition or subordinating conjunction',
                                          examples: [],
                                        },
                                        word: 'than',
                                        token: {
                                          index: 18,
                                          word: 'than',
                                          originalText: 'than',
                                          characterOffsetBegin: 1589,
                                          characterOffsetEnd: 1593,
                                          before: ' ',
                                          after: ' ',
                                          pos: 'IN',
                                        },
                                        children: [],
                                      },
                                    ],
                                  },
                                  {
                                    pos: 'NP',
                                    posInfo: {
                                      description: 'Noun Phrase. ',
                                      examples: [],
                                    },
                                    word: '',
                                    children: [
                                      {
                                        pos: 'PRP$',
                                        posInfo: {
                                          group:
                                            'Possessive pronoun (prolog version PRP-S)',
                                          tag: 'Possessive pronoun (prolog version PRP-S)',
                                          examples: [],
                                        },
                                        word: 'its',
                                        token: {
                                          index: 19,
                                          word: 'its',
                                          originalText: 'its',
                                          characterOffsetBegin: 1594,
                                          characterOffsetEnd: 1597,
                                          before: ' ',
                                          after: ' ',
                                          pos: 'PRP$',
                                        },
                                        children: [],
                                      },
                                      {
                                        pos: 'JJ',
                                        posInfo: {
                                          group: 'Adjective',
                                          tag: 'Adjective',
                                          examples: [],
                                        },
                                        word: 'graphical',
                                        token: {
                                          index: 20,
                                          word: 'graphical',
                                          originalText: 'graphical',
                                          characterOffsetBegin: 1598,
                                          characterOffsetEnd: 1607,
                                          before: ' ',
                                          after: ' ',
                                          pos: 'JJ',
                                        },
                                        children: [],
                                      },
                                      {
                                        pos: 'NN',
                                        posInfo: {
                                          group: 'Noun, singular or mass',
                                          tag: 'Noun, singular or mass',
                                          examples: [],
                                        },
                                        word: 'positioning',
                                        token: {
                                          index: 21,
                                          word: 'positioning',
                                          originalText: 'positioning',
                                          characterOffsetBegin: 1608,
                                          characterOffsetEnd: 1619,
                                          before: ' ',
                                          after: '',
                                          pos: 'NN',
                                        },
                                        children: [],
                                      },
                                    ],
                                  },
                                ],
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            pos: '.',
            word: '.',
            token: {
              index: 22,
              word: '.',
              originalText: '.',
              characterOffsetBegin: 1619,
              characterOffsetEnd: 1620,
              before: '',
              after: '',
              pos: '.',
            },
            children: [],
          },
        ],
      },
    ],
  },
]

export const hardcodeLevels = [
  2, 2, 2, 3, 3, 5, 5, 5, 5, 6, 7, 9, 9, 9, 10, 10, 8, 9, 9, 9, 1, 3, 3, 3, 4,
  5, 7, 8, 8, 1, 1, 3, 3, 3, 3, 4, 5, 7, 7, 7, 8, 9, 9, 1, 2, 2, 3, 4, 5, 5, 3,
  5, 5, 5, 5, 5, 6, 9, 9, 8, 8, 9, 9, 9, 1, 2, 1, 3, 3, 3, 4, 4, 2, 3, 3, 5, 5,
  6, 6, 7, 7, 7, 1, 2, 3, 1, 2, 3, 3, 3, 2, 2, 2, 3, 5, 6, 7, 9, 10, 11, 12, 1,
  2, 3, 3, 3, 3, 3, 2, 2, 5, 5, 5, 6, 6, 6, 3, 5, 5, 5, 6, 6, 6, 1, 2, 2, 4, 6,
  7, 7, 5, 6, 7, 8, 8, 8, 1, 2, 2, 2, 3, 4, 6, 7, 9, 9, 9, 11, 12, 12, 13, 15,
  14, 15, 15, 18, 19, 19, 17, 18, 19, 19, 19, 20, 14, 12, 13, 15, 16, 16, 16,
  18, 18, 17, 18, 1, 2, 3, 1, 3, 3, 3, 4, 4, 4, 4, 2, 3, 3, 4, 5, 7, 7, 7, 8, 1,
  2, 1, 2, 2, 5, 5, 5, 5, 6, 4, 5, 7, 7, 6, 7, 7, 2, 2, 3, 4, 4, 6, 6, 6, 5, 1,
  1, 2, 2, 3, 3, 3, 4, 6, 5, 6, 1, 1, 2, 2, 2, 2, 3, 4, 5, 5, 7, 9, 9, 11, 11,
  11, 12, 13, 14, 8, 8, 10, 9, 11, 11, 11, 11, 12, 13, 1, 2, 2, 2, 3, 3, 3, 3,
  5, 6, 6, 1, 2, 2, 4, 4, 4, 4, 5, 5, 2, 4, 5, 6, 6, 6, 8, 8, 8, 8, 8, 8, 8, 1,
]

export const hardcodeSegmentation = {
  1: [
    1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
    1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1,
    1, 1, 1, 1, 1, 2, 1, 1, 3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 3,
    1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
    1, 1, 1, 1, 1, 1, 3, 1, 1, 1, 1, 3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 3, 1, 1,
    1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
    1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
    1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 2, 1, 1, 1,
    1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
    1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
    1, 1, 1, 1, 1, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 2, 3, 1,
  ],
  2: [
    1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 3, 1, 3, 1, 1, 1, 1, 1, 1, 1, 2, 1, 1,
    1, 1, 1, 1, 1, 1, 1, 1, 1, 3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 3,
    4, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 4, 1, 1, 1, 1, 1, 1, 1, 1, 1,
    1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 4, 1, 2, 4, 1, 1,
    1, 1, 1, 2, 1, 1, 4, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
    1, 1, 2, 1, 1, 2, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
    1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 5, 1,
    1, 1, 1, 1, 3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
    1, 1, 1, 1, 1, 1, 1, 2, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
    1, 3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 7, 1,
  ],
  3: [
    1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 5, 4, 1, 1, 1, 1, 1, 1, 3, 1, 1, 1, 1, 1,
    1, 1, 1, 2, 4, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 7, 1, 1, 1, 1, 1,
    1, 1, 1, 1, 1, 1, 1, 6, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 3,
    1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 6, 1, 6, 1, 1, 1, 1, 3, 1, 5, 1, 1, 1, 1, 1,
    1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 3, 1, 5, 1, 1, 1, 1, 1, 1, 1, 2,
    1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 4, 1, 1, 1, 1, 1, 3,
    2, 1, 6, 1, 1, 1, 1, 1, 4, 1, 1, 1, 1, 1, 1, 1, 4, 1, 1, 1, 1, 1, 1, 1, 1,
    1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 1, 1, 1, 1, 1, 1, 1, 2, 1, 1, 1, 1, 1, 1,
    1, 1, 3, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 8, 1,
  ],
  4: [
    1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 10, 1, 1, 1, 1, 1, 1, 3, 1, 1, 1, 1, 1, 1, 1,
    1, 6, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 8, 1, 1, 1, 1, 1, 1, 2, 1, 1,
    1, 7, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 4, 1, 1, 3, 2, 1, 1, 13,
    1, 1, 1, 1, 9, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 9,
    1, 1, 1, 1, 1, 1, 1, 4, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 5, 1,
    1, 1, 1, 1, 5, 7, 1, 1, 1, 1, 5, 1, 1, 1, 1, 1, 6, 1, 1, 1, 1, 1, 1, 1, 1,
    1, 1, 1, 1, 1, 3, 3, 1, 1, 1, 1, 3, 3, 1, 1, 1, 1, 3, 4, 1, 1, 1, 1, 1, 1,
    1, 2, 1, 1, 11, 1,
  ],
  5: [
    1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 10, 1, 1, 1, 1, 1, 4, 1, 1, 1, 1, 1, 1, 1, 7,
    1, 1, 1, 1, 1, 2, 1, 4, 9, 1, 1, 1, 2, 3, 1, 1, 8, 1, 1, 1, 1, 1, 1, 1, 1,
    1, 1, 1, 1, 1, 1, 1, 4, 1, 7, 14, 1, 1, 1, 10, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
    1, 1, 1, 1, 1, 1, 1, 1, 1, 9, 1, 1, 1, 1, 2, 5, 1, 1, 1, 1, 1, 1, 1, 4, 1,
    1, 1, 6, 1, 1, 1, 1, 1, 12, 1, 1, 7, 1, 1, 1, 8, 1, 1, 1, 1, 1, 1, 1, 1, 1,
    1, 1, 1, 1, 6, 1, 1, 1, 1, 6, 1, 2, 8, 1, 1, 1, 3, 3, 1, 12, 1,
  ],
  6: [
    1, 1, 1, 1, 1, 4, 11, 1, 1, 1, 1, 5, 1, 1, 1, 1, 1, 1, 8, 1, 1, 1, 1, 3, 1,
    13, 1, 1, 1, 5, 10, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 5, 1, 7, 14,
    1, 1, 1, 10, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 11, 1, 1, 1,
    8, 1, 1, 1, 1, 2, 5, 1, 1, 7, 1, 1, 1, 14, 1, 8, 1, 1, 1, 8, 1, 1, 1, 1, 1,
    1, 1, 1, 1, 1, 1, 8, 1, 1, 8, 1, 2, 8, 1, 1, 1, 6, 1, 12, 1,
  ],
  7: [
    1, 1, 1, 1, 1, 15, 1, 2, 6, 1, 1, 3, 9, 1, 1, 1, 4, 14, 1, 1, 1, 5, 10, 1,
    1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 6, 1, 7, 14, 1, 1, 11, 1, 1, 1, 1, 1, 1,
    1, 1, 1, 1, 1, 1, 1, 1, 1, 14, 1, 1, 8, 1, 2, 1, 7, 9, 1, 1, 1, 14, 1, 8, 1,
    1, 1, 8, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 18, 1, 2, 8, 1, 1, 20, 1,
  ],
  8: [
    1, 1, 1, 1, 16, 1, 8, 1, 1, 12, 1, 1, 19, 1, 1, 1, 5, 10, 1, 1, 1, 1, 1, 1,
    1, 1, 1, 1, 1, 1, 7, 1, 7, 14, 1, 1, 11, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
    1, 1, 15, 1, 9, 1, 2, 1, 7, 9, 1, 1, 1, 14, 1, 8, 1, 1, 1, 8, 1, 1, 1, 1, 1,
    1, 1, 1, 1, 1, 19, 1, 2, 8, 1, 1, 20, 1,
  ],
  9: [
    2, 18, 1, 8, 1, 1, 12, 1, 1, 19, 1, 1, 1, 5, 10, 1, 1, 1, 1, 1, 1, 1, 1, 1,
    1, 1, 1, 7, 1, 7, 14, 1, 1, 11, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 25,
    1, 2, 1, 7, 9, 1, 1, 1, 14, 1, 8, 1, 1, 1, 8, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1,
    19, 1, 2, 8, 1, 1, 20, 1,
  ],
  10: [
    2, 18, 1, 8, 1, 1, 12, 1, 1, 19, 1, 1, 1, 5, 10, 1, 1, 1, 1, 1, 3, 1, 1, 1,
    8, 1, 7, 14, 1, 1, 11, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 28, 1, 2, 1, 7, 9,
    1, 1, 1, 14, 1, 8, 1, 1, 1, 8, 1, 1, 1, 1, 1, 1, 1, 1, 1, 20, 1, 2, 8, 1, 1,
    20, 1,
  ],
  11: [
    2, 18, 1, 8, 1, 1, 12, 1, 1, 19, 1, 1, 1, 5, 10, 1, 2, 1, 6, 9, 1, 7, 14, 1,
    1, 11, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 28, 1, 2, 1, 7, 9, 1, 1, 1, 14, 1,
    8, 1, 1, 1, 8, 1, 1, 1, 1, 1, 1, 1, 22, 1, 2, 8, 1, 1, 20, 1,
  ],
  12: [
    2, 18, 1, 8, 1, 1, 12, 1, 1, 19, 1, 1, 1, 5, 10, 1, 2, 1, 6, 9, 1, 7, 14, 1,
    1, 11, 1, 1, 1, 1, 1, 1, 1, 1, 2, 29, 1, 2, 1, 7, 9, 1, 1, 1, 14, 1, 8, 1,
    1, 1, 8, 1, 1, 1, 1, 1, 1, 23, 1, 2, 8, 1, 1, 20, 1,
  ],
  13: [
    2, 18, 1, 8, 1, 1, 12, 1, 1, 19, 1, 1, 1, 5, 10, 1, 2, 1, 6, 9, 1, 7, 14, 1,
    1, 11, 1, 1, 1, 1, 1, 1, 1, 1, 31, 1, 2, 1, 7, 9, 1, 1, 1, 14, 1, 8, 1, 1,
    1, 8, 1, 1, 1, 3, 23, 1, 2, 8, 1, 1, 20, 1,
  ],
  14: [
    2, 18, 1, 8, 1, 1, 12, 1, 1, 19, 1, 1, 1, 5, 10, 1, 2, 1, 6, 9, 1, 7, 14, 1,
    1, 11, 1, 1, 1, 1, 1, 1, 1, 32, 1, 2, 1, 7, 9, 1, 1, 1, 14, 1, 8, 1, 1, 1,
    8, 1, 1, 1, 3, 23, 1, 2, 8, 1, 1, 20, 1,
  ],
  15: [
    2, 18, 1, 8, 1, 1, 12, 1, 1, 19, 1, 1, 1, 5, 10, 1, 2, 1, 6, 9, 1, 7, 14, 1,
    1, 11, 1, 1, 1, 1, 1, 1, 33, 1, 2, 1, 7, 9, 1, 1, 1, 14, 1, 8, 1, 1, 1, 8,
    1, 1, 1, 3, 23, 1, 2, 8, 1, 1, 20, 1,
  ],
  16: [
    2, 18, 1, 8, 1, 1, 12, 1, 1, 19, 1, 1, 1, 5, 10, 1, 2, 1, 6, 9, 1, 7, 14, 1,
    1, 11, 1, 1, 1, 1, 1, 1, 33, 1, 2, 1, 7, 9, 1, 1, 1, 14, 1, 8, 1, 1, 1, 8,
    1, 1, 1, 3, 23, 1, 2, 8, 1, 1, 20, 1,
  ],
  17: [
    2, 18, 1, 8, 1, 1, 12, 1, 1, 19, 1, 1, 1, 5, 10, 1, 2, 1, 6, 9, 1, 7, 14, 1,
    1, 11, 1, 1, 1, 1, 1, 34, 1, 2, 1, 7, 9, 1, 1, 1, 14, 1, 8, 1, 1, 1, 8, 1,
    1, 1, 3, 23, 1, 2, 8, 1, 1, 20, 1,
  ],
  18: [
    2, 18, 1, 8, 1, 1, 12, 1, 1, 19, 1, 1, 1, 5, 10, 1, 2, 1, 6, 9, 1, 7, 14, 1,
    1, 11, 1, 1, 1, 1, 35, 1, 2, 1, 7, 9, 1, 1, 1, 14, 1, 8, 1, 1, 1, 8, 1, 1,
    1, 3, 23, 1, 2, 8, 1, 1, 20, 1,
  ],
  19: [
    2, 18, 1, 8, 1, 1, 12, 1, 1, 19, 1, 1, 1, 5, 10, 1, 2, 1, 6, 9, 1, 7, 14, 1,
    1, 11, 1, 2, 36, 1, 2, 1, 7, 9, 1, 1, 1, 14, 1, 8, 1, 1, 1, 8, 1, 1, 1, 3,
    23, 1, 2, 8, 1, 1, 20, 1,
  ],
  20: [21, 23, 21, 18, 19, 22, 13, 39, 20, 26, 11, 29, 11, 22],
  21: [44, 21, 18, 19, 22, 13, 39, 20, 26, 11, 29, 11, 22],
  22: [65, 18, 19, 22, 13, 39, 20, 26, 11, 29, 11, 22],
  23: [83, 19, 22, 13, 39, 20, 26, 11, 29, 11, 22],
  24: [102, 22, 13, 39, 20, 26, 11, 29, 11, 22],
  25: [124, 13, 39, 20, 26, 11, 29, 11, 22],
  26: [137, 39, 20, 26, 11, 29, 11, 22],
  27: [176, 20, 26, 11, 29, 11, 22],
  28: [196, 26, 11, 29, 11, 22],
  29: [222, 11, 29, 11, 22],
  30: [233, 29, 11, 22],
  31: [262, 11, 22],
  32: [273, 22],
  33: [295],
}
